export const gene2pheno_disease = ["ADENOMATOUS POLYPOSIS COLI",
    "ATAXIA-TELANGIECTASIA",
    "TUMOR PREDISPOSITION SYNDROME",
    "JUVENILE POLYPOSIS SYNDROME, INFANTILE FORM",
    "BRCA1 related CANCER",
    "BRCA2 associated CANCER",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP J",
    "GASTRIC CANCER, FAMILIAL DIFFUSE, WITH OR WITHOUT CLEFT LIP AND/OR PALATE",
    "MELANOMA, CUTANEOUS MALIGNANT, 3",
    "MELANOMA, CUTANEOUS MALIGNANT, 2",
    "LEUKEMIA, ACUTE MYELOID",
    "CHEK2 related CANCER",
    "CYLINDROMATOSIS, FAMILIAL",
    "XERODERMA PIGMENTOSUM, GROUP E, DDB-NEGATIVE SUBTYPE",
    "COLORECTAL CANCER, HEREDITARY NONPOLYPOSIS, TYPE 8",
    "XERODERMA PIGMENTOSUM, GROUP D",
    "ERCC3-related xeroderma pigmentosum, group B",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP Q",
    "ERCC5-related xeroderma pigmentosum, group G",
    "EXT1-related multiple exostoses",
    "EXOSTOSES, MULTIPLE, TYPE 2",
    "LEIOMYOMATOSIS AND RENAL CELL CANCER",
    "BIRT-HOGG-DUBE SYNDROME",
    "EMBERGER SYNDROME",
    "MULTIPLE ENDOCRINE NEOPLASIA 1",
    "RENAL CELL CARCINOMA, PAPILLARY, 1",
    "MLH1-related constitutional mismatch repair deficiency syndrome (CMMRD)",
    "ADENOMAS, MULTIPLE COLORECTAL",
    "NF1-related neurofibromatosis",
    "SCHWANNOMATOSIS",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP N",
    "PALB2 related CANCER",
    "PMS2-related Lynch syndrome",
    "CARNEY COMPLEX, TYPE 1",
    "PTCH1-related Gorlin syndrome (basal cell nevus syndrome)",
    "PTEN-related hamartoma tumour syndrome (Cowden syndrome)",
    "RETINOBLASTOMA",
    "MEDULLARY THYROID CARCINOMA",
    "RET-related multiple endocrine neoplasia (MEN2)",
    "MULTIPLE ENDOCRINE NEOPLASIA IIA",
    "RHBDF2-related tylosis with esophageal cancer",
    "PLATELET DISORDER, FAMILIAL, WITH ASSOCIATED MYELOID MALIGNANCY",
    "PARAGANGLIOMAS 2",
    "GASTROINTESTINAL STROMAL TUMOR",
    "PARAGANGLIOMA AND GASTRIC STROMAL SARCOMA",
    "PARAGANGLIOMAS 3",
    "PARAGANGLIOMAS 1, WITH OR WITHOUT DEAFNESS",
    "LI-FRAUMENI SYNDROME",
    "TSC2-related tuberous sclerosis",
    "VON HIPPEL-LINDAU SYNDROME",
    "XERODERMA PIGMENTOSUM, GROUP A",
    "XERODERMA PIGMENTOSUM, GROUP C",
    "SMAD4-related juvenile polyposis/hereditary hemorrhagic telangiectasia syndrome",
    "NEUROBLASTOMA WITH HIRSCHSPRUNG DISEASE",
    "HYPERPARATHYROIDISM-JAW TUMOR SYNDROME",
    "PHEOCHROMOCYTOMA, SUSCEPTIBILITY TO",
    "MEDULLOBLASTOMA, ASSOCIATED WITH GORLIN SYNDROME",
    "KIT-related familial gastro-intestinal stromal tumours",
    "HEREDITARY MIXED POLYPOSIS",
    "MSH2-related constitutional mismatch repair deficiency syndrome (CMMRD)",
    "PMS2-related constitutional mismatch repair deficiency syndrome (CMMRD)",
    "CONSTITUTIONAL MISMATCH REPAIR DEFICIENCY SYNDROME",
    "POLYMERASE PROOFREADING-ASSOCIATED POLYPOSIS",
    "ADENOMATOUS POLYPOSIS, CRC,  BREAST CANCER AND OTHER TUMOURS",
    "PARAGANGLIOMAS",
    "FAMILIAL WILMS TUMOUR",
    "Lynch syndrome",
    "Autoimmune lymphoproliferative syndrome",
    "Multiple endocrine neoplasia, type IV",
    "ELANE-Related Neutropenia",
    "Lymphoproliferative syndrome, X-linked",
    "Melanoma, cutaneous malignant",
    "Wilms tumour",
    "Meningioma, familial",
    "Cowden syndrome",
    "Breast cancer, susceptibility to",
    "Paget disease of bone",
    "Dyskeratosis congenita, autosomal dominant",
    "Lymphoproliferative syndrome",
    "RTEL1-related dyskeratosis congenita",
    "Dyskeratosis Congenita",
    "Myeloproliferative/lymphoproliferative neoplasms, familial (multiple types), susceptibility to",
    "Diaphyseal medullary stenosis with malignant fibrous histiocytoma",
    "Neuroblastoma, susceptibility to",
    "Nonsmall cell lung cancer, susceptibility to",
    "Pituitary adenoma predisposition",
    "RAD51C related cancer",
    "PEUTZ-JEGHERS SYNDROME",
    "DKC1-related dyskeratosis congenita",
    "NOP10-related dyskeratosis congenita",
    "SMARCA4-related rhabdoid tumor predisposition syndrome",
    "POLH-related xeroderma pigmentosum, variant type",
    "TERC-related dyskeratosis congenita",
    "Myofibromatosis, infantile",
    "NHP2-related dyskeratosis congenita",
    "Hyper-IgE recurrent infection syndrome, autosomal recessive",
    "WRAP53-related dyskeratosis congenita",
    "PARN-related dyskeratosis congenita",
    "Gastrointestinal stromal tumor/GIST-plus syndrome, somatic or familial",
    "TGFBR1-related multiple self-healing squamous epithelioma",
    "RAD51D related cancer",
    "TSC1-related tuberous sclerosis",
    "DICER1 Tumor Predisposition",
    "ATM-related cancer",
    "PTPN13 related predisposition to bone marrow failure",
    "MBD4 multi-tumour predisposition syndrome",
    "GIP-dependent primary bilateral macronodular adrenal hyperplasia with Cushing's syndrome",
    "Predisposition to ependymoma",
    "Bazex-Dupre-Christol basal cell carcinoma susceptibility syndrome",
    "CHEK2-related cancer predisposition",
    "NPAT-related cancer",
    "DSC2-related ARVC",
    "DSG2-related ARVC",
    "DSP-related ARVC",
    "PKP2-related  ARVC",
    "TMEM43-related  ARVC",
    "JUP-related Naxos disease",
    "CALM1-related CPVT",
    "CALM2-related CPVT",
    "CALM3-related CPVT",
    "TECRL-related CPVT",
    "TRDN-related CPVT",
    "SCN5A-related BrS",
    "CASQ2-related CPVT",
    "KCNH2-related SQTS",
    "KCNJ2 relared SQTS",
    "KCNQ1-related SQTS",
    "SLC4A3-related SQTS",
    "BAG3-related DCM",
    "DES-related DCM",
    "FLNC-related DCM",
    "LMNA-related DCM",
    "MYH7-related DCM",
    "PLN-related Intrinsic Cardiomyopathy",
    "RBM20-related DCM",
    "TNNC1-related DCM",
    "TNNT2-related DCM",
    "TTN-related DCM",
    "ACTC1-related HCM",
    "MYBPC3-related HCM",
    "MYL2-related HCM",
    "MYL3-related HCM",
    "TNNI3-related HCM",
    "TPM1-related HCM",
    "KCNH2-related LQTS",
    "KCNQ1-related LQTS",
    "SCN5A-related LQTS",
    "TRDN-related LQTS",
    "ALPK3-related HCM",
    "DES-related Myofibrillar myopathy",
    "FHL1-related Emery-related Dreifuss MD",
    "FLNC-related Myofibrillar myopathy",
    "GLA-related Fabry disease",
    "LAMP2-related Danon disease",
    "PRKAG2-related cardiomyopathy",
    "KCNQ1-related JLNS",
    "SLC22A5-related primary systemic carnitine deficiency",
    "MYH7-related HCM",
    "CALM1-related LQTS",
    "CALM2-related LQTS",
    "CALM3-related LQTS",
    "TNNT2-related HCM",
    "KCNJ2-related Andersen-related Tawil syndrome",
    "CACNA1C-related Timothy syndrome",
    "PTPN11-related Noonan syndrome",
    "RAF1-related Noonan syndrome",
    "RIT1-related Noonan syndrome",
    "RYR2-related CPVT",
    "PTPN11-related NSML syndrome",
    "ABCC9-related Cantu Syndrome",
    "CRYAB-related Alpha-related B crystallinpathy",
    "FXN-related Friedreich ataxia",
    "GAA-related Pompe disease",
    "MYO6-related nonsyndromic genetic hearing loss with LVH",
    "SLC25A4-related Mitochondrial disease",
    "BAG3-related Myofibrillar myopathy",
    "DSP-related DCM",
    "SCN5A-related DCM",
    "TTR-related hereditary ATTR amyloidosis",
    "JERVELL AND LANGE-NIELSEN SYNDROME TYPE 2",
    "OCULOAURICULAR SYNDROME",
    "FANCONI ANEMIA COMPLEMENTATION GROUP P",
    "ARGININEMIA",
    "SECKEL SYNDROME TYPE 1",
    "FANCB-related Fanconi anemia",
    "ALG9-CDG",
    "CONGENITAL INSENSITIVITY TO PAIN WITH ANHIDROSIS",
    "COLOBOMA, OCULAR, WITH OR WITHOUT HEARING IMPAIRMENT, CLEFT LIP/PALATE, AND/OR INTELLECTUAL DEVELOPMENTAL DISORDER",
    "BARDET-BIEDL SYNDROME TYPE 9",
    "BARDET-BIEDL SYNDROME TYPE 11",
    "PAX2-related papillorenal syndrome",
    "FGFR3-related lacrimo-auriculo-dento-digital syndrome",
    "DYSCHROMATOSIS SYMMETRICA HEREDITARIA 1",
    "HYPOGONADOTROPIC HYPOGONADISM WITH OR WITHOUT ANOSMIA",
    "SPONDYLOCARPOTARSAL SYNOSTOSIS SYNDROME",
    "NONPECIFIC SEVERE ID",
    "CONGENITAL DISORDERS OF GLYCOSYLATION",
    "AGPS-related rhizomelic chondrodysplasia punctata",
    "ORAL-FACIAL-DIGITAL SYNDROME TYPE 1",
    "LISSENCEPHALY TYPE 1",
    "COL1A1-RELATED OSTEOGENESIS IMPERFECTA",
    "CAMTA1-related cerebellar dysfunction with variable cognitive and behavioral abnormalities",
    "SPONDYLOEPIPHYSEAL DYSPLASIA WITH CONGENITAL JOINT DISLOCATIONS",
    "COSTELLO SYNDROME",
    "LEBER CONGENITAL AMAUROSIS 6",
    "POPLITEAL PTERYGIUM SYNDROME, LETHAL TYPE",
    "ULNAR-MAMMARY SYNDROME",
    "LAMA1-related cerebellar dysplasia with cysts with or without retinal dystrophy",
    "AUTOSOMAL RECESSIVE INTELLECTUAL DEVELOPMENTAL DISORDER",
    "PROPIONIC ACIDEMIA",
    "COG7-CDG",
    "NONSPECIFIC SEVERE ID",
    "RETT SYNDROME (RTT)",
    "HEREDITARY HYPERFERRITINEMIA-CATARACT SYNDROME",
    "NOONAN SYNDROME-LIKE DISORDER WITH OR WITHOUT JUVENILE MEYLOMONOCYTIC LEUKEMIA",
    "KNIEST DYSPLASIA",
    "LOEYS-DIETZ SYNDROME",
    "HYPERPHOSPHATASIA WITH INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME 2",
    "HALLERMANN-STREIFF SYNDROME",
    "PLK4-related microcephaly, growth failure and retinopathy",
    "ARYLSULFATASE A DEFICIENCY",
    "CLN3-related neuronal ceroid lipofuscinosis",
    "LRP5-related osteopetrosis",
    "SPEECH-LANGUAGE DISORDER 1",
    "ADAMS-OLIVER SYNDROME 2",
    "PARKINSONISM-DYSTONIA, INFANTILE",
    "CHAMP1-related neurodevelopmental disorder",
    "CONGENITAL PRIMARY APHAKIA",
    "CLEFT LIP +/- CLEFT PALATE",
    "CLN8-related neuronal ceroid lipofuscinosis",
    "MCKUSICK-KAUFMAN SYNDROME",
    "NEPHROTIC SYNDROME TYPE 1",
    "SPONDYLOEPIPHYSEAL DYSPLASIA TYPE KIMBERLEY",
    "EXTREME MYOPIA;MYOPIA 23, AUTOSOMAL RECESSIVE",
    "EPILEPTIC ENCEPHALOPATHY",
    "KANZAKI DISEASE",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 12",
    "HEMOLYTIC ANEMIA DUE TO UMPH1 DEFICIENCY",
    "SLC4A11-related corneal endothelial dystrophy with or without deafness",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED ARX-RELATED",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 1",
    "MICROPHTHALMIA WITH CATARACTS AND IRIS ABNORMALITIES",
    "CK SYNDROME",
    "MYASTHENIC SYNDROME, CONGENITAL, WITH TUBULAR AGGREGATES 2",
    "NEMALINE MYOPATHY 6",
    "PIERRE ROBIN SEQUENCE",
    "OSTEOPATHIA STRIATA WITH CRANIAL SCLEROSIS",
    "AURICULOCONDYLAR SYNDROME",
    "NEPHRONOPHTHISIS 9",
    "SPONDYLOEPIPHYSEAL DYSPLASIA TARDA",
    "PURE HAIR AND NAIL ECTODERMAL DYSPLASIA",
    "MEIER-GORLIN SYNDROME 5",
    "IFT140-related short-rib thoracic dysplasia with or without polydactyly",
    "HYPERPHOSPHATASIA WITH INTELLECTUAL DEVELOPMENTAL DISORDER",
    "Schaaf-Yang syndrome",
    "TUBULAR-AGGREGATE MYOPATHY",
    "SLC2A1-related glucose transporter type 1 deficiency syndrome",
    "ABLEPHARON MACROSTOMIA SYNDROME",
    "ECTODERMAL DYSPLASIA/SHORT STATURE SYNDROME",
    "3-HYDROXYACYL-COENZYME A DEHYDROGENASE DEFICIENCY",
    "ACROMESOMELIC CHONDRODYSPLASIA GREBE TYPE",
    "ORNITHINE TRANSCARBAMYLASE DEFICIENCY",
    "INHERITED SKIN FRAGILITY",
    "CORNEAL DYSTROPHY FUCHS ENDOTHELIAL TYPE 6",
    "CATARACT, COPPOCK-LIKE",
    "GROWTH HORMONE INSENSITIVITY WITH IMMUNODEFICIENCY",
    "TOWNES-BROCKS SYNDROME",
    "RETINITIS PIGMENTOSA 57",
    "RENAL-HEPATIC-PANCREATIC DYSPLASIA 2",
    "HEMORRHAGIC DESTRUCTION OF THE BRAIN, SUBEPENDYMAL CALCIFICATION, AND CATARACTS",
    "CONGENITAL CONTRACTURES OF THE LIMBS AND FACE, HYPOTONIA, AND DEVELOPMENTAL DELAY",
    "ALOPECIA AND T-CELL IMMUNODEFICIENCY",
    "BARDET-BIEDL SYNDROME TYPE 10",
    "INFANTILE HYPERTROPHIC CARDIOMYOPATHY AND LACTIC ACIDOSIS",
    "GROWTH RETARDATION DEVELOPMENTAL DELAY COARSE FACIES AND EARLY DEATH",
    "XYLT1-related Desbuquois dysplasia",
    "MULTIPLE PTERYGIUM SYNDROME ESCOBAR VARIANT",
    "TEMTAMY PREAXIAL BRACHYDACTYLY SYNDROME",
    "GOLDBERG-SHPRINTZEN MEGACOLON SYNDROME",
    "IFT172-related short-rib thoracic dysplasia with or without polydactyly",
    "INPP5E-related intellectual development disorder, truncal obesity, retinal dystrophy, and micropenis",
    "SINOATRIAL NODE DYSFUNCTION AND DEAFNESS",
    "ATRIOVENTRICULAR SEPTAL DEFECT 5",
    "HYPERIMMUNOGLOBULIN E RECURRENT INFECTION SYNDROME AUTOSOMAL RECESSIVE",
    "HEREDITARY FOLATE MALABSORPTION",
    "DYSTROPHIA MYOTONICA TYPE 1",
    "ASPARTYLGLUCOSAMINURIA",
    "EXFOLIATIVE ICHTHYOSIS, AUTOSOMAL RECESSIVE, ICHTHYOSIS BULLOSA OF SIEMENS-LIKE",
    "ANEMIA, SIDEROBLASTIC, PYRIDOXINE-REFRACTORY, AUTOSOMAL RECESSIVE",
    "AUTOSOMAL RECESSIVE OTOSPONDYLOMEGAEPIPHYSEAL DYSPLASIA",
    "SPLIT HAND AND FOOT MALFORMATION",
    "BRCA1-related Fanconi anaemia",
    "ARTERIAL CALCIFICATION, GENERALIZED, OF INFANCY, 2",
    "FRAGILE X-E INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME",
    "COMBINED OXIDATIVE PHOSPHORYLATION DEFICIENCY 5",
    "BOSLEY-SALIH-ALORAINY SYNDROME",
    "GPSM2-related sensorineural hearing loss with corpus callosum hypoplasia, gray matter heterotopia and arachnoid cysts",
    "BARAITSER-WINTER SYNDROME",
    "PXDN-related anterior segment dysgenesis with sclerocornea",
    "CHONDRODYSPLASIA PUNCTATA 2, X-LINKED",
    "PRIMARY ALDOSTERONISM, SEIZURES, AND NEUROLOGIC ABNORMALITIES",
    "NAKAJO SYNDROME",
    "HYPOTONIA, INFANTILE, WITH PSYCHOMOTOR RETARDATION AND CHARACTERISTIC FACIES",
    "OCCIPITAL CORTICAL MALFORMATIONS",
    "PRIMORDIAL DWARFISM",
    "METHIONINE ADENOSYLTRANSFERASE DEFICIENCY",
    "CONGENITAL INABILITY TO EXPERIENCE PAIN",
    "COL9A1-related Stickler syndrome",
    "ATRIAL SEPTAL DEFECT WITH ATRIOVENTRICULAR CONDUCTION DEFECTS",
    "PITT-HOPKINS SYNDROME",
    "COMBINED OXIDATIVE PHOSPHORYLATION DEFICIENCY 1",
    "POLYMICROGYRIA WITH OPTIC NERVE HYPOPLASIA",
    "CHROMOSOME 11P15.5-RELATED RUSSELL-SILVER SYNDROME",
    "CROUZON SYNDROME",
    "BARDET-BIEDL SYNDROME TYPE 4",
    "AMELOGENESIS IMPERFECTA",
    "MICROCEPHALIC OSTEODYSPLASTIC PRIMORDIAL DWARFISM, TYPE II",
    "MOSAIC VARIEGATED ANEUPLOIDY SYNDROME 1",
    "BRANCHIOOTORENAL SYNDROME TYPE 1",
    "N-ACETYLGLUTAMATE SYNTHASE DEFICIENCY",
    "CEDNIK SYNDROME",
    "22Q11.2 DELETION SYNDROME",
    "HYPERORNITHINEMIA-HYPERAMMONEMIA-HOMOCITRULLINURIA SYNDROME",
    "GLYCOGEN STORAGE DISEASE TYPE VI",
    "LETHAL NEONATAL RIGIDITY AND SEIZURE SYNDROME",
    "SPINAL MUSCULAR ATROPHY, DISTAL, X-LINKED 3",
    "CONGENITAL DISORDER OF GLYCOSYLATION TYPE 1N",
    "SPASTIC PARAPLEGIA 9, AUTOSOMAL DOMINANT",
    "CUTIS LAXA, AUTOSOMAL RECESSIVE, TYPE IIB",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 41",
    "COENZYME Q10 DEFICIENCY",
    "GLDC-RELATED GLYCINE ENCEPHALOPATHY",
    "Intellectual disability with autism spectrum disorder",
    "JOUBERT SYNDROME AND RELATED DISORDERS",
    "ACHONDROGENESIS TYPE 2",
    "PLEC-related epidermolysis bullosa simplex and limb-girdle muscular dystrophy",
    "RENAL TUBULAR ACIDOSIS, DISTAL, AD",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP C",
    "CORTICAL DYSPLASIA-FOCAL EPILEPSY SYNDROME",
    "COFFIN SIRIS",
    "ATAXIA TELANGIECTASIA-LIKE DISORDER",
    "MUENKE SYNDROME",
    "SHORT SYNDROME",
    "COHEN SYNDROME",
    "NIEMANN-PICK DISEASE TYPE A",
    "SERKAL SYNDROME",
    "HYPERINSULINISM-HYPERAMMONEMIA SYNDROME",
    "RENAL TUBULAR ACIDOSIS, DISTAL, AR",
    "LONG CHAIN 3-HYDROXYACYL-COA DEHYDROGENASE DEFICIENCY",
    "TERMINAL OSSEOUS DYSPLASIA",
    "HEREDITARY SPASTIC PARAPLEGIA",
    "BROWN-VIALETTO-VAN LAERE SYNDROME",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED TURNER TYPE",
    "SPINAL MUSCULAR ATROPHY, LOWER EXTREMITY-PREDOMINANT, AD",
    "MYOPATHY, EARLY-ONSET, AREFLEXIA, RESPIRATORY DISTRESS, AND DYSPHAGIA",
    "POLYMICROGYRIA",
    "TRICHOTHIODYSTROPHY NON-PHOTOSENSITIVE TYPE 1",
    "HYDROCEPHALUS DUE TO STENOSIS OF THE AQUEDUCT OF SYLVIUS",
    "DENYS-DRASH SYNDROME",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA WITH JOINT LAXITY TYPE 1",
    "MEGALOCORNEA, X-LINKED",
    "AUTOSOMAL-DOMINANT ROBINOW SYNDROME",
    "CONGENITAL ANOMALIES OF KIDNEY AND URINARY TRACT, CAKUT1",
    "CONGENITAL AND JUVENILE CATARACT",
    "ALG8-CDG",
    "3MC SYNDROME 1",
    "ROBINOW SYNDROME, AUTOSOMAL RECESSIVE 1",
    "SPINOCEREBELLAR ATAXIA TYPE 13",
    "NORRIE DISEASE",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL DOMINANT 32",
    "MICROPHTHALMIA SYNDROMIC TYPE 2",
    "CORNELIA DE LANGE-LIKE SYNDROME HDAC8 XLR",
    "COENZYME Q10 DEFICIENCY, PRIMARY, 2",
    "FRASER SYNDROME",
    "ALG1-CDG",
    "SYNDROMIC INTELLECTUAL DISABILITY",
    "PONTOCEREBELLAR HYPOPLASIA TYPE 6",
    "SUBCUTANEOUS LIPODYSTROPHY, DEAFNESS, MANDIBULAR HYPOPLASIA AND MALE HYPOGONADISM ",
    "LRAT-related Leber congenital amaurosis",
    "KARS1-related leukoencephalopathy with or without deafness",
    "CONGENITAL DISORDER OF GLYCOSYLATION TYPE 2C",
    "GLASS SYNDROME",
    "MICROPHTHALMIA SYNDROMIC TYPE 8",
    "MITOCHONDRIAL RESPIRATORY CHAIN COMPLEX I DEFICIENCY",
    "PRIMARY MICROCEPHALY",
    "HYPOKALEMIC PERIODIC PARALYSIS",
    "KRIT1-related cerebral cavernous malformation (CCM)",
    "ALG11-CDG",
    "SEPTOOPTIC DYSPLASIA",
    "SPONDYLOCOSTAL DYSOSTOSIS TYPE 1",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP F",
    "FUMARASE DEFICIENCY",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY CONGENITAL WITH BRAIN AND EYE ANOMALIES TYPE A3 (MDDGA3)",
    "DEAFNESS AUTOSOMAL RECESSIVE TYPE 2",
    "CLEIDOCRANIAL DYSPLASIA",
    "CRYGC-related congenital cataract",
    "LOWE OCULOCEREBRORENAL SYNDROME",
    "MARTINEZ-FRIAS SYNDROME",
    "LEIGH SYNDROME, FRENCH-CANADIAN TYPE",
    "INFANTILE STRIATONIGRAL DEGENERATION",
    "ACROMESOMELIC DYSPLASIA MAROTEAUX TYPE",
    "MITOCHONDRIAL COMPLEX IV DEFICIENCY",
    "FLOATING-HARBOR SYNDROME",
    "NEURODEGENERATION WITH BRAIN IRON ACCUMULATION",
    "NEPHRONOPHTHISIS TYPE 4",
    "AGNATHIA-OTOCEPHALY COMPLEX monoallelic",
    "ACROFACIAL DYSOSTOSIS WEYERS TYPE",
    "SCN1A-RELATED SEIZURE DISORDERS",
    "MULTIPLE EPIPHYSEAL DYSPLASIA TYPE 6",
    "SPASTIC PARAPLEGIA AUTOSOMAL RECESSIVE TYPE 15",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL DOMINANT 24",
    "CRANIOECTODERMAL DYSPLASIA 2",
    "SCAPER-related neurodevelopmental disorder and retinitis pigmentosa",
    "ELN-RELATED CUTIS LAXA",
    "AICARDI-GOUTIERES SYNDROME 4",
    "ERYTHROKERATODERMIA VARIABILIS ET PROGRESSIVA",
    "CEREBRAL PALSY SPASTIC QUADRIPLEGIC TYPE 3",
    "CONGENITAL HEART DEFECTS and XX sex reversal",
    "TEMTAMY SYNDROME; COLOBOMA, HYPOPLASTIC CORPUS CALLOSUM AND INTELLECTUAL DISABILITY",
    "RHABDOID PREDISPOSITION SYNDROME 1",
    "MOLYBDENUM COFACTOR DEFICIENCY",
    "PYRUVATE DEHYDROGENASE E2 DEFICIENCY",
    "FRANK-TER HAAR SYNDROME",
    "MELNICK-NEEDLES SYNDROME",
    "NR2F1-related Bosch-Boonstra-Schaaf optic atrophy syndrome",
    "KAT6B-related Say-Barber-Biesecker-Young-Simpson syndrome",
    "GREIG CEPHALOPOLYSYNDACTYLY SYNDROME",
    "NEUROPATHY, HEREDITARY SENSORY AND AUTONOMIC, TYPE IIB",
    "LETHAL CONGENITAL CONTRACTURE SYNDROME TYPE 3",
    "NON-PHENYLKETONURIA HYPERPHENYLALANINEMIA",
    "PITUITARY DWARFISM II",
    "COENZYME Q10 DEFICIENCY, PRIMARY, 7",
    "TOOTH AGENESIS, SELECTIVE, 3",
    "EMERY-DREIFUSS MUSCULAR DYSTROPHY 6, X-LINKED",
    "DEAFNESS AUTOSOMAL RECESSIVE TYPE 12",
    "TRPM1-related night blindness, congenital stationary",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 13",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 59",
    "ICHTHYOSIS, X-LINKED",
    "HYPOPHOSPHATASIA",
    "GLI2-RELATED HOLOPROSENCEPHALY",
    "ASAH1-related Farber lipogranulomatosis",
    "METHYLMALONIC ACIDURIA TYPE CBLA",
    "AUTOSOMAL DOMINANT LARSEN SYNDROME",
    "INTELLECTUAL DISABILITY",
    "STRA6-related syndromic microphthalmia",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED ZNF711-RELATED",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 1",
    "FKRP-related congenital alpha-dystroglycanopathy with brain and eye anomalies",
    "HCCS-related linear skin defects with microphthalmia",
    "MICROCEPHALY CAPILLARY MALFORMATION (MIC-CAP) SYNDROME",
    "SPONDYLO-MEGAEPIPHYSEAL-METAPHYSEAL DYSPLASIA",
    "AUTOSOMAL- RECESSIVE INTELLECTUAL DISABILITY MRT5",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 9",
    "AUTOIMMUNE DISEASE, SYNDROMIC MULTISYSTEM",
    "CONGENITAL DISORDER OF GLYCOSYLATION TYPE 1O",
    "AROMATIC L-AMINO-ACID DECARBOXYLASE DEFICIENCY",
    "MULTIPLE MITOCHONDRIAL DYSFUNCTIONS SYNDROME 1",
    "FAMILIAL FOCAL EPILEPSY WITH VARIABLE FOCI",
    "CLOVES: CONGENITAL LIPOMATOUS OVERGROWTH, VASCULAR MALFORMATIONS, AND EPIDERMAL NEVI",
    "INPP5E-related Joubert syndrome",
    "POSTAXIAL ACROFACIAL DYSOSTOSIS",
    "CHARCOT-MARIE-TOOTH DISEASE X-LINKED RECESSIVE TYPE 5",
    "HYPOPHOSPHATEMIC RICKETS, AR",
    "MICROPHTHALMIA ISOLATED TYPE 3",
    "AMISH LETHAL MICROCEPHALY",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY (CONGENITAL WITH BRAIN AND EYE ANOMALIES), TYPE A, 11",
    "ADAMS-OLIVER SYNDROME 1",
    "BARDET-BIEDL SYNDROME TYPE 5",
    "HYDROCEPHALUS, NONSYNDROMIC, AUTOSOMAL RECESSIVE 2",
    "2-AMINOADIPIC AND 2-OXOADIPIC ACIDURIA",
    "MICROPHTHALMIA, ISOLATED, WITH COLOBOMA 7",
    "EPILEPSY WITH MYOCLONIC-ATONIC SEIZURES",
    "LEUKODYSTROPHY HYPOMYELINATING TYPE 4",
    "GUANIDINOACETATE METHYLTRANSFERASE DEFICIENCY",
    "ARTERIAL TORTUOSITY SYNDROME",
    "X-LINKED CONGENITAL IDIOPATHIC INTESTINAL PSEUDOOBSTRUCTION",
    "CFC1-RELATED CONOTRUNCAL HEART MALFORMATIONS",
    "LYSYL HYDROXYLASE 3 DEFICIENCY",
    "ARID1B-related Coffin-Siris Syndrome",
    "MOEBIUS SYNDROME",
    "AUTOINFLAMMATION, ANTIBODY DEFICIENCY, AND IMMUNE DYSREGULATION, PLCG2-ASSOCIATED",
    "NEURAL TUBE DEFECT",
    "PONTOCEREBELLAR HYPOPLASIA TYPE 1",
    "APERT SYNDROME",
    "SPINOCEREBELLAR ATAXIA, AUTOSOMAL RECESSIVE 12",
    "GLYCOGEN STORAGE DISEASE TYPE III",
    "TRPS1-related trichorhinopharangeal syndrome",
    "NEMALINE MYOPATHY 8, AUTOSOMAL RECESSIVE",
    "CONGENITAL DISORDER OF GLYCOSYLATION TYPE 2A",
    "SOX11-related neurodevelopmental disorder",
    "PARKINSON DISEASE 9",
    "LISSENCEPHALY 2",
    "GALACTOSEMIA",
    "CRIGLER-NAJJAR SYNDROME, TYPE I",
    "CHEDIAK-HIGASHI SYNDROME",
    "MOWAT-WILSON SYNDROME",
    "TTC8-related retinitis pigmentosa",
    "ACRODYSOSTOSIS",
    "CRANIOECTODERMAL DYSPLASIA TYPE 3",
    "PROLIFERATIVE VASCULOPATHY AND HYDRAENCEPHALY-HYDROCEPHALY SYNDROME",
    "GAPO SYNDROME",
    "DENT DISEASE TYPE 2",
    "NEPHROTIC SYNDROME, TYPE 2",
    "Kleefstra syndrome",
    "MEIER-GORLIN SYNDROME 4",
    "Autosomal recessive titinopathy with arthrogryposis and/or myopathy ",
    "SYNPOLYDACTYLY, 3/3-PRIME/4, ASSOCIATED WITH METACARPAL AND METATARSAL SYNOSTOSES",
    "ATHELIA",
    "EPILEPTIC ENCEPHALOPATHY WITH SEIZURE ONSET IN THE FIRST DAYS OF LIFE",
    "LYSOSOMAL BETA-MANNOSIDOSIS",
    "LENZ-MAJEWSKI HYPEROSTOTIC DWARFISM",
    "ANONYCHIA CONGENITA",
    "CARNITINE-ACYLCARNITINE TRANSLOCASE DEFICIENCY",
    "SPLIT-HAND/FOOT MALFORMATION TYPE 6",
    "PEX1-related peroxisome biogenesis disorder",
    "AICARDI-GOUTIERES SYNDROME 1, DOMINANT AND RECESSIVE",
    "EPILEPTIC ENCEPHALOPATHY Loss-of-function",
    "COHESINOPATHY",
    "INFANTILE ENCEPHALOPATHY WITH EPILEPSY AND DYSMORPHIC CORPUS CALLOSUM",
    "HAWKINSINURIA",
    "GNPAT-related rhizomelic chondrodysplasia punctata",
    "DNM1-associated microcephaly, developmental and epileptic encephalopathy",
    "COG5-CDG",
    "GM2-GANGLIOSIDOSIS TYPE 2",
    "SPONDYLOCOSTAL DYSOSTOSIS TYPE 2",
    "PRIMARY AUTOSOMAL RECESSIVE MICROCEPHALY",
    "HYPERPHENYLALANINEMIA, BH4-DEFICIENT, D",
    "VENOUS MALFORMATIONS, MULTIPLE CUTANEOUS AND MUCOSAL",
    "DEAFNESS, DYSTONIA, AND CENTRAL HYPOMYELINATION WITH DISORGANIZATION OF THE GOLGI APPARATUS",
    "ATRIAL SEPTAL DEFECT TYPE 3",
    "CEREBRAL PALSY SPASTIC QUADRIPLEGIC TYPE 2",
    "KBG SYNDROME",
    "POTOCKI-SHAFFER SYNDROME",
    "NEURAL TUBE DEFECTS",
    "JOUBERT SYNDROME TYPE 10",
    "INCONTINENTIA PIGMENTI",
    "DIABETES MELLITUS, PERMANENT NEONATAL, WITH CEREBELLAR AGENESIS",
    "ICHTHYOSIS VULGARIS",
    "SEVERE EARLY-ONSET EPILEPSY",
    "INTELLECTUAL DEVELOPMENTAL DISORDER-JOINT HYPERMOBILITY-SKIN LAXITY WITH OR WITHOUT METABOLIC ABNORMALITIES",
    "WNT7A- associated skeletal malformations syndrome",
    "HYPERKALEMIC PERIODIC PARALYSIS TYPE 1",
    "BLEPHAROPHIMOSIS, PTOSIS, AND EPICANTHUS INVERSUS SYNDROME",
    "NEMALINE MYOPATHY 7",
    "MICROCEPHALY, POSTNATAL PROGRESSIVE, WITH SEIZURES AND BRAIN ATROPHY",
    "THYROID HORMONOGENESIS DEFECT I",
    "MOYAMOYA DISEASE 5",
    "FANCG-related Fanconi anemia",
    "SPLIT-HAND/FOOT MALFORMATION TYPE 3",
    "ASPH-related dysmorphism, lens dislocation, anterior segment abnormalities, and filtering blebs",
    "CORTICAL DYSPLASIA, COMPLEX, WITH OTHER BRAIN MALFORMATIONS 5",
    "SUMF1-related multiple sulfatase deficiency",
    "CIB2-related Usher syndrome",
    "MACROCEPHALY, MACROSOMIA, FACIAL DYSMORPHISM SYNDROME",
    "CEREBRAL CAVERNOUS MALFORMATIONS TYPE 3",
    "OROFACIODIGITAL SYNDROME XIV",
    "JOUBERT SYNDROME 15",
    "DEAFNESS AUTOSOMAL DOMINANT TYPE 2B",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 24",
    "CAMURATI-ENGELMANN DISEASE",
    "OSTEOGLOPHONIC DYSPLASIA",
    "MUCOPOLYSACCHARIDOSIS TYPE 3A",
    "ATRIAL SEPTAL DEFECT TYPE 6",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 6",
    "MEIER-GORLIN SYNDROME 1",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP E",
    "BARDET-BIEDL SYNDROME TYPE 3",
    "MUCOPOLYSACCHARIDOSIS TYPE 1S",
    "Tatton-Brown Rahman syndrome (OVERGROWTH SYNDROME WITH INTELLECTUAL DISABILITY)",
    "UV-SENSITIVE SYNDROME",
    "CHOANAL ATRESIA AND LYMPHEDEMA",
    "ROBO3-related familial horizontal gaze palsy with progressive scoliosis",
    "BARDET-BIEDL SYNDROME TYPE 1",
    "FRONTONASAL DYSPLASIA TYPE 3",
    "BMP4-related microphthalmia with brain and digit anomalies",
    "TETRA-AMELIA SYNDROME",
    "MERRF",
    "CONGENITAL DISORDER OF GLYCOSYLATION TYPE 1G",
    "SUCCINYL-COA-3-KETOACID-COA TRANSFERASE DEFICIENCY",
    "MFSD8-RELATED NEURONAL CEROID-LIPOFUSCINOSIS",
    "CEREBRO-OCULO-FACIO-SKELETAL SYNDROME TYPE 2",
    "COENZYME Q10 DEFICIENCY, PRIMARY, 3",
    "MUCOPOLYSACCHARIDOSIS TYPE 7",
    "2-METHYL-3-HYDROXYBUTYRYL-COA DEHYDROGENASE DEFICIENCY",
    "NOONAN SYNDROME 8",
    "DIABETES MELLITUS, 6Q24-RELATED TRANSIENT NEONATAL",
    "LETHAL RESTRICTIVE DERMOPATHY, ZMPSTE24-RELATED",
    "HYPOGONADOTROPIC HYPOGONADISM",
    "LEUKOENCEPHALOPATHY WITH BRAINSTEM AND SPINAL CORD INVOLVEMENT AND LACTATE ELEVATION",
    "MALONYL-COA DECARBOXYLASE DEFICIENCY",
    "HUMAN PIEBALDISM",
    "BECKWITH-WIEDEMANN SYNDROME",
    "ALOPECIA NEUROLOGIC DEFECTS AND ENDOCRINOPATHY SYNDROME",
    "HGSNAT-related mucopolysaccharidosis type IIIC",
    "GLUTARICACIDEMIA TYPE 1",
    "PIGL-related coloboma, congenital heart disease, ichthyosiform dermatosis, impaired intellectual development, and ear anomalies (CHIME) syndrome",
    "ZFPM2-associated malformation syndrome",
    "PRIMARY CILIARY DYSPLASIA",
    "PONTOCEREBELLAR HYPOPLASIA",
    "CANTU SYNDROME HYPERTRICHOTIC OSTEOCHONDRODYSPLASIA",
    "PERRAULT SYNDROME",
    "KABUKI SYNDROME 2",
    "LANGER MESOMELIC DYSPLASIA",
    "BENIGN FAMILIAL INFANTILE EPILEPSY AND INFANTILE CONVULSIONS WITH CHOREOATHETOSIS SYNDROME",
    "GDF6 Oculo-Skeletal Syndrome",
    "COACH SYNDROME",
    "VACTERL ASSOCIATION, X-LINKED, WITH OR WITHOUT HYDROCEPHALUS",
    "HETEROTAXY SYNDROME",
    "CONGENITAL MYOPATHY WITH EXCESS OF MUSCLE SPINDLES",
    "EPILEPSY, PROGRESSIVE MYOCLONIC 7",
    "CHRNB2-RELATED NOCTURNAL FRONTAL LOBE EPILEPSY, AUTOSOMAL DOMINANT",
    "METHYLMALONIC ACIDURIA AND HOMOCYSTINURIA TYPE CBLD",
    "GALK1-related galactokinase deficiency with cataracts",
    "NYX-related congenital stationary night blindness",
    "VENTRICULOMEGALY WITH CYSTIC KIDNEY DISEASE",
    "PYRUVATE CARBOXYLASE DEFICIENCY",
    "JOUBERT SYNDROME 14",
    "CCDC78-related congenital myopathy",
    "ATRIAL SEPTAL DEFECT TYPE 2",
    "SEVERE COBBLESTONE LISSENCEPHALY",
    "RING DERMOID OF CORNEA",
    "CHILDHOOD ABSENCE EPILEPSY TYPE 5",
    "CATARACT POSTERIOR POLAR TYPE 2",
    "ALVEOLAR CAPILLARY DYSPLASIA WITH MISALIGNMENT OF PULMONARY VEINS",
    "ZELLWEGER SYNDROME",
    "LEIGH SYNDROME",
    "KIF11-related microcephaly with or without chorioretinopathy, lymphedema, and developmental delay",
    "PONTOCEREBELLAR HYPOPLASIA TYPE 2 AND TYPE 4",
    "METHYLMALONIC ACIDURIA AND HOMOCYSTINURIA, CBLJ TYPE",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED OPHN1-RELATED",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 91",
    "MEDIUM CHAIN ACYL-COENZYME A DEHYDROGENASE DEFICIENCY",
    "SMAD3-RELATED LOEYS-DIETZ SYNDROME",
    "PRIMARY CILIARY DYSKINESIA",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED CASK-RELATED",
    "GLUTARIC ACIDURIA TYPE 2C",
    "CHAR SYNDROME",
    "SPINAL AND BULBAR MUSCULAR ATROPHY",
    "OLMSTED SYNDROME",
    "VAN DER WOUDE SYNDROME",
    "PERIVENTRICULAR HETEROTOPIA WITH MICROCEPHALY",
    "HYDROLETHALUS SYNDROME TYPE 1",
    "SPASTIC ATAXIA, CHARLEVOIX-SAGUENAY TYPE",
    "NESTOR-GUILLERMO PROGERIA SYNDROME",
    "ANDROGEN INSENSITIVITY SYNDROME",
    "EHMT1-LIKE INTELLECTUAL DISABILITY",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED ZDHHC9-RELATED",
    "FOXC1-related Axenfeld-Rieger syndrome",
    "GENERALIZED EPILEPSY AND PAROXYSMAL DYSKINESIA",
    "MITOCHONDRIAL COMPLEX I DEFICIENCY",
    "CRANIOECTODERMAL DYSPLASIA",
    "TETRALOGY OF FALLOT",
    "HYPEREKPLEXIA",
    "CRANIOECTODERMAL DYSPLASIA 4",
    "CEP152-related Developmental Disorder",
    "DEAFNESS AUTOSOMAL DOMINANT TYPE 39 WITH DENTINOGENESIS IMPERFECTA 1",
    "CLCN7-RELATED OSTEOPETROSIS",
    "MODERATE SENSORINEURAL HEARING LOSS",
    "CLUBBING WITH SKELETAL DYSPLASIA INC ACROOSTEOLYSIS",
    "MULTICENTRIC CARPOTARSAL OSTEOLYSIS SYNDROME",
    "COMBINED OXIDATIVE PHOSPHORYLATION DEFICIENCY 7",
    "POLYCYSTIC KIDNEY DISEASE, AUTOSOMAL RECESSIVE",
    "SUBCORTICAL BAND HETEROTOPIA X-LINKED",
    "KENNY-CAFFEY SYNDROME",
    "POC1B-related cone-rod dystrophy",
    "3-METHYLCROTONYL-COA CARBOXYLASE 2 DEFICIENCY",
    "CRX-RELATED LEBER CONGENITAL AMAUROSIS LEBER CONGENITAL AMAUROSIS 7",
    "CATARACT, AUTOSOMAL RECESSIVE CONGENITAL 1",
    "LYMPHEDEMA, HEREDITARY, IC",
    "AUTISM",
    "SEVERE CONGENITAL NEUTROPENIA",
    "PMM2-related congenital disorder of glycosylation",
    "SOX10-related peripheral demyelinating neuropathy, central dysmyelinating leukodystrophy, waardenburg syndrome, and hirschsprung disease",
    "OROTIC ACIDURIA TYPE 1",
    "MICROPHTHALMIA ISOLATED TYPE 2",
    "PEX19-related peroxisome biogenesis disorder",
    "SLC4A4-related proximal renal tubular acidosis with ocular abnormalities",
    "BAMFORTH-LAZARUS SYNDROME",
    "BLOC1S6-related Hermansky-Pudlak syndrome",
    "MYOPATHY MYOFIBRILLAR TYPE 4",
    "SEVERE DERMATITIS, MULTIPLE ALLERGIES AND METABOLIC WASTING",
    "ARL6-related retinal dystrophy",
    "SPTAN1-related neurodevelopmental disorder with epilepsy and spastic paraplegia",
    "ABCB11-RELATED INTRAHEPATIC CHOLESTASIS",
    "ACUTE HEPATIC PORPHYRIA",
    "BUSCHKE-OLLENDORFF SYNDROME",
    "ATAXIA, POSTERIOR COLUMN, WITH RETINITIS PIGMENTOSA",
    "JOUBERT SYNDROME 2",
    "HYPOTHYROIDISM, CONGENITAL, NONGOITROUS, 6",
    "BARTTER SYNDROME TYPE 4B",
    "CATARACT AUTOSOMAL DOMINANT BFSP2-RELATED",
    "TUBGCP6-related microcephaly with chorioretinopathy with or without developmental delay",
    "ATYPICAL NOONAN SYNDROME",
    "ECTODERMAL DYSPLASIA-SYNDACTYLY SYNDROME 1",
    "NYSTAGMUS 1, CONGENITAL, X-LINKED",
    "CONGENITAL SYSTEMIC GLUTAMINE DEFICIENCY",
    "MEIER-GORLIN SYNDROME 2",
    "3MC SYNDROME 2",
    "Periventricular nodular heterotopia with ID, cleft palate and 2.3 toe syndactyly",
    "HOLOPROSENCEPHALY",
    "EPILEPSY, FOCAL, WITH SPEECH DISORDER AND WITH OR WITHOUT INTELLECTUAL DEVELOPMENTAL DISORDER",
    "FRAGILE X TREMOR/ATAXIA SYNDROME",
    "MYOCLONIC EPILEPSY, INFANTILE, FAMILIAL",
    "Macrocephaly with intellectual disability",
    "WDR45-RELATED NEURODEGENERATION WITH BRAIN IRON ACCUMULATION",
    "HEREDITARY SPASTIC PARAPARESIS",
    "BRACHYDACTYLY, TYPE B1",
    "SIALIDOSIS",
    "MICROCEPHALY, PROGRESSIVE, SEIZURES, AND CEREBRAL AND CEREBELLAR ATROPHY",
    "CAFFEY DISEASE",
    "EEM SYNDROME",
    "PAX3-related Waardenburg syndrome",
    "CEREBRO-COSTO-MANDIBULAR SYNDROME",
    "GALACTOSIALIDOSIS",
    "DIAPHANOSPONDYLODYSOSTOSIS",
    "HYPOPLASTIC LEFT HEART SYNDROME",
    "THIAMINE METABOLISM DYSFUNCTION SYNDROME 2",
    "DIAPHRAGMATIC HERNIA 3",
    "VESICOURETERAL REFLUX TYPE 3",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL DOMINANT 6",
    "SENGERS SYNDROME",
    "MYOPATHY, MYOFIBRILLAR, FATAL INFANTILE HYPERTONIC, ALPHA-B CRYSTALLIN-RELATED",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 46",
    "PSEUDOHYPOPARATHYROIDISM TYPE 1B",
    "MUCOPOLYSACCHARIDOSIS TYPE 3D",
    "SHORT-RIB POLYDACTYLY",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 28",
    "PARTINGTON SYNDROME",
    "CATARACT 17, MULTIPLE TYPES, MONOALLELIC",
    "X-LINKED CREATINE DEFICIENCY SYNDROME",
    "LMNA-related familial partial lipodystrophy",
    "SUCCINATE SEMIALDEHYDE DEHYDROGENASE DEFICIENCY",
    "PORENCEPHALY 1",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY CONGENITAL WITH BRAIN AND EYE ANOMALIES TYPE A1",
    "BRACHYDACTYLY, TYPE E2",
    "CONE-ROD DYSTROPHY 16",
    "CONGENITAL GENERALIZED LIPODYSTROPHY TYPE 3",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA WITH ABNORMAL DENTITION",
    "SECKEL SYNDROME 6",
    "Proximal spinal muscular atrophy with brain anomalies",
    "HYPOTRICHOSIS SIMPLEX OF THE SCALP 2",
    "B4GALT7-related spondylo-dysplastic Ehlers Danlos syndrome",
    "SYNDROMIC MR WITH ATAXIA, DYSARTHRIA AND EPILEPSY",
    "MEGALOBLASTIC ANEMIA DUE TO DIHYDROFOLATE REDUCTASE DEFICIENCY",
    "HARS1-related Usher syndrome",
    "OSTEOPETROSIS AUTOSOMAL RECESSIVE TYPE 3",
    "GLYCINE ENCEPHALOPATHY",
    "COCOON SYNDROME",
    "CATARACT 5, MULTIPLE TYPES",
    "MIRROR MOVEMENTS 2",
    "FGFR2-related lacrimo-auriculo-dento-digital syndrome",
    "PFEIFFER SYNDROME",
    "KRABBE DISEASE",
    "AICARDI-GOUTIERES SYNDROME 2",
    "ADRENOLEUKODYSTROPHY PSEUDONEONATAL",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL DOMINANT TYPE 3",
    "FEINGOLD SYNDROME",
    "DESMOSTEROLOSIS",
    "SKELETAL DEFECTS GENITAL HYPOPLASIA AND INTELLECTUAL DEVELOPMENTAL DISORDER",
    "ALEXANDER DISEASE",
    "HESX1-RELATED COMBINED PITUITARY HORMONE DEFICIENCY",
    "CARDIOFACIOCUTANEOUS SYNDROME",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 3",
    "ALAGILLE SYNDROME",
    "SEX REVERSAL TYPE 3",
    "TIMM8A-related Mohr-Tranebjaerg syndrome",
    "VAN DEN ENDE-GUPTA SYNDROME",
    "WOODHOUSE-SAKATI SYNDROME",
    "HOMOCYSTINURIA-MEGALOBLASTIC ANEMIA, CBL E TYPE",
    "BARDET-BIEDL SYNDROME TYPE 8",
    "CONGENITAL MUSCULAR DYSTROPHY",
    "LEUKODYSTROPHY HYPOMYELINATING TYPE 1",
    "6-PYRUVOYLTETRAHYDROPTERIN SYNTHASE DEFICIENCY",
    "SCHMID TYPE METAPHYSEAL CHONDRODYSPLASIA",
    "CONGENITAL CONTRACTURAL ARACHNODACTYLY",
    "ACHALASIA-ADDISONIANISM-ALACRIMA SYNDROME",
    "NONSYNDROMIC INTELLECTUAL DEVELOPMENTAL DISORDER",
    "CHONDRODYSPLASIA WITH JOINT DISLOCATIONS, GRAPP TYPE",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-LINKED 99",
    "TYROSINEMIA TYPE 3",
    "PRIMARY CILIARY DYSKINEASIA",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL RECESSIVE 48",
    "IMMUNODEFICIENCY-CENTROMERIC INSTABILITY-FACIAL ANOMALIES SYNDROME 1",
    "FRAGILE X SYNDROME",
    "CORNELIA DE LANGE SYNDROME TYPE 3",
    "SMOC1-related ophthalmoacromelic syndrome",
    "FANCONI-BICKEL SYNDROME",
    "DNA2-related microcephalic primordial dwarfism with or without poikiloderma and cataracts",
    "CTNS-related nephropathic cystinosis",
    "DONNAI-BARROW SYNDROME",
    "HENNEKAM LYMPHANGIECTASIA-LYMPHEDEMA SYNDROME",
    "Short-rib thoracic dysplasia 3 with or without polydactyly",
    "MICROCEPHALIC OSTEODYSPLASTIC PRIMORDIAL DWARFISM, TYPE I",
    "NEPHROPATHY WITH PRETIBIAL EPIDERMOLYSIS BULLOSA AND DEAFNESS",
    "SHORT CHAIN ACYL-COA DEHYDROGENASE DEFICIENCY",
    "ADENYLOSUCCINASE DEFICIENCY",
    "CHARCOT-MARIE-TOOTH DISEASE TYPE 2B1",
    "COG1-CDG",
    "ICHTHYOSIS, SPASTIC QUADRIPLEGIA, AND INTELLECTUAL DEVELOPMENTAL DISORDER",
    "NDST1-related intellectual disability with or without seizures",
    "NONSYNDROMIC AUTOSOMAL-RECESSIVE INTELLECTUAL DISABILITY",
    "CORTICAL DYSPLASIA, COMPLEX, WITH OTHER BRAIN MALFORMATIONS 6",
    "ARTHROGRYPOSIS MULTIPLEX CONGENITA AND INTELLECTUAL DISABILITY, hemizygous",
    "CEROID LIPOFUSCINOSIS, NEURONAL, 6",
    "PHELAN-MCDERMID SYNDROME",
    "PYRUVATE DEHYDROGENASE E1-ALPHA DEFICIENCY IN FEMALES",
    "CLDN19-related hypomagnesemia with ocular involvement",
    "ALS2-RELATED DISORDERS",
    "TRIPHALANGEAL THUMB-POLYSYNDACTYLY SYNDROME",
    "MULTIPLE MITOCHONDRIAL DYSFUNCTIONS SYNDROME 2",
    "TCF12-related neurodevelopmental disorder with coronal craniosynostosis",
    "TYROSINEMIA TYPE 2",
    "MITOCHONDRIAL COMPLEX III DEFICIENCY",
    "YEMENITE DEAF-BLIND HYPOPIGMENTATION SYNDROME",
    "LEUKODYSTROPHY, HYPOMYELINATING, 2",
    "SLC12A5-related epilepsy of infancy with migrating focal seizures",
    "CURRARINO SYNDROME",
    "ADENOSINE DEAMINASE DEFICIENCY",
    "MENKES DISEASE",
    "HYPERLYSINEMIA",
    "PANCREATIC AGENESIS, DIAPHRAGMATIC HERNIA AND CONGENITAL HEART DEFECTS",
    "BRANCHIOOCULOFACIAL SYNDROME",
    "GHOSAL HEMATODIAPHYSEAL SYNDROME",
    "LHX4-RELATED COMBINED PITUITARY HORMONE DEFICIENCY",
    "ECTODERMAL DYSPLASIA TYPE 1",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 18",
    "COL11A1-related fibrochondrogenesis",
    "SYSTEMIC PRIMARY CARNITINE DEFICIENCY",
    "PARAMYOTONIA CONGENITA OF VON EULENBURG",
    "FAMILIAL HYPERINSULINISM",
    "PHOSPHOSERINE PHOSPHATASE DEFICIENCY",
    "UBE2A-RELATED X-LINKED SYNDROMIC INTELLECTUAL DEVELOPMENTAL DISORDER",
    "NAIL DISORDER NON-SYNDROMIC CONGENITAL TYPE 10",
    "PRIMARY MICROCEPHALY AND DISTURBED CENTROSOMAL FUNCTION",
    "DEAFNESS WITH LABYRINTHINE APLASIA, MICROTIA AND MICRODONTIA",
    "WALKER WARBURG SYNDROME",
    "STAR SYNDROME",
    "46XY SEX REVERSAL 6",
    "JUVENILE MYOCLONIC EPILEPSY",
    "HOLT-ORAM SYNDROME",
    "TIETZ SYNDROME",
    "ATELOSTEOGENESIS TYPE 3",
    "STICKLER SYNDROME, TYPE V",
    "PEX3-related peroxisome biogenesis disorder",
    "CATARACT, NUCLEAR",
    "CHILDHOOD-ONSET HYPOGAMMAGLOBULINEMIA",
    "CORTICAL DYSPLASIA, COMPLEX, WITH OTHER BRAIN MALFORMATIONS 2",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP D2",
    "3-METHYLGLUTACONIC ACIDURIA TYPE 1",
    "MAPLE SYRUP URINE DISEASE",
    "BH4-DEFICIENT HYPERPHENYLALANINEMIA C",
    "KABUKI SYNDROME",
    "NEUROMYOTONIA AND AXONAL NEUROPATHY, AUTOSOMAL RECESSIVE",
    "JOHANSON-BLIZZARD SYNDROME",
    "AUTOIMMUNE POLYENDOCRINOPATHY SYNDROME TYPE 1",
    "Cataract 2, multiple types",
    "ALG6-CDG",
    "SALLA DISEASE",
    "ARID1A-related Coffin-Siris Syndrome",
    "OPITZ-KAVEGGIA SYNDROME",
    "46XY SEX REVERSAL 1",
    "CATARACT CONGENITAL ZONULAR WITH SUTURAL OPACITIES",
    "SMITH-MAGENIS SYNDROME",
    "C SYNDROME",
    "EARLY INFANTILE EPILEPTIC ENCEPHALOPATHY AND MICROCEPHALY",
    "CORTICAL DYSPLASIA, COMPLEX, WITH OTHER BRAIN MALFORMATIONS 1",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL DOMINANT 23",
    "COMPLEX HEREDITARY SPASTIC PARAPLEGIA",
    "PRIMARY CILLARY DYSKINEASIA",
    "KEPPEN-LUBINSKY SYNDROME",
    "TUBGCP4-related microcephaly with chorioretinopathy",
    "TP63-related ectrodactyly, ectodermal dysplasia, and cleft lip/palate syndrome",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA MISSOURI TYPE",
    "RPS19-RELATED DIAMOND-BLACKFAN ANEMIA",
    "GLYCOGEN STORAGE DISEASE TYPE II",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL DOMINANT TYPE 4",
    "CHRNA2-RELATED NOCTURNAL FRONTAL LOBE EPILEPSY, AUTOSOMAL DOMINANT",
    "PRIMARY FAILURE OF TOOTH ERUPTION",
    "MEGALENCEPHALY-POLYMICROGYRIA-POLYDACTYLY-HYDROCEPHALUS SYNDROME 1",
    "SCALP-EAR-NIPPLE SYNDROME",
    "RETINAL NON-ATTACHMENT CONGENITAL NON-SYNDROMIC",
    "GFER-related mitochondrial progressive myopathy with congenital cataract, hearing loss and developmental delay",
    "ATRIAL SEPTAL DEFECT TYPE 4",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IIK",
    "FG SYNDROME TYPE 4",
    "FRONTOMETAPHYSEAL DYSPLASIA",
    "HYCC-related leukodystrophy, hypomyelinating",
    "RENAL CYSTS AND DIABETES SYNDROME",
    "MOCS2-related molybdenum cofactor deficiency",
    "ALOPECIA UNIVERSALIS",
    "THROMBOCYTOPENIA 2",
    "ALPHA-THALASSEMIA INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME X-LINKED NON-DELETION TYPE",
    "POPLITEAL PTERYGIUM SYNDROME",
    "AGENESIS OF THE CORPUS CALLOSUM WITH PERIPHERAL NEUROPATHY",
    "Epileptic Encephalopathy due to congenital disorder of glycosylation",
    "ADRENOLEUKODYSTROPHY, X-LINKED",
    "SNYDER-ROBINSON SYNDROME",
    "GLUTAMATE FORMIMINOTRANSFERASE DEFICIENCY",
    "BENIGN NEONATAL EPILEPSY TYPE 1",
    "CANAVAN DISEASE",
    "SEBORRHEA-LIKE DERMATITIS WITH PSORIASIFORM ELEMENTS",
    "RUBINSTEIN-TAYBI SYNDROME TYPE 2",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED TYPE 14",
    "AICARDI-GOUTIERES SYNDROME",
    "ARGININOSUCCINATE LYASE DEFICIENCY",
    "GENERALIZED EPILEPSY WITH FEBRILE SEIZURES PLUS, TYPE 9",
    "COL2A1-related Stickler syndrome, non-syndromic ocular",
    "ACHONDROGENESIS TYPE 1B",
    "HUTCHINSON-GILFORD PROGERIA SYNDROME",
    "BRANCHIOOTORENAL SYNDROME TYPE 2",
    "AXENFELD-RIEGER SYNDROME TYPE 1",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED CHRISTIANSON TYPE",
    "FANCONI ANEMIA COMPLEMENTATION GROUP D TYPE 1",
    "OGDEN SYNDROME",
    "MYOPATHY WITH EXTRAPYRAMIDAL SIGNS",
    "EARLY-ONSET EPILEPTIC ENCEPHALOPATHY WITH PERSISTENT MYELINATION DEFECT.",
    "EPG5-related immunodeficiency, cardiomyopathy, cataract, hypopigmentation, and absent corpus callosum",
    "CENANI-LENZ SYNDACTYLY SYNDROME",
    "BRANCHIOOTIC SYNDROME TYPE 3",
    "SCHINZEL-GIEDION MIDFACE RETRACTION SYNDROME",
    "NOONAN SYNDROME TYPE 3",
    "NEUTRAL LIPID STORAGE DISEASE WITH MYOPATHY",
    "CEREBRAL PALSY SPASTIC QUADRIPLEGIC TYPE 5",
    "PONTOCEREBELLAR HYPOPLASIA, TYPE 10",
    "FACIAL PARESIS, HEREDITARY CONGENITAL, 3",
    "EARLY ONSET EPILEPTIC ENCEPHALOPATHY",
    "GLUTARIC ACIDURIA TYPE 2A",
    "PONTOCEREBELLAR HYPOPLASIA AND MICROCEPHALY",
    "NECTIN1-related cleft lip/palate-ectodermal dysplasia syndrome",
    "LEFT VENTRICULAR OUTFLOW TRACT OBSTRUCTION",
    "CBS-related homocystinuria due to cystathionine beta-synthase deficiency",
    "CONGENITAL ICHTHYOSIS",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 3",
    "MULTIPLE CONGENITAL ANOMALIES-HYPOTONIA-SEIZURES SYNDROME 2",
    "CORNELIA DE LANGE SYNDROME TYPE 1",
    "JERVELL AND LANGE-NIELSEN SYNDROME TYPE 1",
    "RETINITIS PIGMENTOSA 54",
    "BIRK-BAREL SYNDROME",
    "OSTEOGENESIS IMPERFECTA",
    "NEONATAL EPILEPSY SPECTRUM",
    "CEREBELLAR ATAXIA INTELLECTUAL DEVELOPMENTAL DISORDER AND DYSEQUILIBRIUM SYNDROME TYPE 3",
    "INFANTILE HYPERTROPHIC CARDIOMYOPATHY, LACTIC ACIDOSIS, AND ISOLATED COMPLEX I DEFICIENCY",
    "PTPN11-related Noonan Syndrome with Multiple Lentigines",
    "SAETHRE-CHOTZEN SYNDROME",
    "WAARDENBURG SYNDROME TYPE 2E",
    "ADAMS OLIVER SYNDROME",
    "SPINOCEREBELLAR ATAXIA, AUTOSOMAL RECESSIVE 8",
    "ANTERIOR SEGMENT MESENCHYMAL DYSGENESIS",
    "MECONIUM ILEUS",
    "3-M SYNDROME 2",
    "NICOLAIDES-BARAITSER SYNDROME",
    "FLNA-related otopalatodigital syndrome",
    "RARB-related microphthalmia syndromic",
    "METHYLMALONIC ACIDURIA TYPE CBLB",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 72 (MRX72) +/- PARKINSONS",
    "CAUDAL DUPLICATION ANOMALY",
    "METHYLENETETRAHYDROFOLATE REDUCTASE DEFICIENCY",
    "3-HYDROXY-3-METHYLGLUTARYL-COENZYME A LYASE DEFICIENCY",
    "AGAMMAGLOBULINEMIA 7, AUTOSOMAL RECESSIVE",
    "GLYCOGEN STORAGE DISEASE XII",
    "MUCOPOLYSACCHARIDOSIS TYPE 3B",
    "GALLOWAY-MOWAT SYNDROME: MICROCEPHALY AND STEROID-RESISTANT NEPHROTIC SYNDROME",
    "LACTICACIDEMIA DUE TO PDX1 DEFICIENCY",
    "PITX3-related anterior segment mesenchymal dysgenesis",
    "FGFR3-related Crouzon syndrome with acanthosis nigricans",
    "HAJDU-CHENEY SYNDROME",
    "IMMUNODEFICIENCY, COMMON VARIABLE, 2",
    "PETERS ANOMALY",
    "MUCOPOLYSACCHARIDOSIS TYPE 6",
    "PCGF2-related craniofacial neurological cardiovascular and skeletal features (Turnpenny-Fry syndrome)",
    "ENCEPHALOPATHY ASSOCIATED WITH MULTIPLE OXIDATIVE PHOSPHORYLATION COMPLEX DEFICIENCIES AND A MITOCHONDRIAL TRANSLATION DEFECT",
    "LIMB-GIRDLE MUSCULAR DYSTROPHY TYPE 2L",
    "PIK3CA-related overgrowth spectrum disorder with or without megalencephaly, capillary malformation, polymicrogyria and lipomatous overgrowth",
    "NANCE-HORAN SYNDROME",
    "MICROPHTHALMIA WITH LINEAR SKIN LESIONS",
    "Hypogonadotropic hypogonadism 2 with or without anosmia",
    "PROLIDASE DEFICIENCY",
    "CONGENITAL DISORDER OF DEGLYCOSYLATION",
    "LATHOSTEROLOSIS",
    "DEAFNESS AUTOSOMAL DOMINANT TYPE 13",
    "DISTAL ARTHROGRYPOSIS TYPE 5D",
    "ALSTROM SYNDROME",
    "CILIARY DYSKINESIA, PRIMARY, 23",
    "MINICORE MYOPATHY WITH EXTERNAL OPHTHALMOPLEGIA",
    "NONSYNDROMIC DEAFNESS DFNB48",
    "FGF10-related lacrimo-auriculo-dento-digital (LADD) syndrome",
    "MALIGNANT MIGRATING PARTIAL SEIZURES OF INFANCY",
    "ABHD5-related ichthyotic neutral lipid storage disease",
    "MULTIPLE EPIPHYSEAL DYSPLASIA TYPE 5",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED LUBS TYPE",
    "SEVERE INTELLECTUAL DISABILITY, EPILEPSY, AND CATARACTS",
    "GMPPB-related muscular dystrophy-dystroglycanopathy",
    "MITOCHONDRIAL COMPLEX III DEFICIENCY, NUCLEAR TYPE 6",
    "COLE-CARPENTER SYNDROME",
    "CRANIOMETAPHYSEAL DYSPLASIA JACKSON TYPE",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 4",
    "LIMB-GIRDLE MUSCULAR DYSTROPHY TYPE 2H",
    "INFANTILE CEREBELLAR-RETINAL DEGENERATION",
    "MUCOLIPIDOSIS TYPE III COMPLEMENTATION GROUP C",
    "TTC7A-related intestinal atresia, inflammatory bowel disease and immunodeficiency",
    "PHOSPHOGLYCERATE KINASE 1 DEFICIENCY",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP A",
    "AMELOGENESIS IMPERFECTA AND GINGIVAL FIBROMATOSIS SYNDROME",
    "AMINOACYLASE-1 DEFICIENCY",
    "PROP1-RELATED COMBINED PITUITARY HORMONE DEFICIENCY",
    "MITOCHONDRIAL TRANSLATION DEFECT ASSOCIATED WITH HYPERTROPHIC CARDIOMYOPATHY, LACTIC ACIDOSIS, AND ENCEPHALOPATHY",
    "AUTISM/ID",
    "LUJAN-FRYNS SYNDROME",
    "INTERSTITIAL LUNG DISEASE, NEPHROTIC SYNDROME, AND EPIDERMOLYSIS BULLOSA, CONGENITAL",
    "DPAGT1-CDG",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA SHORT LIMB-HAND TYPE",
    "MICROVILLUS INCLUSION DISEASE",
    "MCT8 (SLC16A2)-SPECIFIC THYROID HORMONE CELL TRANSPORTER DEFICIENCY",
    "MESOAXIAL SYNOSTOTIC SYNDACTYLY WITH PHALANGEAL REDUCTION, MALIK-PERCIN TYPE",
    "D-BIFUNCTIONAL PROTEIN DEFICIENCY",
    "PRIMARY CILIARY DYSKINESIA-22",
    "KCNH5-related epilepsy and epileptic encephalopathy",
    "BAINBRIDGE-ROPERS SYNDROME",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY LIMB-GIRDLE TYPE C7",
    "DEAFNESS AUTOSOMAL RECESSIVE TYPE 53",
    "KCNT1-related epilepsy",
    "ANEMIA, SIDEROBLASTIC, WITH ATAXIA",
    "JANSEN METAPHYSEAL CHONDRODYSPLASIA",
    "CEREBRORETINAL MICROANGIOPATHY WITH CALCIFICATIONS AND CYSTS",
    "LONG QT SYNDROME-5",
    "GDF3 multiple malformations",
    "CONGENITAL SHORT BOWEL SYNDROME",
    "TYROSINEMIA TYPE 1",
    "JOUBERT SYNDROME TYPE 5",
    "CORNELIA DE LANGE SYNDROME TYPE 2",
    "CENPJ-related developmental disorder",
    "DEAFNESS X-LINKED TYPE 1",
    "EHLERS-DANLOS SYNDROME MUSCULOCONTRACTURAL TYPE",
    "CATARACT, CONGENITAL NUCLEAR, AUTOSOMAL RECESSIVE 2",
    "BRACHYDACTYLY, TYPE A1",
    "HOLOPROSENCEPHALY 11",
    "ACHONDROPLASIA",
    "GAUCHER DISEASE PERINATAL LETHAL",
    "FUCOSIDOSIS",
    "ACHONDROGENESIS TYPE 1A",
    "BRACHYDACTYLY-SYNDACTYLY SYNDROME",
    "ALPORT SYNDROME AUTOSOMAL RECESSIVE",
    "MUCOPOLYSACCHARIDOSIS TYPE 2",
    "LEGIUS SYNDROME",
    "GRACILE SYNDROME",
    "LEBER CONGENITAL AMAUROSIS 4",
    "BOERJESON-FORSSMAN-LEHMANN SYNDROME",
    "NESCAV SYNDROME",
    "RAINE SYNDROME",
    "GRM6-related congenital stationary night blindness",
    "AUTOSOMAL-DOMINANT HYPOTRICHOSIS SIMPLEX",
    "NOONAN SYNDROME 5",
    "NEUROPATHY, HEREDITARY SENSORY, TYPE IIC",
    "INSULIN-LIKE GROWTH FACTOR I, RESISTANCE TO, biallelic",
    "CATARACTS, GROWTH HORMONE DEFICIENCY, SENSORY NEUROPATHY, SENSORINEURAL HEARING LOSS, AND SKELETAL DYSPLASIA",
    "RETINITIS PIGMENTOSA 28",
    "OPITZ G/BBB SYNDROME, X-LINKED",
    "RESPIRATORY CHAIN DISORDER",
    "PITT HOPKINS 2",
    "NEPHROTIC SYNDROME, TYPE 3",
    "CEREBELLAR ATAXIA INTELLECTUAL DEVELOPMENTAL DISORDER AND DYSEQUILIBRIUM SYNDROME TYPE 1",
    "INTELLECTUAL DEVELOPMENTAL DISORDER-STEREOTYPIC MOVEMENTS-EPILEPSY AND/OR CEREBRAL MALFORMATIONS",
    "INTELLECTUAL DEVELOPMENTAL DISORDER-ANTERIOR MAXILLARY PROTRUSION-STRABISMUS",
    "ENLARGED PARIETAL FORAMINA/CRANIUM BIFIDUM",
    "NOT IN OMIM",
    "NLGN4X-related autism and intellectual disability",
    "PYRIDOXINE-DEPENDENT EPILEPSY",
    "LEBER CONGENITAL AMAUROSIS",
    "HYPOMYELINATION WITH ATROPHY OF THE BASAL GANGLIA AND CEREBELLUM",
    "RETICULAR DYSGENESIS",
    "BILE ACID SYNTHESIS DEFECT, CONGENITAL, 1",
    "NEUROPATHY, CONGENITAL HYPOMYELINATING, 1",
    "NOONAN SYNDROME 1",
    "MICROPHTHALMIA, ISOLATED, WITH CATARACT 2",
    "JOUBERT SYNDROME 9",
    "WDR19-related short-rib thoracic dysplasia with or without polydactyly",
    "CENTRAL HYPOTHYROIDISM AND TESTICULAR ENLARGEMENT",
    "BONE MARROW FAILURE SYNDROME 2",
    "MOSAIC VARIEGATED ANEUPLOIDY SYNDROME 2",
    "UROFACIAL SYNDROME",
    "AUTISM SPECTRUM DISORDERS",
    "HYPERTELORISM, SEVERE, WITH MIDFACE PROMINENCE, MYOPIA, INTELLECTUAL DEVELOPMENTAL DISORDER, AND BONE FRAGILITY",
    "ACROCALLOSAL SYNDROME",
    "METHYLMALONIC ACIDURIA AND HOMOCYSTINURIA TYPE CBLF",
    "CARTILAGE-HAIR HYPOPLASIA",
    "DANON DISEASE",
    "CEREBRAL PALSY SPASTIC QUADRIPLEGIC TYPE 1",
    "HNF4A-RELATED MATURITY-ONSET DIABETES OF THE YOUNG TYPE 1",
    "LTBP2-related microspherophakia and/or megalocornea, with ectopia lentis and with or without secondary glaucoma",
    "EPILEPTIC ENCEPHALOPATHY LENNOX-GASTAUT TYPE",
    "MULTIPLE EPIPHYSEAL DYSPLASIA TYPE 4",
    "MICROPHTHALMIA SYNDROMIC TYPE 5",
    "MITOCHONDRIAL RESPIRATORY CHAIN COMPLEX III DEFICIENCY, UQCRQ RELATED",
    "JACKSON-WEISS SYNDROME",
    "CONGENITAL HEMIDYSPLASIA WITH ICHTHYOSIFORM ERYTHRODERMA AND LIMB DEFECTS",
    "DEAFNESS, AUTOSOMAL RECESSIVE",
    "COCKAYNE SYNDROME TYPE B",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, FRA12A TYPE",
    "MITOCHONDRIAL COMPLEX II DEFICIENCY",
    "FBN1-related Marfan syndrome",
    "ATP8B1-RELATED INTRAHEPATIC CHOLESTASIS",
    "THYROID HORMONE METABOLISM, ABNORMAL",
    "MAN2B1-related lysosomal alpha-mannosidosis",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP 0",
    "CONGENITAL VARIANT OF RETT SYNDROME",
    "SETLEIS SYNDROME",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL DOMINANT, 28",
    "CHROMOSOME XQ28 DUPLICATION SYNDROME",
    "RPGRIP1-related retinal dystrophy",
    "AGENESIS OF THE CORPUS CALLOSUM WITH INTELLECTUAL DEVELOPMENTAL DISORDER-OCULAR COLOBOMA-MICROGNATHIA",
    "GTP CYCLOHYDROLASE 1 DEFICIENCY",
    "SPONDYLOMETAPHYSEAL DYSPLASIA, KOZLOWSKI TYPE",
    "LIG4 SYNDROME",
    "FIBROSIS OF EXTRAOCULAR MUSCLES, CONGENITAL, 5",
    "TEMPLE BARRAISTER SYNDROME",
    "ALBRIGHT HEREDITARY OSTEODYSTROPHY",
    "AICARDI-GOUTIERES SYNDROME 7",
    "SIX3-related holoprosencephaly",
    "NOCTURNAL FRONTAL LOBE EPILEPSY TYPE 1",
    "EPILEPTIC ENCEPHALOPATHY EARLY INFANTILE TYPE 9",
    "SMALL PATELLA SYNDROME",
    "CRANIOSYNOSTOSIS, TYPE 2",
    "BARDET-BIEDL SYNDROME TYPE 13",
    "SPASTIC PARAPLEGIA X-LINKED TYPE 2",
    "MUCOLIPIDOSIS TYPE III COMPLEMENTATION GROUP A",
    "GM2-GANGLIOSIDOSIS TYPE 1",
    "DISTAL RENAL TUBULAR ACIDOSIS WITH DEAFNESS",
    "PRIMARY CILIARY DYSKINESIA WITH CENTRAL-COMPLEX AND RADIAL-SPOKE DEFECTS",
    "MYHRE SYNDROME",
    "CPLANE1-related Joubert syndrome",
    "FRONTONASAL DYSPLASIA 2",
    "FATAL INFANTILE CARDIOENCEPHALOMYOPATHY DUE TO CYTOCHROME C OXIDASE DEFICIENCY",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY CONGENITAL WITH INTELLECTUAL DEVELOPMENTAL DISORDER TYPE B6",
    "CILIARY DYSKINESIA, PRIMARY, 29",
    "FETAL AKINESIA DEFORMATION SEQUENCE",
    "BARDET-BIEDL SYNDROME TYPE 15",
    "FRONTONASAL DYSPLASIA TYPE 1",
    "MANITOBA OCULOTRICHOANAL SYNDROME",
    "FILIPPI SYNDROME. SYNDACTYLY, TYPE I, WITH MICROCEPHALY AND INTELLECTUAL DEVELOPMENTAL DISORDER",
    "ALTERNATING HEMIPLEGIA OF CHILDHOOD",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP K",
    "MITF-related Waardenburg syndrome",
    "ANGELMAN SYNDROME",
    "LEUKODYSTROPHY, HYPOMYELINATING, 8, WITH OR WITHOUT OLIGODONTIA AND/OR HYPOGONADOTROPIC HYPOGONADISM",
    "CRANIOLENTICULOSUTURAL DYSPLASIA",
    "WNT5A-RELATED ROBINOW SYNDROME, AUTOSOMAL DOMINANT",
    "X-LINKED HYPOSPADIAS TYPE 2",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY CONGENITAL WITH BRAIN AND EYE ANOMALIES TYPE A2",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IW",
    "UBE3B-related blepharophimosis-intellectual developmental disorder",
    "SEVERE COMBINED IMMUNE DEFICIENCY, AUTOSOMAL RECESSIVE, T CELL-NEGATIVE, B CELL -POSITIVE, NK CELL-NEGATIVE, JAK3-RELATED",
    "CEREBRAL PALSY SPASTIC QUADRIPLEGIC TYPE 6",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 5",
    "ALG3-related congenital disorder of glycosylation",
    "MALFORMATIONS OF CORTICAL DEVELOPMENT AND MICROCEPHALY.",
    "LISSENCEPHALY 4",
    "CHROMOSOME 17Q21.31 MICRODELETION SYNDROME",
    "STICKLER SYNDROME TYPE 3",
    "ANOPHTHALMIA/MICROPHTHALMIA",
    "DYSTONIA 6, TORSION",
    "NOONAN SYNDROME 4",
    "NEUTROPENIA, SEVERE CONGENITAL 3, AUTOSOMAL RECESSIVE",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 58",
    "PRIMARY CONGENITAL GLAUCOMA TYPE 3A",
    "CASP2-related developmental disorder with lissencephaly",
    "DYSTONIA TYPE 5",
    "RPE65-related Leber congenital amaurosis",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED CABEZAS TYPE",
    "CAPILLARY MALFORMATION-ARTERIOVENOUS MALFORMATION 1",
    "CRANIOFACIAL DYSMORPHISM, SKELETAL ANOMALIES, AND INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME",
    "ANTLEY-BIXLER SYNDROME",
    "NOG-related-symphalangism spectrum disorder ",
    "HEMIMEGALENCEPHALY AKT3",
    "NEURODEGENERATION DUE TO CEREBRAL FOLATE TRANSPORT DEFICIENCY",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA PAKISTANI TYPE",
    "SPINAL MUSCULAR ATROPHY ASSOCIATED WITH PROGRESSIVE MYOCLONIC EPILEPSY",
    "HYPOTHYROIDISM, CONGENITAL, NONGOITROUS, 1",
    "MULTIPLE EPIPHYSEAL DYSPLASIA TYPE 3",
    "THANATOPHORIC DYSPLASIA TYPE 2",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 94",
    "Developmental delay, ID, obesity and dysmorphic features",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED TYPE 10",
    "RICKETS VITAMIN D-DEPENDENT TYPE 2A",
    "PRSS56-related microphthalmia",
    "COMBINED OXIDATIVE PHOSPHORYLATION DEFICIENCY 4",
    "MULTIPLE CONGENITAL ANOMALIES-HYPOTONIA-SEIZURES SYNDROME 3",
    "KERATOCONUS WITH CATARACT; EDICT SYNDROME",
    "SPASTIC PARAPLEGIA-11",
    "LESCH-NYHAN SYNDROME",
    "TYRP1-related oculocutaneous albinism",
    "AGENESIS OF THE CORPUS CALLOSUM",
    "CSPP1-related Joubert syndrome with or without Jeune asphyxiating thoracic dystrophy",
    "FAMILIAL SCHIZENCEPHALY, EMX2-RELATED",
    "ALG2-CDG",
    "LEIGH SYNDROME DUE TO MITOCHONDRIAL COMPLEX IV DEFICIENCY",
    "ATELOSTEOGENESIS TYPE 1",
    "MEGALENCEPHALY-POLYMICROGYRIA-POLYDACTYLY-HYDROCEPHALUS SYNDROME",
    "TRICHOHEPATOENTERIC SYNDROME",
    "OSTEOGENESIS IMPERFECTA, TYPE VIII",
    "MICROPHTHALMIA SYNDROMIC TYPE 3",
    "EPILEPTIC ENCEPHALOPATHY EARLY INFANTILE TYPE 4",
    "HYPERPROLINEMIA TYPE 2",
    "MICROPHTHALMIA ISOLATED WITH CATARACT TYPE 4",
    "HYPOPARATHYROIDISM-RETARDATION-DYSMORPHISM SYNDROME",
    "MYOTUBULAR MYOPATHY, X-LINKED",
    "LETHAL CONGENITAL CONTRACTURE SYNDROME TYPE 2",
    "CTDP1-related congenital cataracts, dysmorphism and neuropathy",
    "SPONDYLOCOSTAL DYSOSTOSIS TYPE 3",
    "HYPERAMMONEMIA DUE TO CARBONIC ANHYDRASE VA DEFICIENCY",
    "LONP1-related CODAS syndrome",
    "MEGALENCEPHALY-CAPILLARY MALFORMATION-POLYMICROGYRIA SYNDROME, SOMATIC 3",
    "DISTINCT DNA BREAKAGE SYNDROME",
    "HEARING LOSS",
    "ACYL-COA DEHYDROGENASE FAMILY MEMBER TYPE 9 DEFICIENCY",
    "DOPA-RESPONSIVE DYSTONIA DUE TO SEPIAPTERIN REDUCTASE DEFICIENCY",
    "DENTIN DYSPLASIA, TYPE I, WITH MICRODONTIA AND MISSHAPEN TEETH",
    "METHYLMALONYL-COA EPIMERASE DEFICIENCY",
    "INTELLECTUAL DISABILITY WITH EPILEPSY",
    "AICA-RIBOSURIA",
    "CEREBRAL PALSY SPASTIC QUADRIPLEGIC TYPE 4",
    "ROBERTS SYNDROME",
    "PERIVENTRICULAR HETEROTOPIA",
    "MACROCEPHALY, NEURODEVELOPMENTAL DELAY, AND SEIZURES",
    "CARBAMOYL PHOSPHATE SYNTHETASE 1 DEFICIENCY",
    "OPSISMODYSPLASIA",
    "GLUCOCORTICOID DEFICIENCY 1",
    "GM1-GANGLIOSIDOSIS TYPE 3",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL DOMINANT TYPE 7",
    "NEMALINE MYOPATHY 3",
    "HYPOTONIA-CYSTINURIA SYNDROME",
    "RIGI-related Singleton-Merten syndrome",
    "POMGNT2-related Walker Warberg spectrum disorder",
    "SPECIFIC LANGUAGE IMPAIRMENT 5",
    "MCCUNE-ALBRIGHT SYNDROME",
    "PROTEUS SYNDROME",
    "HOMEOTIC ARM-TO-LEG TRANSFORMATION ASSOCIATED WITH GENOMIC REARRANGEMENTS AT THE PITX1 LOCUS",
    "COBBLESTONE BRAIN MALFORMATION WITHOUT MUSCULAR OR OCULAR ABNORMALITIES",
    "PANCREATIC AGENESIS",
    "BARTH SYNDROME",
    "PARIETAL FORAMINA 2",
    "METHYLCOBALAMIN DEFICIENCY TYPE G",
    "FEINGOLD SYNDROME TYPE 1",
    "SPONDYLOENCHONDRODYSPLASIA WITH IMMUNE DYSREGULATION",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 44",
    "AUTOSOMAL-RECESSIVE CEREBELLAR ATAXIA WITH SPASTICITY.",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 21",
    "AMISH INFANTILE EPILEPSY SYNDROME",
    "THROMBOCYTOPENIA-ABSENT RADIUS SYNDROME",
    "SLIT-ROBO RHO GTPASE-ACTIVATING PROTEIN 3",
    "SEIZURES-SENSORINEURAL DEAFNESS-ATAXIA-INTELLECTUAL DEVELOPMENTAL DISORDER-ELECTROLYTE IMBALANCE",
    "MICROPHTHALMIA ISOLATED WITH COLOBOMA TYPE 5",
    "BRUCK SYNDROME TYPE 2",
    "KNOBLOCH SYNDROME TYPE I",
    "COG4-CDG",
    "OCULOCUTANEOUS ALBINISM TYPE 1",
    "CONGENITAL HEART DEFECTS, MULTIPLE TYPES, 6",
    "SPINAL MUSCULAR ATROPHY WITH RESPIRATORY DISTRESS 1",
    "TUBA1A-associated tubulinopathy",
    "ANEMIA, DYSERYTHROPOIETIC CONGENITAL, TYPE IV",
    "LEUKOENCEPHALOPATHY MEGALENCEPHALIC WITH SUBCORTICAL CYSTS",
    "CRB1-related Leber Congenital Amaurosis and Retinitis Pigmentosa",
    "LOEYS-DIETZ SYNDROME, TYPE 4",
    "CILIARY DYSKINESIA, PRIMARY, 18",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 63",
    "MUSCULAR DYSTROPHY, LIMB-GIRDLE, TYPE 2S",
    "CAMPTODACTYLY TALL STATURE AND HEARING LOSS SYNDROME",
    "CENTRONUCLEAR MYOPATHY WITH DILATED CARDIOMYOPATHY",
    "HIBCH DEFICIENCY",
    "PITUITARY HORMONE DEFICIENCY COMBINED TYPE 3",
    "CONGENITAL ERYTHROPOIETIC PORPHYRIA",
    "DYSSEGMENTAL DYSPLASIA SILVERMAN-HANDMAKER TYPE",
    "SUSCEPTIBILITY TO AUTISM TYPE 17",
    "AUTOSOMAL RECESSIVE TYPICAL NEMALINE MYOPATHY",
    "L-2-HYDROXYGLUTARIC ACIDURIA",
    "DEVELOPMENTAL AND EXPRESSIVE LANGUAGE DELAY",
    "MULTIPLE SYNOSTOSES SYNDROME TYPE 3",
    "FANCM-RELATED FANCONI ANEMIA",
    "MARTSOLF SYNDROME",
    "CATEL-MANZKE SYNDROME",
    "HYDROPS-ECTOPIC CALCIFICATION-MOTH-EATEN SKELETAL DYSPLASIA",
    "ANEMIA, DYSERYTHROPOIETIC CONGENITAL, TYPE II",
    "Smith-Kingsmore syndrome",
    "HAND-FOOT-GENITAL SYNDROME",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED WITH ISOLATED GROWTH HORMONE DEFICIENCY",
    "ICHTHYOSIS PREMATURITY SYNDROME",
    "sjogren-larsson syndrome",
    "CLEFT PALATE, X-LINKED",
    "HPS1-related Hermansky-Pudlak syndrome",
    "GLYCEROL KINASE DEFICIENCY",
    "TUBB2B-related polymicrogyria asymmetric",
    "MECKEL SYNDROME TYPE 5",
    "ATRICHIA WITH PAPULAR LESIONS",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IX",
    "3-METHYLGLUTACONIC ACIDURIA, TYPE VII, WITH CATARACTS, NEUROLOGIC INVOLVEMENT AND NEUTROPENIA",
    "LRP5-related exudative vitreoretinopathy",
    "TARP SYNDROME",
    "MANDIBULOFACIAL DYSOSTOSIS WITH MICROCEPHALY",
    "METAPHYSEAL ANADYSPLASIA TYPE 1",
    "ATAXIA WITH OCULOMOTOR APRAXIA 1",
    "3-METHYLCROTONYL-COA CARBOXYLASE DEFICIENCY",
    "SCHNECKENBECKEN DYSPLASIA",
    "NEPHRONOPHTHISIS TYPE 1",
    "CONGENITAL HEART DISEASE, NONSYNDROMIC, 2",
    "PLATYSPONDYLY WITH AMELOGENESIS IMPERFECTA",
    "PHOSPHOGLYCERATE DEHYDROGENASE DEFICIENCY",
    "GJA8-related cataract",
    "ASPHYXIATING THORACIC DYSTROPHY 2",
    "EHLERS-DANLOS SYNDROME WITH PROGRESSIVE KYPHOSCOLIOSIS, MYOPATHY, AND HEARING LOSS",
    "LYMPHEDEMA-DISTICHIASIS SYNDROME",
    "DIHYDROLIPOAMIDE DEHYDROGENASE (E3) DEFICIENCY",
    "HYPOCHONDROPLASIA",
    "CONGENITAL HYPOTHYROIDISM NON-GOITROUS TYPE 2",
    "NEU-LAXOVA",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 13",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL DOMINANT 19",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED JARID1C-RELATED",
    "MILROY DISEASE",
    "CONGENITAL HEART DISEASE",
    "MITOCHONDRIAL DNA DEPLETION SYNDROME 6",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IS",
    "SYNDROMIC OSTEOGENESIS IMPERFECTA",
    "BEARE-STEVENSON CUTIS GYRATA SYNDROME",
    "EPILEPSY, X-LINKED, WITH VARIABLE LEARNING DISABILITIES AND BEHAVIOR DISORDERS",
    "SYNDROMIC X-LINKED INTELLECTUAL DISABILITY",
    "SHPRINTZEN-GOLDBERG CRANIOSYNOSTOSIS SYNDROME",
    "CONGENITAL DIARRHEAL DISORDERS",
    "LERI-WEILL DYSCHONDROSTEOSIS",
    "USHER SYNDROME TYPE 1D",
    "PERIVENTRICULAR NEURONAL HETEROTOPIA",
    "TREACHER COLLINS SYNDROME TYPE 2",
    "FAMILIAL COLD AUTOINFLAMMATORY SYNDROME 3",
    "FIBRODYSPLASIA OSSIFICANS PROGRESSIVA",
    "CENTRAL HYPOVENTILATION SYNDROME, CONGENITAL, WITH OR WITHOUT HIRSCHSPRUNG DISEASE",
    "ICHTHYOSIS AUTOSOMAL RECESSIVE WITH HYPOTRICHOSIS",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 93",
    "MICROCEPHALY CORTICAL MALFORMATIONS AND INTELLECTUAL DEVELOPMENTAL DISORDER",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 7",
    "MECKEL SYNDROME 9",
    "COCKAYNE SYNDROME TYPE A",
    "PORENCEPHALY 2",
    "NIEMANN-PICK DISEASE, TYPE C1",
    "GJA3-related cataract",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 90",
    "CHOLESTEROL DESMOLASE-DEFICIENT CONGENITAL ADRENAL HYPERPLASIA",
    "EPIMERASE-DEFICIENCY GALACTOSEMIA",
    "PALLISTER-HALL SYNDROME",
    "METHYLMALONIC ACIDURIA AND HOMOCYSTINURIA, CBLC TYPE",
    "FYCO1-related congenital cataract",
    "BARDET-BIEDL SYNDROME TYPE 2",
    "FATAL ENCEPHALOPATHY, LACTIC ACIDOSIS, AND SEVERE MTDNA DEPLETION IN MUSCLE",
    "FRUCTOSE 1,6 BISPHOSPHATASE DEFICIENCY",
    "HYPEROXALURIA, PRIMARY, TYPE 1",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 7",
    "SYMPTOMATIC EPILEPSY AND SKULL DYSPLASIA",
    "SPONDYLOMETAPHYSEAL DYSPLASIA WITH CONE-ROD DYSTROPHY",
    "ACROMELIC FRONTONASAL DYSOSTOSIS",
    "CAPRIN1-related neurodevelopmental disorder ",
    "WINCHESTER SYNDROME",
    "PHOSPHORIBOSYLPYROPHOSPHATE SYNTHETASE SUPERACTIVITY",
    "GDF5-related Symphalangism Spectrum Disorder",
    "THANATOPHORIC DYSPLASIA TYPE 1",
    "ACROCEPHALOPOLYSYNDACTYLY TYPE 2",
    "IRON-REFRACTORY IRON DEFICIENCY ANEMIA",
    "ATRIAL SEPTAL DEFECT 9",
    "3-HYDROXY-3-METHYLGLUTARYL-COA SYNTHASE 2 DEFICIENCY",
    "CITRULLINEMIA TYPE I",
    "MITOCHONDRIAL DNA DEPLETION SYNDROME 4A",
    "ARTHROGRYPOSIS, RENAL DYSFUNCTION, AND CHOLESTASIS 1",
    "RENAL-HEPATIC CILIOPATHY",
    "LEUKOENCEPHALOPATHY, CYSTIC, WITHOUT MEGALENCEPHALY",
    "KEUTEL SYNDROME",
    "CONGENITAL CLUBFOOT",
    "INFANTILE NEUROAXONAL DYSTROPHY 1",
    "TREACHER COLLINS SYNDROME TYPE 1",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 23",
    "LEUKODYSTROPHY, HYPOMYELINATING, 3",
    "TOOTH AGENESIS SELECTIVE X-LINKED TYPE 1",
    "BRACHYDACTYLY-INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 2A",
    "PREMATURE OVARIAN FAILURE SYNDROME TYPE 1",
    "DISTAL ARTHROGRYPOSIS TYPE 2A",
    "EMERY-DREIFUSS MUSCULAR DYSTROPHY TYPE 2",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL DOMINANT TYPE 5",
    "KOHLSCHUTTER-TONZ SYNDROME",
    "NOONAN SYNDROME TYPE 6",
    "NIJMEGEN BREAKAGE SYNDROME",
    "NAIL-PATELLA SYNDROME",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA STRUDWICK TYPE",
    "ALPHA-METHYLACETOACETIC ACIDURIA",
    "HYPOTHRYOIDISM, CONGENITAL, NONGOITROUS 4",
    "COX15-related Leigh Syndrome",
    "ACHROMATOPSIA",
    "PERLMAN SYNDROME",
    "TRICHOTHIODYSTROPHY PHOTOSENSITIVE",
    "MULTIPLE EPIPHYSEAL DYSPLASIA TYPE 2",
    "MUCOPOLYSACCHARIDOSIS TYPE 9",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-LINKED 3",
    "ACROCAPITOFEMORAL DYSPLASIA",
    "CONGENITAL HYPOTHYROIDISM NON-GOITROUS TYPE 5",
    "RIDDLE SYNDROME",
    "INFANTILE NEPHRONOPHTHISIS AND INTELLECTUAL DISABILITY",
    "ACROFACIAL DYSOSTOSIS 1, NAGER TYPE",
    "CEREBELLAR ATAXIA, INTELLECTUAL DEVELOPMENTAL DISORDER, AND DYSEQUILIBRIUM SYNDROME 4",
    "BIOTINIDASE DEFICIENCY",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED SYP-RELATED",
    "UROCANASE DEFICIENCY",
    "RETINAL ARTERIAL MACROANEURYSM WITH SUPRAVALVULAR PULMONIC STENOSIS",
    "ISOVALERIC ACIDEMIA",
    "LRIT3-related complete congenital stationary night blindness",
    "MARINESCO-SJOEGREN SYNDROME",
    "DEAFNESS, AUTOSOMAL RECESSIVE 89",
    "12P12.5 INTRAGENIC DELETIONS ASSOCIATED WITH INTELLECTUAL DISABILITY",
    "GNATHODIAPHYSEAL DYSPLASIA",
    "FOCAL DERMAL HYPOPLASIA",
    "TGFBR2-related Loeys-Dietz syndrome	",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY LIMB-GIRDLE TYPE C4",
    "CONGENITAL HEART DISEASE and NEURODEVELOPMENTAL DISORDER",
    "BARDET-BIEDL SYNDROME TYPE 7",
    "FAMILIAL ISOLATED HYPOPARATHYROIDISM",
    "ETHYLMALONIC ENCEPHALOPATHY",
    "PYCNODYSOSTOSIS",
    "THREE M SYNDROME 3",
    "ICHTHYOSIS, LAMELLAR, 4",
    "NIGHT BLINDNESS, CONGENITAL STATIONARY, TYPE 1D",
    "MITOCHONDRIAL COMPLEX V (ATP SYNTHASE) DEFICIENCY, NUCLEAR TYPE 2",
    "ENCEPHALOPATHY NEONATAL SEVERE DUE TO MECP2 MUTATIONS",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IT",
    "NEK1-related short rib-polydactyly syndrome",
    "KCTD7-related progressive myoclonic epilepsy",
    "INTELLECTUAL DEVELOPMENTAL DISORDER WITH LANGUAGE IMPAIRMENT AND AUTISTIC FEATURES",
    "SCHIMKE IMMUNOOSSEOUS DYSPLASIA",
    "CHARGE SYNDROME",
    "FACIAL CLEFTING, OBLIQUE, 1",
    "SMITH-LEMLI-OPITZ SYNDROME",
    "ATAXIA-OCULOMOTOR APRAXIA 4",
    "PRIMARY CILIARY DYSKINESIA WITH CENTRAL-COMPLEX DEFECTS",
    "SPINOCEREBELLAR ATAXIA 29, CONGENITAL NONPROGRESSIVE",
    "ALAZAMI SYNDROME",
    "WIEDEMANN-STEINER SYNDROME",
    "METHEMOGLOBINEMIA DUE TO DEFICIENCY OF METHEMOGLOBIN REDUCTASE",
    "DIABETES MELLITUS, KCNJ11-RELATED TRANSIENT NEONATAL",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, autosomal recessive 34, with variant lissencephaly",
    "INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROMIC X-LINKED SIDERIUS TYPE",
    "ARSL-related chondrodysplasia punctata",
    "CONGENITAL CEREBELLAR ATAXIA",
    "MICROCEPHALY PRIMARY TYPE 7",
    "PIGN-related multiple congenital anomalies-hypotonia-seizures syndrome",
    "CENTRONUCLEAR MYOPATHY 2",
    "HYPOMYELINATION WITH BRAIN STEM AND SPINAL CORD INVOLVEMENT AND LEG SPASTICITY.",
    "BILATERAL PERISYLVIAN POLYMICROGYRIA",
    "CDKN1C-related Beckwith-Wiedemann syndrome",
    "CHOROIDEREMIA",
    "IKBKG-related ectodermal dysplasia and immunodeficiency",
    "HYPERTHYROIDISM, FAMILIAL GESTATIONAL",
    "HOLOPROSENCEPHALY-7",
    "BRACHYDACTYLY TYPE A2",
    "CATARACT 21, MULTIPLE TYPES",
    "METHYLMALONIC ACIDURIA TYPE MUT",
    "RETINAL CONE DYSTROPHY 3 PDE6H",
    "NEPHRONOPHTHISIS TYPE 11",
    "AURAL ATRESIA, CONGENITAL",
    "HOLOPROSENCEPHALY TYPE 3",
    "XL INTELLECTUAL DISABILITY",
    "DIABETES MELLITUS NEONATAL WITH CONGENITAL HYPOTHYROIDISM",
    "X-LINKED TRICHOTHIODYSTROPHY",
    "AICARDI-GOUTIERES SYNDROME ASSOCIATED WITH A TYPE I INTERFERON SIGNATURE BIALLELIC",
    "BRUNNER SYNDROME",
    "CARPENTER SYNDROME",
    "TRICHOHEPATOENTERIC SYNDROME 2",
    "BARDET-BIEDL SYNDROME TYPE 12",
    "ODAPH-related Amyelogenesis Imperfecta",
    "CORNELIA DE LANGE-LIKE SYNDROME",
    "OSTEOGENESIS IMPERFECTA TYPE V",
    "NIEMANN-PICK DISEASE, TYPE C2",
    "SUSCEPTIBILITY TO AUTISM TYPE 16",
    "CIC-related neurodevelopmental disorder",
    "RICHIERI-COSTA-PEREIRA SYNDROME",
    "EPILEPSY, CHILDHOOD ABSENCE, SUSCEPTIBILITY TO, 6",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL RECESSIVE 12",
    "KCNQ2-related epileptic encephalopathy",
    "INFANTILE EPILEPTIC ENCEPHALOPATHY AND/OR INTELLECTUAL DISABILITY",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED WITH EPILEPSY",
    "SLC33A1-related congenital cataracts and hearing loss with low serum copper and ceruloplasmin",
    "AARSKOG-SCOTT SYNDROME",
    "CRANIOOSTEOARTHROPATHY",
    "PEROXISOME BIOGENESIS DISORDER COMPLEMENTATION GROUP 11",
    "TDRD7-related cataract with or without azoospermia",
    "CLEIDOCRANIAL DYSPLASIA WITH MICROGNATHIA, ABSENT THUMBS, AND DISTAL APHALANGIA YUNIS-VARON SYNDROME",
    "BLOOM SYNDROME",
    "EPILEPSY, GENERALIZED, WITH FEBRILE SEIZURES PLUS, TYPE 3",
    "KLIPPEL-FEIL ANOMALY",
    "CHOREOATHETOSIS, HYPOTHYROIDISM, AND NEONATAL RESPIRATORY DISTRESS",
    "CRANIOSYNOSTOSIS AND DENTAL ANOMALIES",
    "NEPHRONOPHTHISIS-LIKE NEPHROPATHY TYPE 1",
    "3-M SYNDROME 1",
    "BRUGADA SYNDROME 5",
    "WARBURG MICRO SYNDROME TYPE 1",
    "ABCD SYNDROME",
    "MULTIPLE EPIPHYSEAL DYSPLASIA TYPE 1",
    "SENIOR-LOKEN SYNDROME 7",
    "NEPHRONOPHTHISIS TYPE 3",
    "MARSHALL-SMITH SYNDROME",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA AGGRECAN TYPE",
    "ZIMMERMANN-LABAND SYNDROME",
    "RENPENNING SYNDROME 1",
    "MICROCEPHALY PRIMARY TYPE 1",
    "NEXMIF-related Intellectual disability and epilepsy (XLR)",
    "PRIMARY CILIARY DYSKINESIA ASSOCIATED WITH DEFECTIVE OUTER AND INNER DYNEIN ARMS.",
    "ARTHROGRYPOSIS, LETHAL, WITH ANTERIOR HORN CELL DISEASE",
    "CILIARY DYSKINESIA, PRIMARY, 14",
    "MYH9-related macrothrombocytopenia and granulocyte inclusions with or without nephritis or sensorineural hearing loss",
    "EPIDERMOLYSIS BULLOSA WITH PYLORIC ATRESIA",
    "OMODYSPLASIA TYPE 1 (OMOD1)",
    "KERATOSIS LINEARIS WITH ICHTHYOSIS CONGENITA AND SCLEROSING KERATODERMA",
    "GRISCELLI SYNDROME TYPE 3",
    "WEAVER SYNDROME 2",
    "CHONDRODYSPLASIA BLOMSTRAND TYPE",
    "GLOMUVENOUS MALFORMATIONS",
    "MITOCHONDRIAL DNA DEPLETION SYNDROME, MYOPATHIC FORM",
    "GLUTARIC ACIDURIA TYPE 2B",
    "PLXND1-related cardiac malformation syndrome",
    "NORTH AMERICAN INDIAN CHILDHOOD CIRRHOSIS",
    "GJA1-related oculodentodigital dysplasia",
    "BURN MCKEOWN SYNDROME",
    "SPONDYLOEPIPHYSEAL DYSPLASIA CONGENITA",
    "IFIH1-related Singleton-Merten syndrome",
    "RENAL HYPODYSPLASIA/APLASIA 1",
    "MEIER-GORLIN SYNDROME 3",
    "POU1F1-RELATED COMBINED PITUITARY HORMONE DEFICIENCY",
    "INTELLECTUAL DISABILTIY",
    "STICKLER SYNDROME, TYPE II",
    "CEREBROOCULOFACIOSKELETAL SYNDROME 4",
    "CRANIOFRONTONASAL SYNDROME",
    "INTELLECTUAL DEVELOPMENTAL DISORDER AUTOSOMAL RECESSIVE TYPE 3",
    "OROFACIODIGITAL SYNDROME",
    "MICROPHTHALMIA WITH LINEAR SKIN DEFECTS SYNDROME",
    "GM2-GANGLIOSIDOSIS TYPE AB",
    "MUCOLIPIDOSIS IV",
    "COMPLEX CRANIOSYNOSTOSIS",
    "MANDIBULOFACIAL DYSOSTOSIS WITH ALOPECIA",
    "DYGGVE-MELCHIOR-CLAUSEN SYNDROME/SMITH-MCCORT DYSPLASIA",
    "MULIBREY NANISM",
    "BILE ACID SYNTHESIS DEFECT, CONGENITAL, 2",
    "ACUTE NECROTIZING ENCEPHALOPATHY 1, SUSCEPTIBILITY TO",
    "8Q24.3 DELETION-LIKE",
    "HYPERPHOSPHATASIA WITH INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME 4",
    "NEUROPATHY, HEREDITARY SENSORY AND AUTONOMIC, TYPE IC",
    "VERY LONG CHAIN ACYL-COENZYME A DEHYDROGENASE DEFICIENCY",
    "IPEX SYNDROME",
    "INFANTILE MYOFIBROMATOSIS",
    "LIMB-MAMMARY SYNDROME",
    "BARTTER SYNDROME TYPE 4A",
    "EHMT1-like SYNDROME",
    "CAMPOMELIC DYSPLASIA",
    "DOORS SYNDROME",
    "SEVERE ASPHYXIATING THORACIC DYSPLASIA",
    "ASPERGER",
    "IMMUNODEFICIENCY 23",
    "FATAL INFANTILE LACTIC ACIDOSIS",
    "LRP5 - OSTEOPOROSIS-PSEUDOGLIOMA SYNDROME on a spectrum with FEVR with osteopenia",
    "ANIRIDIA",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 30",
    "SLC31A1-associated congenital copper transport disorder",
    "FANCI-related Fanconi anemia",
    "UNVERRICHT-LUNDBORG DISEASE",
    "DENTINOGENESIS IMPERFECTA, SHIELDS TYPE II",
    "DOPA-RESPONSIVE DYSTONIA",
    "FBN1-related Weill-Marchesani syndrome",
    "INTELLECTUAL DEVELOPMENTAL DISORDER X-LINKED TYPE 95",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY LIMB-GIRDLE TYPE C3",
    "PRIMARY CILARY DYSKINESIA",
    "NIJMEGEN BREAKAGE SYNDROME-LIKE DISORDER",
    "AICARDI-GOUTIERES SYNDROME 3",
    "MULLERIAN APLASIA AND HYPERANDROGENISM",
    "CILIARY DYSKINESIA, PRIMARY, 15",
    "FAMILIAL DIARRHEA DIARRHEA 6",
    "POSTNATAL MICROCEPHALY, HYPOMYELINATION, AND REDUCED CEREBRAL WHITE-MATTER VOLUME",
    "ALPORT SYNDROME AUTOSOMAL DOMINANT",
    "FANCONI ANEMIA",
    "SHWACHMAN-DIAMOND SYNDROME",
    "BILATERAL DIFFUSE POLYMICROGYRIA",
    "INSULIN-LIKE GROWTH FACTOR I DEFICIENCY",
    "METATROPIC DYSPLASIA",
    "ID, MACROCEPHALY AND CEREBELLAR HYPOPLASIA",
    "FAMILIAL INFANTILE MYOFIBROMATOSIS",
    "SOTOS SYNDROME",
    "PROGEROID SYNDROME",
    "DUANE-RADIAL RAY SYNDROME",
    "FGFR2-related Pfeiffer syndrome",
    "ARGININE:GLYCINE AMIDINOTRANSFERASE DEFICIENCY",
    "XIA-GIBBS SYNDROME",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IR",
    "Generalized Arterial Calcification of Infancy and Hypophosphataemic Rickets",
    "WARBURG MICRO SYNDROME TYPE 3",
    "ATYPICAL DOMINANT FANCONI SYNDROME WITH MODY",
    "MULTIPLE PTERYGIUM SYNDROME LETHAL TYPE",
    "MICROPHTHALMIA ISOLATED TYPE 5",
    "CHONDROCALCINOSIS 2",
    "EPILEPTIC ENCEPHALOPATHY EARLY INFANTILE TYPE 2",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 26",
    "ATYPICAL KRABBE DISEASE",
    "GMPPA-related alacrima, achalasia and intellectual disability",
    "INFANTILE EPILEPTIC ENCEPHALOPATHY",
    "TPP1-related neuronal ceroid lipofuscinosis",
    "ARTHROGRYPOSIS, DISTAL, TYPE 3",
    "PRIMROSE SYNDROME",
    "MRX WITH/WITHOUT NYSTAGMUS",
    "POLYMICROGYRIA AND CORPUS CALLOSUM AGENESIS",
    "ARTHROGRYPOSIS, RENAL DYSFUNCTION, AND CHOLESTASIS 2",
    "WOLFRAM SYNDROME TYPE 2",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE, 13",
    "WARSAW BREAKAGE SYNDROME",
    "GENITOPATELLAR SYNDROME",
    "ACROFACIAL DYSOSTOSIS, CINCINNATI TYPE",
    "MUCOPOLYSACCHARIDOSIS TYPE 4A",
    "COBALAMIN DISORDER",
    "COG8-CDG",
    "CATARACT, CONGENITAL, CERULEAN TYPE, 2",
    "PLOD1-related Ehlers-Danlos syndrome, kyphoscoliotic type",
    "MITOCHONDRIAL RESPIRATORY CHAIN COMPLEX III DEFICIENCY, UQCRB-RELATED",
    "DUCHENNE MUSCULAR DYSTROPHY",
    "CILIARY DYSKINESIA, PRIMARY, 5",
    "MOHR-MAJEWSKI SYNDROME",
    "SPONDYLOEPIMETAPHYSEAL DYSPLASIA WITH JOINT LAXITY, TYPE 2",
    "NEPHRONOPHTHISIS 7",
    "BOHRING-OPITZ SYNDROME",
    "SEVERE ID WITH NEURONAL MIGRATION DISORDER",
    "LISSENCEPHALY X-LINKED TYPE 1",
    "CREBBP-related Rubinstein-Taybi syndrome",
    "SIMPSON-GOLABI-BEHMEL SYNDROME, TYPE 1",
    "NOONAN-LIKE SYNDROME WITH LOOSE ANAGEN HAIR",
    "EHLERS-DANLOS SYNDROME-LIKE SPONDYLOCHEIRODYSPLASIA",
    "WOLCOTT-RALLISON SYNDROME",
    "CEROID LIPOFUSCINOSIS, NEURONAL, KUFS TYPE, ADULT ONSET",
    "BALLER-GEROLD SYNDROME",
    "COMBINED OXIDATIVE PHOSPHORYLATION DEFICIENCY 6",
    "NEU-LAXOVA SYNDROME",
    "HOLOCARBOXYLASE SYNTHETASE DEFICIENCY",
    "Poikiloderma with neutropenia",
    "Viral induced severe multiorgan dysfunction associated with impaired mitochondrial fission",
    "MACROCEPHALY, ALOPECIA, CUTIS LAXA, AND SCOLIOSIS TALL FOREHEAD, SPARSE HAIR, SKIN HYPEREXTENSIBILITY, AND SCOLIOSIS",
    "HACE1 related disorder",
    "KIAA0586-related Joubert syndrome",
    "MMP21-associated heterotaxy",
    "Pseudohypoparathyroidism-like disorder",
    "Focal epilepsy",
    "JOUBERT SYNDROME",
    "Circumferential Skin Creases Kunze Type",
    "Radioulnar Synostosis with Amegakaryocytic Thrombocytopenia",
    "Episodes of Liver Failure, Peripheral Neuropathy, Cerebellar Atrophy, and Ataxia",
    "Congenital Myasthenic Syndrome Type 19",
    "Intellectual Disability with Cerebellar Atrophy",
    "Autosomal-Dominant Primordial Dwarfism Associated with Meier-Gorlin Syndrome",
    "Dysmorphic Features, Intellectual Disability, and Neurological Manifestations",
    "TERT-related Dyskeratosis congenita",
    "EXUDATIVE RETINOPATHY WITH BONE MARROW FAILURE",
    "ARTHROGRYPOSIS, DISTAL, TYPE 1",
    "Transcobalamin II deficiency",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-linked, syndromic 32",
    "ULLRICH CONGENITAL MUSCULAR DYSTROPHY 1",
    "LETHAL CONGENITAL CONTRACTURE SYNDROME 9",
    "SPONDYLOOCULAR SYNDROME",
    "OSTEOGENESIS IMPERFECTA, TYPE XVII",
    "FANCONI ANEMIA, COMPLEMENTATION GROUP T",
    "CONGENITAL ANOMALIES OF KIDNEY AND URINARY TRACT 2",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-LINKED 12",
    "CRANIOSYNOSTOSIS 6",
    "EPILEPSY, HEARING LOSS, AND INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME",
    "PREMATURE AGING SYNDROME, PENTTINEN TYPE",
    "ADAMS-OLIVER SYNDROME 6",
    "CUTIS LAXA, AUTOSOMAL DOMINANT 3",
    "COMPLEX LETHAL OSTEOCHONDRODYSPLASIA",
    "PROGRESSIVE SPONDYLOEPIMETAPHYSEAL DYSPLASIA",
    "INTRA-MITOCHONDRIAL METHYLATION DEFICIENCY",
    "RTN4IP1-related optic atrophy with or without ataxia, intellectual developmental disorder, and seizures",
    "WAARDENBURG SYNDROME TYPE 2",
    "MICROCEPHALY 15, PRIMARY, AUTOSOMAL RECESSIVE",
    "HEREDITARY SENSORY & AUTONOMIC NEUROPATHY TYPE VIII",
    "CRIPT-related short stature, microcephaly, poikiloderma and skeletal abnormalities (Rothmund Thomson like)",
    "D-2-HYDROXYGLUTARIC ACIDURIA 1",
    "LETHAL CONGENITAL CONTRACTURE SYNDROME 7",
    "EHLERS-DANLOS SYNDROME, MUSCULOCONTRACTURAL TYPE 2",
    "CEREBELLAR ATAXIA, INTELLECTUAL DEVELOPMENTAL DISORDER, AND DYSEQUILIBRIUM SYNDROME 2",
    "HYDROCEPHALUS, NONSYNDROMIC, AUTOSOMAL RECESSIVE",
    "LEIGH SYNDROME DUP",
    "HYPERPHOSPHATASIA WITH INTELLECTUAL DEVELOPMENTAL DISORDER SYNDROME 5",
    "SPONDYLOMETAPHYSEAL DYSPLASIA, SEDAGHATIAN TYPE",
    "CNOT3 syndrome",
    "CSNK2A1 syndrome",
    "GNAI1-related neurodevelopmental disorder with hypotonia, impaired speech, and behavioural abnormalities",
    "KCNQ3 syndrome",
    "Autism",
    "MSL3 syndrome",
    "MYT1L syndrome",
    "PPM1D syndrome",
    "PUF60-related Verheij syndrome",
    "QRICH1 syndrome",
    "SET syndrome",
    "KMT5B syndrome",
    "TCF20 syndrome",
    "ZBTB18 syndrome",
    "Desanto-Shinawi syndrome",
    "Persistent Hypotonia, Encephalopathy, Growth Retardation, and Severe Intellectual Disability",
    "Disorder of Golgi homeostasis",
    "CONGENITAL DISORDER OF GLYCOSYLATION",
    "Infancy-Onset Recurrent Metabolic Crises with Encephalocardiomyopathy",
    "Prenatal Spinal Muscular Atrophy and Congenital Bone Fractures",
    "EMC1-related global developmental delay, hypotonia, scoliosis, and cerebellar atrophy",
    "Encephalocraniocutaneous lipomatosis",
    "Intellectual Disability with Seizures and Hypotonia",
    "DNA Repair-Proficient Trichothiodystrophy",
    "SMG9 Multiple Congenital Anomaly Syndrome",
    "Childhood-Onset Chorea with Bilateral Striatal Lesions",
    "Severe Infantile Syndromic Encephalopathy",
    "Congenital Hemangioma",
    "TELO2 Syndromic Intellectual Disability Disorder",
    "Phenocopy of Proximal 1p36 Deletions",
    "ITPR1-related Gillespie Syndrome",
    "Mitochondrial RNA Processing and Multiple Respiratory Chain Deficiencies",
    "Severe Neurodevelopmental Disability, Hypotonia, and Seizures",
    "GNB3-related congenital stationary night blindness",
    "Isolated Nonsyndromic Patent Ductus Arteriosus.",
    "Riboflavin-Responsive and Non-responsive Multiple Acyl-CoA Dehydrogenase and Combined Respiratory-Chain Deficiency.",
    "Ataxia-Pancytopenia Syndrome",
    "Duane Syndrome, Aberrant Extraocular Muscle Innervation, and Inner-Ear Defects",
    "Short Stature, Developmental Delay, and Congenital Heart Defects",
    "X-Linked Spondyloepimetaphyseal Dysplasia",
    "Epileptic encephalopathy with continuous spike-and-wave during sleep",
    "Curry-Jones Syndrome",
    "Combined immunodeficiency",
    "Autosomal Dominant Coloboma",
    "COL6A1 associated myopathy",
    "Meier-Gorlin Syndrome and Craniosynostosis",
    "Autosomal-Dominant Tubulo-Interstitial and Glomerulocystic Kidney Disease with Anemia",
    "Progressive neurological disorder and regression of developmental milestones",
    "Muscle Weakness and Isolated Complex I Deficiency",
    "Pontocerebellar Hypoplasia and Progressive Microcephaly",
    "Coats Plus",
    "CCDC88A-related PEHO-like syndrome with neuronal migration disorder, seizures and microcephaly",
    "Rasopathy with developmental delay, short stature and sparse slow-growing hair",
    "ATAD3A disorder - global developmental delay, hypotonia, optic atrophy, axonal neuropathy, and hypertrophic cardiomyopathy",
    "Geroderma osteodysplasticum",
    "Hereditary 1,25-dihydroxyvitamin D-resistant rickets",
    "Severe Infantile-Onset Encephalopathy",
    "Cousin Syndrome; Craniofacial Dysmorphism, Hypoplasia of Scapula and Pelvis, and Short Stature",
    "Syndromic INTELLECTUAL DISABILITY with or without congenital heart disease",
    "Cherubism",
    "Syndromic congenital heart defects",
    "Gomez-Lopez-Fernandes syndrome",
    "TLK2 syndrome",
    "Sudden arrhythmic cardiac death after infectious or alcohol trigger",
    "NAA10-related syndromic microphthalmia",
    "Isolated Arhinia/Bosma Arhinia syndrome",
    "OAVS/Goldenhar syndrome",
    "Laterality defects",
    "Autosomal Recessive Craniosynostosis",
    "Syndromic ID with severe microcephaly",
    "Severe microcephaly, short stature and intellectual disability",
    "Microcephaly with short stature",
    "microcephaly",
    "Microcephalic dwarfism",
    "Glycosylphosphatidylinositol deficiency",
    "Early-onset mitochondrial syndrome associated with 3-methylglutaconic aciduria",
    "Congenital lymphatic dysplasia with hydrops and/or lymphoedema",
    "Leukoencephalopathy with cerebral calcification & cysts",
    "Otulin-related auto inflammatory syndrome",
    "Severe pseudo-TORCH syndrome",
    "Severe syndromic form of thoracic aortic aneurysm & dissection",
    "infantile-onset severe developmental delay and skeletal dysplasia",
    "tRNA isopentenyltransferase deficiency",
    "Ataxia, dysmetria, contractures & scoliosis with normal cognition but loss of discriminative touch perception",
    "BRPF1 associated syndromic intellectual disability with ptosis",
    "HIVEP2 associated syndromic developmental delay with intellectual disability",
    "Colobomatous macrophthalmia with microcornea syndrome",
    "Colobomatous microphthalmia, microcephaly, intellectual disability, and short stature",
    "Complex early-onset dystonia",
    "STAG1 syndromic intellectual disability",
    "Intraosseous Vascular Malformation",
    "Growth Retardation with Prenatal Onset, Intellectual Disability, Muscular Hypotonia, and Infantile Hepatopathy",
    "Congenital vascular tumours",
    "Primary Ciliary Dyskinesia with Left-Right Body Asymmetry Randomization",
    "Primary Ciliary Dyskinesia and Male Infertility",
    "Sinus Bradycardia and Cognitive Disability",
    "Intellectual Disability, Congenital Malformations, and Failure to Thrive",
    "Neurodevelopmental Disorder in Females",
    "Congenital Myasthenic Syndrome with Episodic Apnea",
    "Bowen-Conradi syndrome",
    "Severe Epileptic Encephalopathy Treatable with NMDA Receptor Channel Blockers",
    "Severe Early-Onset Mitochondrial Disease and Loss of Mitochondrial DNA Copy Number",
    "Lethal Neurometabolic Disorder of Early Childhood",
    "Intellectual Disability, Ataxia, and Facial Dysmorphism",
    "Spastic paraplegia, intellectual disability, nystagmus, and obesity.",
    "Intellectual Disability Accompanied by Epilepsy and Autistic Features",
    "Lethal arthroogryposis",
    "Early-Onset Neurodegenerative Encephalopathy",
    "Early-Onset Progressive Encephalopathy with Distal Spinal Muscular Atrophy",
    "Developmental delay, macrocephaly, and dysmorphic features",
    "ARID2-Coffin-Siris like disorder",
    "Epileptic encephalopathy with complex movement disorder and regression",
    "DLG4 related intellectual disability",
    "HECW2-related neurodevelopmental disorder",
    "MORC2-related axonal neuropathy and neurodevelopmental disorder",
    "TRIP12-related intellectual disability with/without autism spectrum disorder",
    "Early-Onset Myopathy with Internalized Nuclei and Myofibrillar Disorganization",
    "Glycine Encephalopathy with Arthrogryposis",
    "Cobblestone Lissencephaly",
    "Childhood-Onset Dystonia and Optic Atrophy",
    "Vitamin-B6-Dependent Epilepsy",
    "Anterior Segment Dysgenesis",
    "Epileptic Encephalopathy with Optic Atrophy",
    "MITF-related coloboma, osteopetrosis, microphthalmia, macrocephaly, albinism, and deafness (COMMAD syndrome)",
    "Early-Onset Severe Encephalopathy",
    "X-Linked Primary Ciliary Dyskinesia with Outer and Inner Dynein Arm Defects",
    "Childhood-Onset, Slowly Progressive Nemaline Myopathy",
    "Hyperphenylalaninemia, Dystonia, and Intellectual Disability",
    "NEXMIF-related Intellectual disability and epilepsy (XLD)",
    "MYH10-related Multiple congenital anomalies",
    "Tooth Agenesis",
    "PEHO Like condition",
    "HIST1H4C",
    "Rahman syndrome",
    "Global Developmental Delay, Multiple Malformations",
    "Blepharo-cheiro-dontic syndrome",
    "ACTB Haploinsufficiency syndrome",
    "KINSSHIP syndrome",
    "Brain atrophy, Dandy Walker and Contractures",
    "Short stature, palatal anomalies, congenital heart disease, and skeletal malformations",
    "Beaulieu-Boycott-Innes syndrome",
    "CILIARY DYSKINESIA, PRIMARY, 3",
    "Intellectual Disability",
    "CFAP410-related retinal dystrophy with or without axial spondylometaphyseal dysplasia",
    "Mitochondrial depletion syndrome",
    "Craniofacial anomalies, corpus callosum dysgenesis, ptosis, and developmental delay",
    "Intellectual Disability, Seizures, Abnormal Gait, and Distinctive Facial Features",
    "Chitayat syndrome: hyperphalangism, characteristic facies, hallux valgus and bronchomalacia",
    "Leigh Syndrome with Instability of the Small Mitoribosomal Subunit",
    "Childhood-Onset Neurodegeneration",
    "Mitochondrial Lipoylation Defect Associated with Severe Neonatal Encephalopathy",
    "Progressive Childhood Encephalopathy and Golgi Dysfunction",
    "Early-Onset Epilepsy",
    "Neonatal-onset epilepsy, defective mitochondrial energy metabolism, and glycine elevation",
    "Leigh syndrome with secondary deficiency for pyruvate and alpha-ketoglutarate dehydrogenase.",
    "Joubert syndrome 30",
    "Intellectual Disability with or without Epileptic Encephalopathy",
    "Megacystis Microcolon Intestinal Hypoperistalsis Syndrome",
    "Progressive Spastic Ataxia and Hypomyelination",
    "Lethal Infantile Epileptic Encephalopathy",
    "Weaver-like overgrowth syndrome",
    "Intellectual disability and epilepsy",
    "JOINT LAXITY, SHORT STATURE, AND MYOPIA",
    "CWC27-related retinitis pigmentosa, short stature, skeletal anomalies and intellectual disability with or without ectodermal features",
    "ARTHROGRYPOSIS MULTIPLEX CONGENITA",
    "Neurodevelopmental, Cardiac, and Renal Syndrome",
    "Intellectual Disability Syndrome Associated with Seizures and Dysmorphic Features",
    "Microcephaly, hearing loss, and dysmorphic features",
    "Muscular dystrophy, congenital, with cataracts and intellectual disability",
    "Autosomal-Recessive Intellectual Disability and Microcephaly",
    "Infantile Epilepsy, Cataracts, and Profound Developmental Delay",
    "Mosaic Variegated Aneuploidy and Wilms Tumour",
    "Midline-bridging neuronal commissure disruption, horizontal gaze palsy, scoliosis, and intellectual disability",
    "Congenital heart defects and skeletal malformations",
    "Developmental delay and distinctive facial features",
    "3MC",
    "DHRS3 related craniosynostosis",
    "Peroxisome biogenesis disorder 14B",
    "Posteriorly predominant pachygyria and severe microcephaly",
    "Hartsfield syndrome",
    "CDK10-related severe growth retardation, spine malformations, and developmental delays",
    "Non-degenerative Pontocerebellar Hypoplasia",
    "RAC1-related neurodevelopmental disorder",
    "Unspecified Neurodevelopmental Disorder",
    "Developmental and Speech Delay, Postnatal Microcephaly, and Dysmorphic Features",
    "Severe Neurodevelopmental Disease with Seizures",
    "Severe Neonatal-, Childhood-, or Later-Onset Cardiomyopathy Associated with Combined Respiratory-Chain Deficiencies",
    "Joubert Syndrome with Cranio-facial and Skeletal Defects",
    "Epilepsy and intellectual disability",
    "Neurodevelopmental Disorder",
    "Gorlin-Chaudhry-Moss syndrome (GCMS);  Syndrome with Hypertrichosis, Progeroid Appearance, and Mitochondrial Dysfunction",
    "Spondylometaphyseal Dysplasia with Corner Fractures",
    "Developmental Delay, Epilepsy, Cerebellar Atrophy, and Osteopenia",
    "Nephrotic syndrome with primary microcephaly",
    "Dienoyl-CoA reductase deficiency with hyperlysinemia",
    "Warburg micro syndrome 4",
    "Uridine-responsive epileptic encephalopathy",
    "SMC1A-related Epileptic Encephalopathy",
    "Syndromic neutropenia with Shwachman-Diamond-like features",
    "Diamond-Blackfan anemia with cleft palate and abnormal thumbs",
    "EDAR-related hypohidrotic ectodermal dysplasia",
    "IMAGe Syndrome",
    "Developmental epileptic encephalopathy",
    "SETD2-associated Overgrowth Syndrome (Luscan-Lumish syndrome)",
    "MSI1-associated Microcephaly",
    "Autism, intellectual disability, basal ganglia dysfunction and epilepsy",
    "Intellectual disability, encephalopathy, impaired GPI-anchor maturation ",
    "Coffin Siris like disorder",
    "Macrocephaly and impaired speech and language",
    "Intellectual disability with facial dysmorphism",
    "H3-3A-related Bryant-Li-Bhoj neurodevelopmental syndrome",
    "NOVA2-associated neurodevelopmental disorder",
    "15q13.3 deletions phenocopy",
    "Stickler syndrome",
    "Disordered cortical neuronal migration",
    "Severe early-onset encephalopathy with progressive microcephaly,",
    "Severe early-onset encephalopathy with progressive microcephaly",
    "STAG2-related developmental delay with microcephaly and congenital anomalies",
    "Brown-Vialetto-Van Laere syndrome 2",
    "SNT1-related cerebroretinal microangiopathy with calcifications and cysts",
    "Recessive gain of function causing increased interferon signalling",
    "Pierpont syndrome",
    "EPT1-related complex progressive hereditary spastic paraplegia",
    "Tetra-amelia with lung agenesis",
    "Non-syndromic craniosynostosis",
    "PRRX1-related craniosynostosis",
    "Capillary malformation-arteriovenous malformation 2",
    "Bladder exstrophy plus",
    "Hirschprung disease with intestinal pseudo-obstruction",
    "Megacystis-microcolon-intestinal hypoperistalsis syndrome",
    "Stromme syndrome",
    "KMT2E-related neurodevelopmental disorder/O'Donnell-Luria-Rodan syndrome",
    "Microcephalic primordial dwarfism",
    "Chondrodysplasia with multiple dislocations and amelogenesis imperfecta",
    "KLHL7-related PERCHING syndrome (developmental delay, dysmorphism, feeding and respiratory difficulties, hypotonia, and joint contractures)",
    "KCNK4-related facial dysmorphism, hypertrichosis, epilepsy, intellectual and developmental delay, and gingival overgrowth syndrome",
    "Primary microcephaly, cortical malformation and epileptic encephalopathy",
    "Neurodevelopment disorder",
    "Noonan syndrome",
    "Fontaine progeroid syndrome",
    "IMAGe Syndrome with variable immunodeficiency",
    "Epileptic Encephalopathy with Contractures, Macrocephaly, and Dyskinesia",
    "Mucociliary Clearance and Laterality Defects",
    "MIRAGE - myelodysplasia, infection, restriction of growth, adrenal hypoplasia, genital phenotypes, enteropathy",
    "Neurodegenerative disorder exacerbated by febrile illnesses",
    "Cornelia de Lange Syndrome HDAC8 X-linked dominant",
    "RPS6KA3-related Coffin-Lowry syndrome",
    "AGNATHIA-OTOCEPHALY COMPLEX biallelic",
    "EPILEPTIC ENCEPHALOPATHY Gain-of-function",
    "PHACTR1-associated neurodevelopment disorder",
    "Neurometabolic disorder due to FARS2 deficiency",
    "Cantu syndrome",
    "Developmental and Epileptic Encephalopathy",
    "Congenital Disorder of Glycosylation with Defective Fucosylation",
    "Mutations in ATP6V1E1 or ATP6V1A Cause Autosomal Recessive Cutis Laxa",
    "Autosomal Recessive Cutis Laxa",
    "Neuro immuno skeletal Dysplasia Syndrome",
    "Autosomal Recessive Complicated Spastic Paraparesis SPG23",
    "ATP5F1D metabolic disorder",
    "Hypomyelinating Leukodystrophy",
    "Sensorineural Hearing Loss Hypoglycemia and Multiple OXPHOS Complex Deficiencies",
    "Neurodegeneration in Early Childhood",
    "Cerebellar Atrophy with Spinal Motor Neuronopathy",
    "Severe obesity with neurobehavioral features",
    "Pontocerebellar hypoplasia type 2D",
    "Progressive cerebella-cerebral atrophy type 2",
    "Infantile ataxia with oculomotor and pyramidal signs",
    "SCA14",
    "Intellectual disability and iris abnormalities",
    "Transient Neonatal Hyperparathyroidism",
    "Recessive Spondylocarpotarsal Synostosis Syndrome",
    "Defect in Cholesterol Biosynthesis",
    "Intellectual Disability with Seizures",
    "Developmental Delay Congenital Anomalies and Dysmorphic Features",
    "Enhanced Growth and Connective Tissue Abnormalities",
    "LNPK-associated neurodevelopmental disorder",
    "Bloom Syndrome like Disorder",
    "Variable Neurodevelopmental Disorder",
    "Neurological Phenotypes",
    "Syndromic Neurodevelopmental Disorder with Distinctive Facial Dysmorphism",
    "Early Onset Isolated Mitochondrial Complex I Deficiency",
    "Neurological Syndrome Fetal Akinesia /Epileptic Encephalopathy",
    "Saul Wilson Syndrome",
    "Woolly Hair Liver Dysfunction Dysmorphic Features and Global Developmental Delay",
    "Renal Hypomagnesemia Refractory Seizures and Intellectual Disability",
    "Neurodegeneration with Developmental Delay Ataxia and Axonal Neuropathy",
    "MACROCEPHALY, ACQUIRED, WITH IMPAIRED INTELLECTUAL DEVELOPMENT",
    "Autosomal Recessive Wiedemann Rautenstrauch Syndrome",
    "Motile Cilia Defects and Situs Inversus",
    "Defects in Neuronal Migration and Axon Guidance",
    "Intellectual Disability with Speech Delay Microcephaly Short Stature and Aggressive Behavior",
    "Neurodevelopmental Delay Congenital Heart Defects and Distinct Facial Dysmorphism",
    "Nephronophthisis Related Ciliopathy",
    "Syndromic Intellectual Disability and Developmental Delay",
    "Severe Neurodevelopmental Syndrome",
    "Congenital Microcephaly Epileptic Encephalopathy Blindness and Failure to Thrive",
    "Syndromic Intellectual Disability Resembling Other PP2A Related Neurodevelopmental Disorders",
    "Syndromic Neurodevelopmental Disorder",
    "Intellectual Disability with Variable Brain Anomalies",
    "Impaired Cilia Orientation and Mucociliary Clearance",
    "Neurodevelopmental Disease Associated with Mild Dysmorphism",
    "Neurodevelopmental Disorder of Hypusination",
    "Microcephaly Developmental Delay and Brittle Hair and Nails",
    "Autism and Syndromic Intellectual Disability",
    "congenital hypotonia, epilepsy, developmental delay, digit abnormalities",
    "MED13 - Neurodevelopment disorder",
    "NBEA Neurodevelopment disorder with seizures",
    "Au-Kline Syndrome",
    "DIETS-JONGMANS SYNDROME",
    "EIF3F related developmental disorder",
    "MN1 C-terminal truncation syndrome ",
    "SETD1B associated intellectual disability, epilepsy and autism",
    "Cerebrotendinous xanthomatosis",
    "ANAPC1-related Rothmund-Thomson syndrome",
    "Congenital megabladder",
    "Inherited GPI Biosynthesis Defect with an Axonal Neuropathy and Metabolic Abnormality",
    "Intellectual Disability and Central Nervous System anomalies",
    "Intellectual Disability, Central Nervous System anomalies and Seizures",
    "Intellectual Disability, Central Nervous System anomalies and Scoliosis",
    "Non-photosensitive trichothiodystrophy",
    "Acute Febrile Encephalopathy",
    "Infantile-Onset Recurrent Acute Liver Failure and Skeletal Abnormalities",
    "NEURODEVELOPMENTAL DISORDER WITH MICROCEPHALY AND STRUCTURAL BRAIN ANOMALIES",
    "BRAIN ABNORMALITIES, NEURODEGENERATION, AND DYSOSTEOSCLEROSIS",
    "KEIPERT SYNDROME",
    "NEURODEVELOPMENTAL DISORDER WITH SEIZURES AND NONEPILEPTIC HYPERKINETIC MOVEMENTS",
    "HOLOPROSENCEPHALY 12 WITH OR WITHOUT PANCREATIC AGENESIS",
    "VAN ESCH-O'DRISCOLL SYNDROME",
    "Congenital Lower Urinary Tract Obstruction",
    "EPILEPTIC ENCEPHALOPATHY, EARLY INFANTILE",
    "INTELLECTUAL DEVELOPMENTAL DISORDER WITH SEVERE SPEECH AND AMBULATION DEFECTS",
    "Nuclear Envelopathy with Early Progeroid Appearance",
    "Ciliopathy-related syndromic intellectual disability",
    "MULTIPLE JOINT DISLOCATIONS, SHORT STATURE, AND CRANIOFACIAL DYSMORPHISM WITH OR WITHOUT CONGENITAL HEART DEFECTS",
    "Bicuspid Aortic Valve and Aortic Aneurysm",
    "Malate-Aspartate Shuttle-Related Encephalopathy",
    "DLL1-related neurodevelopmental disorder with nonspecific brain abnormalities, with or without seizures",
    "EPISODIC PAIN SYNDROME, FAMILIAL",
    "HENNEKAM LYMPHANGIECTASIA-LYMPHEDEMA SYNDROME 2",
    "ACUTE LIVER FAILURE (ALF) IN INFANCY AND CHILDHOOD; SHORT STATURE, OPTIC NERVE ATROPHY, AND PELGER-HUET ANOMALY",
    "VAN MALDERGEM SYNDROME",
    "Primary Microcephaly or macrocephaly with developmental delay",
    "Pulmonary artery and lung hypoplasia, agonadism, omphalocele, diaphragmatic defects, hypoplastic left heart and scimitar syndrome",
    "LINGO1 related intellectual disability with microcephaly, speech and motor delay",
    "Cerebello-Oculo-Facio-Genital syndrome",
    "KCNA4-related abnormal striatum, congenital cataract and intellectual disability",
    "Developmental and infantile epileptic encephalopathy",
    "Severe microcephaly and short stature",
    "Multiple malformations of neural tube, ear, genitourinary and gastrointestinal systems",
    "Developmental Disorder with Microcephaly and Congenital Arthrogryposis",
    "Lissencephaly, Subcortical Heterotopia, and Global Developmental Delay",
    "Syndromic Neurodevelopmental Disorder with Corpus Collosum, Axon, Cardiac, Ocular, and Genital Defects",
    "LEUKODYSTROPHY, HYPOMYELINATING, 18",
    "NEURODEVELOPMENTAL DISORDER WITH OR WITHOUT SEIZURES AND GAIT ABNORMALITIES",
    "GALLOWAY-MOWAT SYNDROME 8",
    "NUP107-related steroid resistant nephrotic syndrome with microcephaly, developmental delay and simplified gyration (Galloway-Mowat syndrome)",
    "GALLOWAY-MOWAT SYNDROME 4",
    "GALLOWAY-MOWAT SYNDROME 6",
    "GALLOWAY-MOWAT SYNDROME 5",
    "GALLOWAY-MOWAT SYNDROME 2",
    "MITOCHONDRIAL SHORT-CHAIN ENOYL-CoA HYDRATASE 1 DEFICIENCY",
    "Desbuquois dysplasia 1",
    "GELEOPHYSIC DYSPLASIA 1",
    "NCOR1-related developmental disorder",
    "Marfanoid Habitus and Cognitive Impairment",
    "Transient Hypomyelination during Infancy",
    "Intellectual Disability, Developmental Delay, and Short Stature",
    "Motile Ciliopathy with Hydrocephalus and Randomization of Left/Right Body Asymmetry",
    "MEDNIK-like Syndrome",
    "Spondyloepimetaphyseal Dysplasia with Severe Short Stature",
    "Microcephaly and Lissencephaly Spectrum Disorders",
    "Developmental delay, hypotonia, and autistic features",
    "TASP1-related neurodevelopmental disorder",
    "MICROCEPHALY, FACIAL DYSMORPHISM, RENAL AGENESIS, AND AMBIGUOUS GENITALIA SYNDROME",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-LINKED 102",
    "QUESTION MARK EARS, ISOLATED",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-LINKED 99; MRX99",
    "AICARDI-GOUTIERES SYNDROME ASSOCIATED WITH A TYPE I INTERFERON SIGNATURE",
    "CATARACT 17, MULTIPLE TYPES",
    "Global Developmental Delay, Hypotonia, Scoliosis, and Cerebellar Atrophy",
    "INSULIN-LIKE GROWTH FACTOR I, RESISTANCE TO",
    "MAB21L2-related syndromic microphthalmia",
    "ARTHROGRYPOSIS MULTIPLEX CONGENITA AND INTELLECTUAL DISABILITY",
    "AGO1-related developmental disorder (monoallelic)",
    "DNM1L-related developmental disorder (monoallelic)",
    "BCL11B-related neurodevelopmental disorder",
    "CSNK2B-related developmental disorder (monoallelic)",
    "CTBP1-related developmental disorder (monoallelic)",
    "KCND3-related developmental disorder (monoallelic)",
    "HK1-related developmental disorder (monoallelic)",
    "SPAST-related developmental disorder (monoallelic)",
    "MEIS2-related developmental disorder (monoallelic)",
    "NR4A2-related developmental disorder (monoallelic)",
    "NSD2-related developmental disorder (monoallelic)",
    "OGT-related developmental disorder (hemizygous)",
    "OGT-related developmental disorder (X-linked dominant)",
    "PBX1-related developmental disorder (monoallelic)",
    "PRPF8-related developmental disorder (monoallelic)",
    "AP2S1-related developmental disorder (monoallelic)",
    "SYNCRIP-related developmental disorder (monoallelic)",
    "TCF7L2-related developmental disorder (monoallelic)",
    "VCP-related developmental disorder (monoallelic)",
    "ZNF292-related developmental disorder (monoallelic)",
    "DDX23-related developmental disorder (monoallelic)",
    "ARHGAP35-related developmental disorder (monoallelic)",
    "DPYSL5-related developmental disorder (monoallelic)",
    "FBXW7-related developmental disorder (monoallelic)",
    "GNB2-related developmental disorder (monoallelic)",
    "EEF2-related developmental disorder (monoallelic)",
    "MAST1-related developmental disorder (monoallelic)",
    "GIGYF1-related developmental disorder (monoallelic)",
    "RAB14-related developmental disorder (monoallelic)",
    "GRIA2-related developmental disorder (monoallelic)",
    "HIST1H2AC-related developmental disorder (monoallelic)",
    "HNRNPD-related developmental disorder (monoallelic)",
    "U2AF2-related neurodevelopmental disorder",
    "ADCY5-related developmental disorder (monoallelic)",
    "MIB1-related developmental disorder (monoallelic)",
    "MSL2-related developmental disorder (monoallelic)",
    "ODC1-related neurodevelopmental disorder",
    "PCBP2-related developmental disorder (monoallelic)",
    "ATP6V0A1-related developmental disorder (monoallelic)",
    "KCNK3-associated developmental delay with sleep apnea ",
    "SATB1-related developmental disorder (monoallelic)",
    "SPEN-related developmental disorder (monoallelic)",
    "SPTBN1-related developmental disorder (monoallelic)",
    "SRRM2-related developmental disorder (monoallelic)",
    "SRSF1-related developmental disorder (monoallelic)",
    "PSMC5-related developmental disorder (monoallelic)",
    "TRPM3-related developmental disorder (monoallelic)",
    "UPF1-related developmental disorder (monoallelic)",
    "ZFHX3-related neurodevelopmental disorder",
    "ZFHX4-related developmental disorder (monoallelic)",
    "ZMYM2-related developmental disorder (monoallelic)",
    "ZNF148-related neurodevelopmental disorder",
    "ARHGEF9-related developmental disorder (X-linked dominant)",
    "CACNA1G-related developmental disorder (monoallelic)",
    "CUL3-related developmental disorder (monoallelic)",
    "KDM6B-related developmental disorder (monoallelic)",
    "USP7-related developmental disorder (monoallelic)",
    "Autosomal-Recessive Neurological Disease with Cerebellar Atrophy and Lysosomal Dysfunction",
    "CHRNA3-related congenital anomalies of the kidney and urinary tract",
    "Posterior Amelia with Pelvic and Pulmonary Hypoplasia",
    "Intellectual Disability with or without Epileptic Encephalopathy, activating",
    "GRID2-related cerebellar ataxia, biallelic",
    "GRID2-related cerebellar ataxia, monoallelic",
    "NDNF-related Congenital Hypogonadotrophic Hypogonadism",
    "NDUFAF8-related Leigh Syndrome",
    "PPP1R12A-related Holoprosencephaly Spectrum and Urogenital Malformations",
    "NADSYN1-related Congenital NAD Deficiency Disorder",
    "Steel Syndrome",
    "Shukla-Vernon Syndrome",
    "ANK2-related neurodevelopmental disorder",
    "Mitochondrial Complex III Deficiency, Cardiomyopathy, and Alopecia Totalis",
    "Endosteal Hyperostosis and Oligodontia",
    "UGP2 Epileptic Encephalopathy",
    "TTC12-related Primary Ciliary Dyskinesia",
    "TET3 DNA Demethylation Disorder biallelic",
    "TET3 DNA Demethylation Disorder monoallelic",
    "RALGAPA1-related neurodevelopmental disorder",
    "TKFC-related Cataracts and Multisystem Disease",
    "CDC42BPB-related Neurodevelopmental Disorder",
    "CDC42-related Neurodevelopmental Disorder",
    "RALA-related Neurodevelopmental Syndrome",
    "SLC5A6-related Neurodevelopmental Disorder",
    "SPOP-related Neurodevelopmental Disorder, gain of function",
    "SPOP-related Neurodevelopmental Disorder, dominant negative",
    "METTL23-related Intellectual Disability",
    "RARS1 related hypomyelinating leukodystrophy",
    "TMEM106B related hypomyelinating leukodystrophy",
    "POLR1C-related Leukodystrophy",
    "SLC25A1-related Neurometabolic Disorder",
    "ADARB1-associated Microcephaly, Intellectual Disability, and Seizures",
    "PIGK-associated Neurodevelopmental Syndrome",
    "NRROS-related Infantile-Onset Neurodegeneration with Intracranial Calcification",
    "EIF2AK1-associated Neurodevelopmental Syndrome",
    "EIF2AK2-associated Developmental Delay, Leukoencephalopathy, and Neurologic Decompensation",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL RECESSIVE 70",
    "OCLN-associated Band-like Calcification with Simplified Gyration and Polymicrogyria",
    "KATNB1- associated COMPLEX CEREBRAL MALFORMATIONS",
    "GLYCOSYLPHOSPHATIDYLINOSITOL BIOSYNTHESIS DEFECT 17",
    "MYOPATHY, LACTIC ACIDOSIS, AND SIDEROBLASTIC ANEMIA 1",
    "MYOPATHY, LACTIC ACIDOSIS, AND SIDEROBLASTIC ANEMIA 2",
    "CCDC32-associated neurodevelopmental syndrome",
    "KMT2D multiple malformations disorder",
    "Basel-Vanagaite-Smirin-Yosef Syndrome",
    "ARNT2-associated hypopituitarism, post-natal microcephaly, visual and renal anomalies",
    "SIAH1-associated neurodevelopmental disorder",
    "TTC5-associated neurodevelopmental disorder",
    "CDK19-associated Intellectual Disability and Epileptic Encephalopathy",
    "CONGENITAL DISORDER OF GLYCOSYLATION, TYPE IId",
    "Giant axonal neuropathy 1",
    "MAU2 neurodevelopmental disorder",
    "JABERI-ELAHI SYNDROME",
    "TRIM8-related neurodevelopmental disorder",
    "SMO-related developmental disorder",
    "SOX6-related neurodevelopmental syndrome",
    "RIMS2 Syndromic Congenital Cone-Rod Synaptic Disease",
    "KIF3B-related ciliopathy",
    "HNRNPH1-related neurodevelopmental disorder",
    "MYOPATHY, CONGENITAL, WITH FAST-TWITCH (TYPE II) FIBER ATROPHY",
    "NEUROPATHY, CONGENITAL HYPOMYELINATING, 2",
    "ABAT-related GABA-transaminase Deficiency",
    "PERIVENTRICULAR NODULAR HETEROTOPIA 8",
    "EPILEPTIC ENCEPHALOPATHY, INFANTILE OR EARLY CHILDHOOD, 3",
    "INTELLECTUAL DEVELOPMENTAL DISORDER 59",
    "HYPOPARATHYROIDISM, SENSORINEURAL DEAFNESS, AND RENAL DISEASE",
    "KLF7-related developmental disorder",
    "NOONAN SYNDROME 10",
    "NEURODEGENERATION, CHILDHOOD-ONSET, WITH CEREBELLAR ATROPHY",
    "GLOBAL DEVELOPMENTAL DELAY WITH OR WITHOUT IMPAIRED INTELLECTUAL DEVELOPMENT",
    "ECM1-related lipoid proteinosis",
    "CUTIS LAXA, AUTOSOMAL RECESSIVE, TYPE IB",
    "EIF2B4-RELATED LEUKOENCEPHALOPATHY WITH VANISHING WHITE MATTER",
    "EIF2B5-RELATED LEUKOENCEPHALOPATHY WITH VANISHING WHITE MATTER",
    "DIARRHEA 5, WITH TUFTING ENTEROPATHY, CONGENITAL",
    "NEURODEVELOPMENTAL DISORDER WITH MICROCEPHALY, CATARACTS, AND RENAL ABNORMALITIES",
    "MACROCEPHALY, DYSMORPHIC FACIES, AND PSYCHOMOTOR RETARDATION",
    "NEMALINE MYOPATHY 10",
    "ENCEPHALOPATHY DUE TO DEFECTIVE MITOCHONDRIAL AND PEROXISOMAL FISSION 2",
    "NOONAN SYNDROME 11",
    "MYBPC1-related arthrogryposis and myopathy",
    "LETHAL CONGENITAL CONTRACTURE SYNDROME 4",
    "KLIPPEL-FEIL SYNDROME 4, AUTOSOMAL RECESSIVE, WITH NEMALINE MYOPATHY AND FACIAL DYSMORPHISM",
    "DIENCEPHALIC-MESENCEPHALIC JUNCTION DYSPLASIA SYNDROME 1",
    "JOUBERT SYNDROME 33",
    "PNPLA6-related Disorder",
    "NEUROLOGIC, ENDOCRINE, AND PANCREATIC DISEASE, MULTISYSTEM, INFANTILE-ONSET",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, X-LINKED, SYNDROMIC, 35",
    "DIAMOND-BLACKFAN ANEMIA 11",
    "DIAMOND-BLACKFAN ANEMIA 10",
    "SELENON-related myopathy",
    "NEURODEVELOPMENTAL DISORDER WITH HYPOTONIA, NEUROPATHY, AND DEAFNESS",
    "INTELLECTUAL DEVELOPMENTAL DISORDER, AUTOSOMAL RECESSIVE 68",
    "WOLFRAM SYNDROME 1",
    "Wolfram-like syndrome, autosomal dominant",
    "ZNF142-related neurodevelopmental disorder",
    "CNOT1-related neurodevelopmental disorder",
    "SUPT16H-related neurodevelopmental disorder",
    "KOSAKI OVERGROWTH SYNDROME",
    "TBC1D2B-related neurodevelopmental disorder",
    "TFE3-related intellectual disability with pigmentary mosaicism and coarse features",
    "DSP-related developmental disorder",
    "MFN2-related developmental disorder",
    "MMGT1-related developmental disorder",
    "PRKAR1B-related developmental disorder",
    "MIGRAINE, FAMILIAL HEMIPLEGIC, ATP1A2-related",
    "TANC2-related neurodevelopmental and psychiatric disorders",
    "CHD1-related neurodevelopment disorder",
    "RBFOX1-related neurodevelopmental disorder",
    "CNNM2-related neurodevelopmental disorder with hypomagnesemia",
    "CNNM2-related neurodevelopmental disorder with hypomagnesemia; autosomal recessive form",
    "CTNND2-related neurodevelopmental disorder",
    "FGF14-related episodic ataxia",
    "ZNF407-related Neurodevelopmental Disorder",
    "TOGARAM1-related ciliopathy",
    "MADD-related developmental disorder",
    "NARS1-related Neurodevelopmental Disorder",
    "NARS1-related Neurodevelopmental Disorder ",
    "MYLPF arthrogryposis (biallelic)",
    "MYLPF arthrogryposis (monoallelic)",
    "HPDL Neurodegenerative Disease",
    "Renal hypodysplasia/aplasia 3",
    "NDUFA8-related developmental disorder",
    "ZBTB7A-associated developmental disorder",
    "Intellectual developmental disorder, X-linked 108",
    "MAPK1-related Neurodevelopmental Disorder",
    "SCAF4-related Neurodevelopmental Disorder",
    "KAT5-related Neurodevelopmental Syndrome",
    "Asparagine synthetase deficiency",
    "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 12",
    "DLG5-associated developmental disorder (monoallelic)",
    "DLG5-associated developmental disorder (biallelic)",
    "PPP1R21-related neurodevelopmental disorder",
    "Neurodevelopmental disorder with epilepsy, spasticity, and brain atrophy",
    "SHMT2-related neurodevelopmental syndrome",
    "LMNB1-associated developmental disorder",
    "TNRC6B-related neurodevelopmental disorder",
    "SYT2-related congenital onset presynaptic myasthenic syndrome",
    "PPP1R13L-related dilated cardiomyopathy",
    "RAP1B-related developmental disorder",
    "PRIM1-related Primordial Dwarfism",
    "LMNB2-related Primary Microcephaly",
    "NUDT2-related Developmental Disorder",
    "JARID2-related Neurodevelopmental Disorder",
    "FOXP4-related Developmental Disorder",
    "ATP6V0C-related Developmental Disorder",
    "NAPB-related Neurodevelopmental Disorder",
    "NCKAP1-related Neurodevelopmental Disorder",
    "PRKACA-related Multiple Congenital Malformation Syndrome",
    "PRKACB-related Multiple Congenital Malformation Syndrome",
    "KDELR2-related Osteogenesis Imperfecta",
    "COX16-related Developmental Disorder",
    "KIDINS220-related Developmental Disorder, biallelic",
    "Hypotonia, hypoventilation, impaired intellectual development, dysautonomia, epilepsy, and eye abnormalities",
    "PPIL1-related Neurodegenerative Pontocerebellar Hypoplasia with Microcephaly",
    "CDC40-related Neurodegenerative Pontocerebellar Hypoplasia with Microcephaly",
    "MED12-related developmental disorder",
    "HS2ST1-related Developmental Disorder",
    "CLCN6-related Developmental Disorder",
    "UNC45B-associated Progressive Myopathy with Eccentric Cores",
    "BICRA-related Developmental Disorder",
    "CIMDAG Syndrome, monoallelic",
    "CIMDAG Syndrome, biallelic",
    "KDM4B-related Developmental Disorder",
    "SMG8-related Developmental Disorder",
    "FBXO28-related developmental and epileptic encephalopathy with profound intellectual disability",
    "PIDD1-related neurodevelopmental disorder",
    "HIRA-related neurodevelopmental disorder",
    "FGF13-related neurodevelopmental disorder (hemizygous)",
    "FGF13-related neurodevelopmental disorder (X-linked dominant)",
    "MED27-related neurodevelopmental disorder",
    "SCUBE3-related developmental disorder",
    "POLR3B-related neurodevelopmental disorder",
    "CELF2-related neurodevelopmental disorder",
    "TMEM251-related skeletal dysplasia",
    "Polyhydramnios, megalencephaly, and symptomatic epilepsy",
    "EIF5A-related craniofacial-neurodevelopmental disorder",
    "EMC10-related neurodevelopmental disorder",
    "BRF1-related cerebellofaciodental syndrome",
    "TPP2-related immune deficiency, autoimmune disease and intellectual disability",
    "PRDM15-related renal and neurodevelopmental disorder",
    "CHRNB1-related congenital myaesthenia, biallelic",
    "CHRNB1-related congenital myaesthenia, monoallelic",
    "SEMA3A-related skeletal dysplasia",
    "COPB1-related severe intellectual disability syndrome with cataracts and variable microcephaly",
    "MYSM1-related congenital bone marrow failure",
    "NFE2L2-related leukoencephalopathy, immune deficiency and hypohomocysteinaemia",
    "SARS2-related hyperuricemia, pulmonary hypertension, renal failure and alkalosis",
    "HACD1-related congenital myopathy",
    "NCDN-associated neurodevelopmental disorder with seizures (biallelic)",
    "NCDN-associated neurodevelopmental disorder with seizures (monoallelic)",
    "DDB1-associated neurodevelopmental syndrome",
    "ANO1-associated intestinal disease",
    "NDUFB7-associated lactic acidosis and hypertrophic cardiomyopathy",
    "UBE4A-associated neurodevelopmental disorder",
    "MAPKAPK5-associated syndrome with synpolydactyly",
    "CSDE1-associated intellectual disability and autism",
    "ANKRD17-associated neurodevelopmental disorder",
    "CHD5-associated neurodevelopmental disorder with intellectual disability, speech delay and epilepsy",
    "GEMIN5-associated neurodevelopmental disorder with cerebellar atrophy and motor dysfunction",
    "SLC25A42-associated metabolic crises, recurrent, with variable encephalomyopathic features and neurologic regression",
    "COPB2-associated developmental delay and microcephaly",
    "PLXNA1-associated neurodevelopmental disorder (biallelic)",
    "PLXNA1-associated neurodevelopmental disorder with seizures (monoallelic)",
    "MT-TL1-associated mitochondrial disorder",
    "TRAPPC10-associated intellectual disability",
    "PI4KA-associated polymicrogyria, perisylvian, with cerebellar hypoplasia and arthrogryposis",
    "GRIA1-related neurodevelopmental disorder",
    "TNNT3-associated congenital myopathy (biallelic)",
    "Retinitis pigmentosa and erythrocytic microcytosis",
    "TMEM240-associated spinocerebellar ataxia and intellectual disability",
    "STAC3-associated congenital myopathy and malignant hyperthermia",
    "SOS2 associated Noonan syndrome",
    "NDUFB3-associated mitochondrial complex I deficiency",
    "KIF5A-associated severe neonatal myoclonus",
    "GBE1-associated Glycogen storage disease IV",
    "COL6A2-related muscular dystrophy",
    "ARFGEF1-related intellectual disability and epilepsy",
    "JAG2-related muscular dystrophy",
    "SIN3B-related syndromic intellectual disability and autism spectrum disorder",
    "Glycogen storage disease Ib",
    "SLC37A4-related congenital disorder of glycosylation with liver dysfunction",
    "SRCAP-related Neurodevelopmental Disorder",
    "BCAS3-related neurodevelopmental disorder with thinning of corpus callosum and cerebellar atrophy",
    "LTBP1-related cutis laxa and craniosynostosis",
    "IPO8-related syndromic thoracic aortic aneurysm",
    "PGM2L1-related neurodevelopmental disorder",
    "HERC2-related neurodevelopmental disorder",
    "ALDH1A2-related diaphragmatic hernia and pulmonary hypoplasia",
    "POU4F1-related ataxia, intention tremor, and hypotonia syndrome",
    "NDUFA12-associated mtochondrial complex I deficiency",
    "THG1L-associated cerebellar ataxia",
    "RNPC3-associated growth hormone deficiency and short stature",
    "PDIA6-associated syndromic neonatal diabetes and asphyxiating thoracic dystrophy",
    "UFSP2-associated developmental delay and epilepsy",
    "IFT74-associated ciliopathy",
    "ACBD5 deficiency",
    "AFG3L2-related ataxia and seizures",
    "GLRA1-related hyperexplexia, monoallelic",
    "GLRA1-related hyperexplexia, biallelic",
    "GLRB-related hyperexplexia, monoallelic",
    "GLRB-related hyperexplexia, biallelic",
    "GPHN-related molybdenum cofactor deficiency",
    "KCNA1-related epileptic encephalopathy, biallelic",
    "KCNA1-related epileptic encephalopathy, monoallelic",
    "KCNMA1-related developmental delay, seizures and cerebellar atrophy",
    "PNPO-related neonatal encephalopathy responsive to pyridoxal-5'-phosphate",
    "OTOFACIOCERVICAL SYNDROME",
    "Stuve-Wiedeman syndrome",
    "Sulfite oxidase deficiency",
    "NAA20-associated developmental delay and microcephaly",
    "CEP85L-associated posterior-predominant lissencephaly",
    "NSRP1-associated developmental delay, epilepsy and microcephaly",
    "WDR11-associated intellectual disability and microcephaly",
    "NARS2-associated oxidative phosphorylation deficiency",
    "PUS3-associated neurodevelopmental disorder with microcephaly and gray sclerae",
    "ATG7-related intellectual disability and ataxia",
    "TP73-related ciliary dyskinesia and lissencephaly",
    "AP1G1-related intellectual disability, biallelic",
    "AP1G1-related intellectual disability and epilepsy, monoallelic",
    "EDEM3-related congenital disorder of glycosylation",
    "CLCN3-related Neurodevelopmental disorder with seizures and brain abnormalities",
    "CLCN3-related Neurodevelopmental disorder with hypotonia and brain abnormalities",
    "TNPO2-related intellectual disability",
    "GRIK2-related intellectual disability and hypomyelination",
    "COPB2-related developmental delay and osteopenia",
    "ZFYVE19-related congenital hepatic fibrosis, sclerosing cholangiopathy and high-GGT cholestasis",
    "TRAPPC2L-related Encephalopathy, progressive, early-onset, with episodic rhabdomyolysis",
    "RNU12-related CDAGS syndrome",
    "TMEM222-related Neurodevelopmental disorder with motor and speech delay and behavioral abnormalities",
    "ELFN1-related intellectual disability and epilepsy",
    "OGDH-related neurodevelopmental disorder",
    "RYR2-related Catecholaminergic polymorphic ventricular tachycardia and intellectual disability",
    "HDAC4-related intellectual disability",
    "3-methylglutaconic aciduria with deafness, encephalopathy, and Leigh-like syndrome",
    "YRDC-associated nephrotic syndrome and microcephaly",
    "SLC38A3-associated epileptic encephalopathy.",
    "GRIN1-associated Neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal recessive",
    "ONECUT1-associated neonatal diabetes",
    "WASHC5-associated intellectual disability, congenital cardiac malformation and Dandy-Walker malformation",
    "LONP1-associated congenital diaphragmatic hernia",
    "SPATA5L1-associated sensorineural hearing loss and intellectual disability",
    "ABHD16A-associated spastic paraplegia, intellectual disability and thin corpus callosum",
    "LMBRD2-associated intellectual disability",
    "CHRM1-associated intellectual disability",
    "HMGB1-related intellectual disability",
    "NHLRC2-related fibrosis, neurodegeneration, and cerebral angiomatosis",
    "RBBP8-related microcephaly and intellectual disability",
    "GDF11-related vertebral hypersegmentation, orofacial anomalies and neurodevelopmental disorder.",
    "ATP5F1A-related failure to thrive, hyperlactatemia and hyperammonemia",
    "ATP5F1A-related mitochondrial encephalopathy",
    "AKT2-related hypoinsulinemic hypoglycemia and hemihypertrophy",
    "RNF125-related intellectual disability and macrocephaly",
    "ALKBH8-related intellectual disability, microcephaly and seizures",
    "FZR1-related intellectual disability and epilepsy",
    "SUFU-related Joubert and congenital ocular motor apraxia",
    "SPRED2-related Noonan syndrome",
    "STT3A-related type I congenital disorder of glycosylation with neuromusculoskeletal disease",
    "PRORP-related mitochondrial disorder",
    "GOLGA2-related myopathy, seizures and microcephaly",
    "PCDHGC4-related neurodevelopmental disorder with microcephaly and seizures",
    "ACER3-related leukodystrophy",
    "HYAL2-related syndrome with cleft lip and palate and congenital cardiac anomalies",
    "DYNC2LI1-related short-rib polydactyly",
    "OGDHL-related neurodevelopmental disorder with seizures, hearing loss and gait ataxia",
    "SARS1-related neurodevelopmental disorder with microcephaly, ataxia, and seizures",
    "CDH11-related brachioskeletogenital syndrome",
    "SLIRP-related mitochondrial encephalomyopathy",
    "PRKG2-related acromesomelic dysplasia and spondylometaphyseal dysplasia",
    "ARPC4-related microcephaly and developmental delay",
    "CPSF3-associated neurodevelopmental disorder with seizures and microcephaly",
    "GNE-associated congenital myopathy",
    "GNE-associated sialuria",
    "MAN2C1-associated neurodevelopmental disorder with cerebral malformations",
    "BAP1-associated neurodevelopmental syndrome",
    "Nemaline/Cap myopathy",
    "THUMPD1 neurodevelopment disorder",
    "NRCAM neurodevelopmental disorder with dysmorphic features, hypotonia and spasticity",
    "RORB-epilepsy and neurodevelopmental disorder",
    "USP14-related syndromic neurodevelopmental disorder with arthrogryposis",
    "H3F3B associated neurodevelopmental disorder",
    "Mitochondrial complex I deficiency, nuclear type 7",
    "HPE-related disorder",
    "DNAH14-related Neurodevelopmental disorder",
    "MMP15-related developmental disorder",
    "DPH5-related neurodevelopmental disorder",
    "Early-onset oculopharyngeal muscular dystrophy",
    "PRDM13-related olivopentocerebellar hypoplasia syndrome",
    "ATP2B1-related neurodevelopmental disorder",
    "NAD deficiency disorder",
    "Osteootohepatoenteric syndrome",
    "CEROID LIPOFUSCINOSIS, NEURONAL, 10",
    "CEROID LIPOFUSCINOSIS, NEURONAL, 5",
    "CEROID LIPOFUSCINOSIS, NEURONAL, 1",
    "Microcornea, myopic chorioretinal atrophy, and telecanthus",
    "External Ophthalmoplegia, Rib, and Vertebral Anomalies",
    "BRUCK SYNDROME TYPE 1",
    "WNK3-related neurodevelopmental disorder",
    "PAN2-related neurodevelopmental disorder with multiple congenital anomalies",
    "PERIVENTRICULAR NODULAR HETEROTOPIA TYPE 1",
    "CLDN5-related neurodevelopmental disorder",
    "PPFIBP1-related neurodevelopmental disorder",
    "ATP9A-related neurodevelopmental disorder",
    "SLC32A1-associated developmental and epileptic encephalopathy",
    "TMEM63C-associated hereditary spastic paraplegia",
    "ADAM22-associated developmental and epileptic encephalopathy",
    "CHKA-related neurodevelopmental disorder",
    "DOHH-related neurodevelopmental disorder",
    "FRA10AC1-related neurodevelopmental disorder",
    "PSMC1-related neurodevelopmental disorder",
    "TMEM218-associated ciliopathy",
    "PRDX3-associated cerebellar ataxia",
    "TAF8-associated neurodevelopmental disorder",
    "MED11-associated neurodevelopmental disorder",
    "TAF4-related neurodevelopmental disorder",
    "UBAP2L-associated neurodevelopmental disorder",
    "GABBR1-associated neurodevelopmental disorder",
    "MTSS2-associated syndromic intellectual disability",
    "GABRG1-associated epileptic encephalopathy",
    "RRM1-related mitochondrial DNA depletion/deletions syndrome",
    "ZMYND8-related neurodevelopmental disorder",
    "TMEM163-related hypomyelinating leukodystrophy ",
    "GRM7-related neurodevelopmental disorder",
    "TMEM147-related developmental disorder",
    "PROSER1-related developmental disorder",
    "BUB1-related microcephaly and developmental disorder",
    "Waardenburg syndrome type 3",
    "IREB2-related neurodevelopmental disorder",
    "SEMA6B-related neurodevelopmental disorder ",
    "HECW2-associated neurodevelopmental disorder",
    "Distal hereditary motor neuropathy",
    "WARS1-associated neurodevelopmental syndrome",
    "SLC13A1-associated hypersulfaturia and hyposulfatemia",
    "MYCBP2-related developmental delay with corpus callosum defects",
    "EXOSC2-associated short stature, hearing loss, retinitis pigmentosa, and distinctive facies syndrome",
    "DNAJB4-related myopathy with early respiratory failure",
    "FOXI3-related microtia and craniofacial microsomia",
    "DAW1-associated ciliopathy",
    "SCNM1-associated orofaciodigital syndrome",
    "LETM1-related neurodevelopmental disorder",
    "FRMD5-related developmental disorder ",
    "SLC35B2-related chondrodysplasia with hypomyelinating leukodystrophy",
    "ATL1-associated hereditary spastic paraplegia",
    "TRPC5-related neurodevelopmental disorder",
    "NUP54-related early-onset dystonia with striatal lesions",
    "Developmental delay",
    "WDR5-related neurodevelopmental disorder",
    "TRA2B-associated neurodevelopmental syndrome",
    "CAMSAP1-associated neuronal migration disorder",
    "MAN2A2-related disorder of glycosylation",
    "Rabin-Pappas syndrome",
    "SLC30A7-associated Joubert syndrome",
    "BAZ2B-related neurodevelopmental disorder",
    "NAE1-associated neurodevelopmental disorder with intellectual disability, ischiopubic hypoplasia, stress-mediated lymphopenia and neurodegeneration",
    "ZMYM3-related neurodevelopmental disorder",
    "JMJD1C-related neurodevelopmental disorder",
    "ATG4D-related neurodevelopmental disorder",
    "AMOTL1-related orofacial clefting, cardiac anomalies, and tall stature",
    "HMGB1-related brachyphalangy, polydactyly and tibial aplasia syndrome",
    "ATP1A2-related epileptic encephalopathy",
    "Autosomal recessive ATP1A2-related neuronal migration disorder with epilepsy ",
    "Autosomal recessive GRIN2A-related neurodevelopmental disorder",
    "Autosomal dominant SARS1-related neurodevelopmental disorder",
    "FXR1-related congenital myopathy",
    "SPRY1-associated craniosynostosis with inner ear and renal anomalies",
    "GTF2IRD1-related neurodevelopmental disorder",
    "OTUD5-associated neurodevelopmental disorder",
    "KDM2B-related neurodevelopmental disorder",
    "SLC1A4-related Spastic tetraplegia, thin corpus callosum, and progressive microcephaly",
    "ARF3-related neurodevelopmental disorder",
    "SLF2-related developmental disorder",
    "SMC5-related developmental disorder",
    "FEM1C-related developmental disorder",
    "TCEAL1-related neurodevelopmental disorder ",
    "REST-related gingival fibromatosis and sensorineural hearing loss",
    "UHRF1-related immunodeficiency-centromeric instability-facial anomalies syndrome",
    "MPC2-related metabolic disorder",
    "CRLS1-related mitochondrial disorder ",
    "BSN-related epilepsy ",
    "CACNA2D1-related neurodevelopmental disorder ",
    "KIF5B-related disease",
    "PIGP-associated multiple congenital anomalies-hypotonia-seizures syndrome",
    "STX1A-associated neurodevelopmental disorder with epilepsy",
    "STX1A-associated neurodevelopmental disorder without epilepsy ",
    "PIP5K1C-associated neurodevelopmental disorder",
    "PLAG1-associated Silver Russell Syndrome",
    "LEF1-related ectodermal dysplasia and limb malformation",
    "Autosomal dominant EIF4A2-related neurodevelopmental disorder with hypotonia and epilepsy  ",
    "Autosomal recessive EIF4A2-related neurodevelopmental disorder ",
    "TTI1-related microcephaly, intellectual disability and ataxia",
    "YWHAE-related developmental delay, seizures, hypotonia and brain abnormalities",
    "GABRA2-related epileptic encephalopathy",
    "LMOD2-related infantile dilated cardiomyopathy",
    "TSPEAR-related ectodermal dysplasia and tooth agenesis",
    "RABGAP1-related neurodevelopmental disorder with microcephaly and sensorineural hearing loss",
    "FOSL2-related neurodevelopmental disorder with scalp and enamel defects",
    "SNAPC4-related neurodevelopmental disorder with motor regression, progressive spastic paraplegia, and oromotor dysfunction",
    "PABPC1-related developmental delay",
    "IER3IP1-related microcephaly with simplified gyral pattern, epilepsy, and neonatal diabetes",
    "CWF19L1-related developmental delay with epilepsy, progressive ataxia and cerebellar atrophy",
    "PHF5A-related neurodevelopmental disorder with congenital malformations",
    "KLHL20-related developmental disorder with seizures",
    "SLC18A2-related neurotransmitter disorder with dystonia and oculogyric crisis",
    "HECTD4-related neurodevelopmental disorder with seizures, hypotonia, spasticity, and agenesis of the corpus callosum",
    "UBE3C-related neurodevelopmental disorder with absent speech and movement and behavioural abnormalities",
    "MRTFB-related neurodevelopmental disorder",
    "ANGPT2-related non-immune hydrops fetalis",
    "WNT7B-related PDAC syndrome",
    "CBX1-related neurodevelopmental disorder",
    "PSMC3-related neurodevelopmental disorder",
    "ESAM-related neurodevelopmental disorder with intracranial hemorrhage, seizures, and spasticity",
    "MYH8-related Trismus-pseudocamptodactyly syndrome",
    "CNOT2-related neurodevelopmental disorder with hypotonia",
    "CNOT9-related developmental disorder with seizures",
    "FDXR-related optic atrophy-ataxia-peripheral neuropathy-global developmental delay syndrome",
    "FILIP1-related arthrogryposis multiplex congenita with microcephaly",
    "AMFR-related spastic paraplegia with/without neurodevelopmental delay",
    "DHX9-related neurodevelopmental disorder and Charcot-Marie-Tooth disease",
    "TBC1D32-related ciliopathy",
    "MTFMT-related mitochondrial disease with regression and lactic acidosis",
    "FIBP-related overgrowth syndrome with developmental delay (Thauvin-Robinet-Faivre syndrome)",
    "YWHAZ-related developmental delay with simplified gyral pattern",
    "PPM1K-related maple syrup urine disease",
    "CBFB-related cleidocranial dysplasia",
    "SART3-related neurodevelopmental disorder with 46,XY gonadal dysgenesis (INDYGON)",
    "ERI1-related severe growth restriction and skeletal dysplasia",
    "ERI1-related brachydactyly and mild neurodevelopmental delay",
    "ZNF808-related pancreatic agenesis",
    "RPH3A-related neurodevelopmental disorder",
    "TMEM63B-related developmental and epileptic encephalopathy with anaemia",
    "IKZF2-related ICHAD syndrome",
    "TDP2-related spinocerebellar ataxia with seizures and developmental delay",
    "EZH1-related neurodevelopmental disorder",
    "INTS1-related neurodevelopmental disorder with cataracts, hypotonia and gait abnormality",
    "TOR1A-associated arthrogryposis multiplex congenita (AR)",
    "HMGCR-related limb-girdle muscular dystrophy",
    "RAB34-related orofaciodigital syndrome",
    "PEX14-related autosomal dominant Zellweger spectrum disorder",
    "LSM11-related Aicardi-Goutieres syndrome",
    "CRELD1-related neurodevelopmental disorder with hypotonia and seizures",
    "AGPAT3-related intellectual disability and retinitis pigmentosa ",
    "DOT1L-related neurodevelopmental disorder with intracranial anomalies",
    "CTR9-related neurodevelopmental disorder",
    "PRPF19-related neurodevelopmental disorder",
    "RNU4-2 related neurodevelopmental disorder with microcephaly and seizures",
    "PPFIA3-related neurodevelopmental disorder",
    "CAMK2D-related neurodevelopmental disorder and dilated cardiomyopathy ",
    "PAX1-related oculo-auriculo-vertebral syndrome",
    "MAST3-related developmental and epileptic encephalopathy",
    "ACTC1-related distal arthrogryposis with congenital heart disease",
    "KCND2-related neurodevelopmental disorder with or without seizures",
    "KCNN2-related neurodevelopmental disorder with or without movement disorder",
    "ZBTB11-related neurodevelopmental disorder with or without cataracts and movement disorder",
    "DENND5B-related neurodevelopmental disorder with cortical migration and white matter abnormalities",
    "ZBTB47-related developmental delay, intellectual disability, hypotonia and seizures",
    "INTS11-related neurodevelopmental disorder with motor and language delay, ocular defects, and brain abnormalities",
    "MAP4K4-related neurodevelopmental disorder with/without congenital anomalies",
    "LHX2-related neurodevelopmental disorder with or without microcephaly ",
    "RNH1-related susceptibility to infection-related encephalopathy",
    "NALCN-related temporal lobe epilepsy",
    "RRAGC-related congenital dilated cardiomyopathy with hyperlactatemia, deranged liver function and cataracts ",
    "POLA1-related pigmentary disorder, reticulate, with systemic manifestations",
    "GTPBP1-related neurodevelopmental disorder with severe-profound intellectual disability, spasticity and ectodermal features.",
    "BORCS8-related early-infantile neurological disorder with severe intellectual disability, hypotonia and congenital heart disease",
    "FICD-related infancy-onset diabetes and neurodevelopmental disorder",
    "SLC12A9-related syndromic neurodevelopmental disorder with lysosome defects",
    "ZFX-related neurodevelopmental disorder with hypotonia, congenital anomalies and facial dysmorphism with or without hyperparathyroidism",
    "PLS3-related osteoporosis with fractures",
    "PLS3-related diaphragmatic hernia and body-wall defects",
    "ZSCAN10-related neurodevelopmental disorder with oto-facial malformations",
    "ZFTRAF1-related neurodevelopmental disorder",
    "SASS6-related severe microcephaly with brain abnormalities",
    "FEM1B-related neurodevelopmental disorder with or without brain abnormalities",
    "COX18-related peripheral neuropathy",
    "DLG2-related neurodevelopmental disorder",
    "SNF8-related disease spectrum (severe developmental and epileptic encephalopathy to syndromic optic atrophy)",
    "ANO3-related dystonia",
    "SLC4A10-related neurodevelopmental disorder with hypotonia and characteristic brain abnormalities",
    "SGSM3-related intellectual disability",
    "DIP2C-related developmental disorder with speech delay",
    "GABRD-related neurodevelopmental disorder with epilepsy",
    "PNPLA8-related progressive microcephaly with seizures and neurodegeneration",
    "EXOSC8-related pontocerebellar hypoplasia",
    "NPRL2-related familial focal epilepsy with or without focal cortical dysplasia",
    "NPRL3-related familial focal epilepsy with or without focal cortical dysplasia",
    "EPB41L3-related developmental disorder with delayed myelination and seizures",
    "JPH1-related congenital myopathy with ptosis",
    "AFF3-related intellectual disability",
    "Retinoschisis",
    "Retinitis pigmentosa",
    "EXUDATIVE VITREORETINOPATHY 1",
    "EXUDATIVE VITREORETINOPATHY 5",
    "EXUDATIVE VITREORETINOPATHY 2, X-LINKED",
    "EXUDATIVE VITREORETINOPATHY 6",
    "RETINITIS PIGMENTOSA 72",
    "Retinal dystrophy",
    "Sorsby fundus dystrophy",
    "Microphthalmia, isolated, with coloboma",
    "Cone-rod dystrophy",
    "Leber congenital amaurosis 1",
    "Granular corneal dystrophy, type I",
    "Reis-Bucklers corneal dystrophy",
    "Thiel-Behnke corneal dystrophy",
    "Granular corneal dystrophy, type II",
    "Cornea plana",
    "Fleck corneal dystrophy",
    "Schyder corneal dystrophy",
    "Macular corneal dystrophy",
    "Meesmann corneal dystrophy",
    "Optic atrophy",
    "Fibrosis of extraocular muscles, congenital, 1",
    "Fibrosis of extraocular muscles, congenital, 3B",
    "Fibrosis of extraocular muscles, congenital, 2",
    "Fibrosis of extraocular muscles, congenital, 3A",
    "Duane retraction syndrome 2",
    "PHARC",
    "ADAMTS10-related Weill-Marchesani syndrome",
    "Weill-Marchesani-like syndrome",
    "Ectopia lentis, isolated, autosomal recessive",
    "Usher syndrome, type 2C",
    "Usher syndrome, type IIC, GPR98/PDZD7 digenic",
    "Syndromic retinitis pigmentosa",
    "Peters-plus syndrome",
    "Wolfram syndrome",
    "Night blindness, congenital stationary, autosomal dominant 1",
    "RHO-related retinitis pigmentosa",
    "RETINITIS PIGMENTOSA-12, AUTOSOMAL RECESSIVE",
    "PIGMENTED PARAVENOUS CHORIORETINAL ATROPHY",
    "Syndromic congenital cataract",
    "Congenital cataract",
    "Cataract 6, multiple types",
    "CATARACT 9, MULTIPLE TYPES",
    "Cataract 16, multiple types",
    "Myopathy, myofibrillar, 2",
    "CATARACT 10, MULTIPLE TYPES",
    "CATARACT 23",
    "CATARACT 3, MULTIPLE TYPES",
    "CATARACT 22, MULTIPLE TYPES",
    "CATARACT 4, MULTIPLE TYPES",
    "Cataract 33, multiple types",
    "Cataract 15, multiple types",
    "Retinitis pigmentosa with or without situs inversus",
    "DOMINANT LATE-ONSET FUCHS CORNEAL DYSTROPHY",
    "Ocular albinism",
    "Leber congenital amaurosis 13",
    "Leber congenital amaurosis 3",
    "Retinitis pigmentosa 14",
    "Leber congenital amaurosis 16",
    "Snowflake vitreoretinal degeneration",
    "Wagner syndrome 1",
    "Enhanced S-cone syndrome",
    "Retinitis pigmentosa 37",
    "Retinitis pigmentosa 27",
    "Retinal degeneration, autosomal recessive, clumped pigment type",
    "Exudative vitreoretinopathy",
    "Non-syndromic hereditary optic neuropathy",
    "Persistent hyperplastic primary vitreous, autosomal recessive",
    "Familial exudative vitreoretinopathy",
    "Retinal dystrophy with or without extraocular anomalies",
    "Primary congenital glaucoma",
    "Juvenile open angle glaucoma",
    "primary open angle glaucoma (POAG), GLC1E",
    "Glaucoma 1A, primary open angle",
    "Foveal hypoplasia 2, with or without optic nerve misrouting and/or anterior segment dysgenesis",
    "LEBER HEREDITARY OPTIC NEUROPATHY",
    "Optic atrophy 3 with cataract",
    "3-methylglutaconic aciduria, type III",
    "Corneal dystrophy, posterior polymorphous, 3",
    "Usher syndrome, type 2D",
    "Cataract 31, multiple types",
    "Retinitis pigmentosa 26",
    "Nephronophthisis 15",
    "Retinitis pigmentosa 65",
    "Usher syndrome, type 1D",
    "Vitreoretinopathy, neovascular inflammatory",
    "Retinal cone dystrophy 4",
    "Aland Island eye disease",
    "Cone-rod synaptic disorder, congenital nonprogressive",
    "Orofaciodigital syndrome VI",
    "Retinal degeneration, late-onset, autosomal dominant",
    "Neurodegeneration with brain iron accumulation 4",
    "Albinism, oculocutaneous, type VII",
    "BLOC1S3-related Hermansky-Pudlak syndrome",
    "CATARACT 12, MULTIPLE TYPES",
    "Bestrophinopathy, autosomal recessive",
    "Macular dystrophy, vitelliform, 2",
    "Microcornea, rod-cone dystrophy, cataract, and posterior staphyloma",
    "Optic atrophy 9",
    "Spinocerebellar ataxia 7",
    "Achromatopsia 7",
    "Bardet-Biedl syndrome 18",
    "Retinitis pigmentosa 74",
    "Usher syndrome, type 3A",
    "Retinitis pigmentosa 61",
    "Ciliopathy syndrome",
    "Myotonic dystrophy type 2",
    "Retinitis pigmentosa type 49",
    "Achromatopsia 2",
    "Retinitis pigmentosa 45",
    "Achromatopsia 3",
    "Macular degeneration, juvenile",
    "Jalili syndrome",
    "MARSHALL SYNDROME",
    "COL7A1-related epidermolysis bullosa dystrophica",
    "Bietti crystalline corneoretinal dystrophy",
    "Retinitis pigmentosa 59",
    "Doyne honeycomb degeneration of retina",
    "Stargardt disease 3",
    "Aniridia 2",
    "Tangier disease",
    "PSEUDOXANTHOMA ELASTICUM",
    "BARAITSER-WINTER SYNDROME 1",
    "BARAITSER-WINTER SYNDROME 2",
    "Isolated ocular coloboma",
    "CUTIS LAXA, AUTOSOMAL RECESSIVE, TYPE IIIA",
    "Spastic paraplegia 9B, autosomal recessive",
    "SJOGREN-LARSSON SYNDROME",
    "Alpha-methylacyl-CoA racemase deficiency",
    "Hermansky-Pudlak syndrome ",
    "Joubert syndrome 8",
    "Cone-rod dystrophy and hearing loss",
    "Leukoencephalopathy with ataxia",
    "SPONDYLOMETAEPIPHYSEAL DYSPLASIA CONGENITA, STRUDWICK TYPE",
    "Corneal dystrophy, Fuchs endothelial, 1",
    "Cataract 42",
    "Cataract 39, multiple types, autosomal dominant",
    "Cataract 20, multiple types",
    "Macular dystrophy, butterfly-shaped pigmentary, 2",
    "Corneal dystrophy, congenital stromal",
    "Retinitis pigmentosa and hypogammaglobulinemia",
    "Cone-rod dystrophy 21",
    "DTNBP1-related Hermansky-Pudlak syndrome",
    "TRICHOTHIODYSTROPHY, PHOTOSENSITIVE",
    "Spastic paraplegia 35, autosomal recessive",
    "FBN1-related isolated ectopia lentis",
    "LARSEN SYNDROME",
    "MAC spectrum with limb anomalies",
    "Retinitis pigmentosa 30",
    "Cataract 13 with adult i phenotype",
    "Microphthalmia with coloboma 6",
    "Microphthalmia, isolated 7",
    "Microphthalmia",
    "PSEUDOXANTHOMA ELASTICUM-LIKE SKIN MANIFESTATIONS WITH EYE ANOMALIES",
    "GJB6-related ectodermal dysplasia, Clouston type",
    "Fabry disease",
    "Pseudohypoparathyroidism Ia",
    "PSEUDOPSEUDOHYPOPARATHYROIDISM",
    "Pseudohypoparathyroidism Ic",
    "Rod-cone dystrophy",
    "Night blindness, congenital stationary, autosomal dominant 3",
    "Night blindness, congenital stationary, type 1G",
    "Achromatopsia 4",
    "Non-syndromic retinitis pigmentosa",
    "Night blindness, congenital stationary (complete), 1E, autosomal recessive",
    "Oguchi disease-2",
    "Ceroid lipofuscinosis, neuronal, 11",
    "Amyloidosis, Finnish type",
    "Cone dystrophy-3",
    "Cone-rod dystrophy 14",
    "Macular dystrophy",
    "Retinitis pigmentosa 73",
    "Hermansky-Pudlak syndrome",
    "HPS4-related Hermansky-Pudlak syndrome",
    "HPS5-related Hermansky-Pudlak syndrome",
    "HPS6-related Hermansky-Pudlak syndrome",
    "Retinitis pigmentosa 46",
    "Bardet-Biedl syndrome 19",
    "Short-rib thoracic dysplasia 16 with or without polydactyly",
    "Retinitis pigmentosa 10",
    "Leber cogenital amaurosis 11",
    "Macular dystrophy, vitelliform, 4",
    "Retinitis pigmentosa 56",
    "Macular dystrophy, vitelliform, 5",
    "Retinal dystrophy with inner retinal dysfunction and ganglion cell abnormalities",
    "Retinal cone dystrophy 3B",
    "Retinitis pigmentosa 69",
    "Retinitis pigmentosa 42",
    "Leber congenital amaurosis 5",
    "Fish-eye disease",
    "Cataract 46, juvenile-onset",
    "Myopia, high, with cataract and vitreoretinal degeneration",
    "Cataract 19, multiple types",
    "Cataract 44",
    "Bardet-Biedl syndrome 17",
    "Ayme-Gripp syndrome",
    "Duane retraction syndrome 3",
    "Retinitis pigmentosa 62",
    "Macular dystrophy, patterned, 3",
    "Retinitis pigmentosa 38",
    "Hereditary motor and sensory neuropathy VIA",
    "Charcot-Marie-Tooth disease, axonal, type 2A2B",
    "NANOPHTHALMOS 2",
    "Retinal dystrophy and iris coloboma with or without cataract",
    "ABETALIPOPROTEINEMIA",
    "Hyper-IgD syndrome",
    "Mevalonic aciduria",
    "USHER SYNDROME TYPE 1B",
    "Short stature, optic nerve atrophy, and Pelger-Huet anomaly",
    "Retinitis pigmentosa 67",
    "NEUROFIBROMATOSIS, TYPE 2",
    "NOD2-related granulomatous synovitis with uveitis",
    "ALAGILLE SYNDROME 2",
    "JOUBERT SYNDROME TYPE 4",
    "SENIOR-LOKEN SYNDROME 4",
    "BOSCH-BOONSTRA OPTIC ATROPHY SYNDROME",
    "Gyrate atrophy of choroid and retina with or without ornithinemia",
    "OCA2-related oculocutaneous albinism",
    "Retinitis pigmentosa 23",
    "Blue cone monochromacy",
    "Corneal dystrophy, posterior polymorphous, 1",
    "HARP syndrome",
    "Usher syndrome, type 1F",
    "Retinitis pigmentosa 43",
    "Night blindness, congenital stationary, autosomal dominant 2",
    "Retinitis pigmentosa-40",
    "Cone dystrophy 4",
    "Familial Sturge-Weber syndrome",
    "Sturge-Weber syndrome",
    "Epithelial recurrent erosion dystrophy",
    "Corneal intraepithelial dyskeratosis",
    "Autoinflammation with arthritis and dyskeratosis",
    "Brittle cornea syndrome 2",
    "Axenfeld-Rieger syndrome",
    "PEROXISOME BIOGENESIS DISORDER 6B",
    "PEROXISOME BIOGENESIS DISORDER 3B",
    "PEROXISOME BIOGENESIS DISORDER 11B",
    "Peroxisome biogenesis disorder 13A",
    "PEROXISOME BIOGENESIS DISORDER 8B",
    "PEROXISOME BIOGENESIS DISORDER 5B",
    "PEROXISOME BIOGENESIS DISORDER 7B",
    "Peroxisome biogenesis disorder 10B",
    "PEROXISOME BIOGENESIS DISORDER 2B",
    "PEROXISOME BIOGENESIS DISORDER 4B",
    "RHIZOMELIC CHONDRODYSPLASIA PUNCTATA, TYPE 1",
    "REFSUM DISEASE",
    "Cone-rod dystrophy 5",
    "Anterior segment dysgenesis 4",
    "CATARACT 11, MULTIPLE TYPES",
    "Fleck retina, familial benign",
    "Boucher-Neuhauser syndrome",
    "Mitochondrial recessive ataxia syndrome",
    "Progressive external ophthalmoplegia, autosomal dominant 1",
    "Retinitis pigmentosa 36",
    "Retinitis pigmentosa 41",
    "Retinitis pigmentosa 18",
    "Retinitis pigmentosa 11",
    "Retinitis pigmentosa 70",
    "Retinitis pigmentosa 60",
    "Retinitis pigmentosa 13",
    "Glaucoma",
    "Retinitis pigmentosa 7",
    "ARTS SYNDROME",
    "Cone-rod dystrophy 18",
    "Cone-rod dystrophy 11",
    "Retinitis pigmentosa 66",
    "Retinal dystrophy, iris coloboma, and comedogenic acne syndrome",
    "Leber congenital amaurosis 12",
    "Retinal dystrophy, juvenile cataracts, and short stature syndrome",
    "Fundus albipunctatus",
    "WERNER SYNDROME",
    "ROTHMUND-THOMSON SYNDROME",
    "Retinitis pigmentosa 44",
    "Bradyopsia",
    "Cataract 41",
    "Neonatal/Infancy-Onset Diabetes, Congenital Sensorineural Deafness, and Congenital Cataracts Syndrome",
    "Craniofacial anomalies and anterior segment dysgenesis syndrome",
    "Keratoconus 1",
    "Microphthalmia, syndromic 11",
    "Usher syndrome, type 2A",
    "Usher syndrome, type 1G",
    "Usher syndrome, type 1C",
    "Cataract 43",
    "Retinal dystrophy and obesity",
    "Cone-rod dystrophy 19",
    "Hypogammaglobulinemia, short stature with microcephaly, cataract, and inner retinal dysfunction",
    "Aniridia 3",
    "Senior-Loken syndrome 9",
    "ADULT SYNDROME",
    "Retinitis pigmentosa 31",
    "NANOPHTHALMOS",
    "Joubert syndrome 20",
    "Joubert syndrome 16",
    "Sveinsson chorioretinal atrophy",
    "Corneal dystrophy, Fuchs endothelial, 3",
    "Cataract",
    "Corneal dystrophy, gelatinous drop-like",
    "Retinitis pigmentosa 33",
    "Retinitis pigmentosa 68",
    "CORNEAL DYSTROPHY, FUCHS ENDOTHELIAL, 4",
    "Albinism, oculocutaneous, type IV",
    "Myopia 24, autosomal dominant",
    "Neuropathy, hereditary motor and sensory, type VIB",
    "SLC24A1-related night blindness, congenital stationary ",
    "Cataract 47, juvenile, with microcornea",
    "MAC spectrum",
    "Cataract 45",
    "MARINESCO-SJOGREN SYNDROME",
    "Cone-rod dystrophy 7",
    "Bothnia retinal dystrophy",
    "Newfoundland rod-cone dystrophy",
    "Retinitis pigmentosa 1",
    "Occult macular dystrophy",
    "Cone dystrophy",
    "Retinitis pigmentosa 2",
    "Retinitis pigmentosa 9",
    "Retinitis pigmentosa 3",
    "Macular degeneration, X-linked atrophic",
    "Ribose 5-phosphate isomerase deficiency",
    "Ocular coloboma",
    "Oguchi disease-1",
    "Retinitis pigmentosa 47",
    "Charcot-Marie-Tooth disease, type 4B2",
    "MYOPIA 6",
    "Syndromic congenital glaucoma",
    "LHERMITTE-DUCLOS DISEASE",
    "Spastic paraplegia 7, autosomal recessive",
    "Pierson syndrome",
    "Nephrotic syndrome, type 5, with or without ocular abnormalities",
    "Brittle cornea syndrome 1",
    "ABRUZZO-ERICKSON SYNDROME",
    "Deafness and myopia",
    "Congenital glaucoma",
    "Multisystemic smooth muscle dysfunction syndrome",
    "Spondylometaphyseal dysplasia associated with corneal dystrophy and developmental delay (SMDCD)",
    "Optic atrophy 5",
    "Non-syndromic retinal degeneration",
    "Familial Dysautonomia",
    "Neuropathy, hereditary sensory and autonomic, type VI",
    "Brain small vessel disease with or without ocular anomalies",
    "Dihydropyrimidine dehydrogenase deficiency",
    "Central areolar choroidal dystrophy",
    "North Carolina macular dystrophy",
    "Neuropathy, Ataxia, Retinitis Pigmentosa syndrome ",
    "OPA1-related optic atrophy plus syndrome",
    "Behr syndrome",
    "Retinitis pigmentosa 35",
    "SOLITARY MEDIAN MAXILLARY CENTRAL INCISOR",
    "Lattice corneal dystrophy type 1",
    "Visual impairment and progressive phthisis bulbi",
    "Colobomatous microphthalmia",
    "Ocular coloboma, microphthalmia, and cataract",
    "Syndromic congenital sodium diarrhea",
    "USHER SYNDROME",
    "Focal Segmental Glomerulosclerosis with Duane Retraction Syndrome",
    "Posterior Polymorphous Corneal Dystrophy 4",
    "Alport syndrome x-linked",
    "COL5A1-related classical Ehlers Danlos syndrome",
    "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 9",
    "SCHWARTZ-JAMPEL SYNDROME",
    "Atypical Usher syndrome",
    "Developmental delays, cataracts, and craniofacial anomalies",
    "Myopia",
    "ROSAH syndrome",
    "MRCS syndrome",
    "High hyperopia ",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY CONGENITAL WITH BRAIN AND EYE ANOMALIES TYPE A4",
    "MUSCULAR DYSTROPHY-DYSTROGLYCANOPATHY CONGENITAL WITH INTELLECTUAL DEVELOPMENTAL DISORDER TYPE B3",
    "Leukoencephalopathy with vanishing white matter",
    "Cone dystrophy with supernormal rod responses",
    "Non-syndromic retinitis pigmenta",
    "Senior-Loken syndrome",
    "Autosomal dominant retinal dystrophy",
    "Congenital cataract (monoallelic, uncertain)",
    "Achromatopsia 3 (biallelic, activating)",
    "CRYBB3-related cataract",
    "SPONDYLOEPIPHYSEAL DYSPLASIA CONGENITA (biallelic, all missense/in frame)",
    "CATARACT 5, MULTIPLE TYPES (biallelic, uncertain)",
    "Duane retraction syndrome 3 (monoallelic, dominant negative)",
    "BFSP2-related cataract ",
    "Cerebellar atrophy, visual impairment, and psychomotor retardation (monoallelic, dominant negative)",
    "Cataract 33, multiple types (monoallelic, uncertain)",
    "Anauxetic Dysplasia",
    "DESMOID DISEASE, HEREDITARY",
    "LEOPARD SYNDROME TYPE 3",
    "NOONAN SYNDROME TYPE 7",
    "EHLERS-DANLOS SYNDROME, CLASSIC TYPE, COL1A1-RELATED",
    "COL1A1/2-RELATED OSTEOGENESIS IMPERFECTA",
    "EHLERS-DANLOS SYNDROME TYPE VIIA",
    "OSTEOGENESIS IMPERFECTA TYPE I",
    "OSTEOGENESIS IMPERFECTA TYPE IIA",
    "OSTEOGENESIS IMPERFECTA TYPE III",
    "EHLERS-DANLOS SYNDROME TYPE 4",
    "CREBBP intellectual disability without typical RTS features",
    "GJB2-related knuckle pads, leuconychia and sensorineural deafness",
    "DEAFNESS AUTOSOMAL RECESSIVE TYPE 1A",
    "ICHTHYOSIS HYSTRIX-LIKE WITH DEAFNESS SYNDROME",
    "PALMOPLANTAR KERATODERMA WITH DEAFNESS",
    "GJB2-related Vohwinkel syndrome",
    "DEAFNESS AUTOSOMAL RECESSIVE TYPE 1B",
    "HEART-HAND SYNDROME SLOVENIAN TYPE",
    "LETHAL TIGHT SKIN CONTRACTURE SYNDROME",
    "MUIR-TORRE SYNDROME",
    "CARNEY COMPLEX VARIANT",
    "RENAL AGENESIS",
    "CARCINOID TUMORS, INTESTINAL",
    "PANCREATIC CANCER",
    "ECTODERMAL DYSPLASIA RAPP-HODGKIN TYPE",
    "Acanthosis Nigricans and insulin resistance syndrome",
    "Acanthosis Nigricans and insulin resistance syndrome + hypertension",
    "Acrodermatitis enteropathica, zinc deficiency type",
    "Acrokeratosis verruciformis",
    "Adrenal hypoplasia, congenital",
    "Albinism (oculocutaneous type 4)",
    "Amyloidosis, familial visceral",
    "Angioneurotic oedema, hereditary, with normal C1 inhibitor concentration and function",
    "Autoimmune lymphoproliferative syndrome type IA",
    "Autoimmune lymphoproliferative syndrome type IIA",
    "Bare lymphocyte syndrome type 1",
    "Calcinosis, tumoral with hyperphosphataemia",
    "Carboxypeptidase N deficiency",
    "Cerebral autosomal dominant arteiopathy with subcortical infarcts and leukencephalopathy",
    "Cerebral cavernous malformation 2",
    "Chronic granulomatous disease X linked",
    "Chronic granulomatous disease AR cytochrome b negative",
    "Chronic granulomatous disease AR cytochrome b positive type I",
    "Chronic granulomatous disease AR cytochrome b positive type II",
    "Chronic neurologic cutaneous and articular syndrome (CINCA)",
    "Cold induced sweating syndrome",
    "Cold urticaria, familial",
    "Cutis gyrata Beare stevenson",
    "Cutis laxa type I autosomal recessive",
    "Cutis laxa X linked/Occipital Horn Syndrome",
    "Cutis laxa autosomal dominant 2",
    "Dowling-Degos disease",
    "Ectodermal dysplasia + skin fragility (McGrath syndrome)",
    "Ectodermal dysplasia, pure hair/nail type",
    "Classical Ehlers Danlos syndrome",
    "Classical-like Ehlers Danlos syndrome",
    "Dermatosparaxis Ehlers Danlos syndrome",
    "Ehlers Danlos, cardiac valvular form",
    "Epidermodysplasia verruciformis",
    "Erythromelalgia, primary",
    "Familial cold autoinflammatory syndrome",
    "Familial mediterranean fever",
    "Fanconi pancytopaenia H",
    "Glucocorticoid deficiency 2",
    "Glycogen storage disease I",
    "Gorlin syndrome",
    "Griscelli Type 2",
    "Griscelli Type 3",
    "Haemochromatosis type 1",
    "Haemochromatosis type 2B (juvenile)",
    "Haemochromatosis type 3",
    "Haemochromatosis type 4",
    "Hailey-Hailey disease",
    "Hereditary haemorrhagic telangiectasia",
    "Ichthyosis Bullosa of Siemens",
    "Kindler syndrome",
    "SIMPSON-GOLABI-BEHMEL SYNDROME TYPE 2",
    "Sitosterolemia",
    "Skin fragility, Woolly Hair",
    "Steatocystoma multiplex",
    "Transaldolase deficiency",
    "Trichorhinopharangeal syndrome II (Langer-Giedon)",
    "Vitamin E, familial isolated deficiency of",
    "Waardenburg syndrome type IID",
    "Waardenburg syndrome type IV",
    "Warts, hypogammaglobulinaemia, infections and myelokathexis syndrome",
    "White sponge naevus",
    "Wiskott-Aldrich syndrome",
    "Wrinkly skin syndrome",
    "Xeroderma pigmentosum group F",
    "Haemochromatosis type 2A (juvenile)",
    "Epidermolysis Bullosa (Bart Type)",
    "Melanoma-pancreatic cancer syndrome",
    "Kaposi sarcoma",
    "Keratosis follicularis spinulosa decalvans",
    "Laryngoonychocutaneous syndrome",
    "Leprechaunism",
    "Lipodystrophy, congenital generalised type 1",
    "Lipodystrophy, congenital generalised type 2",
    "Lipodystrophy, familial partial type 3",
    "Prader-Willi syndrome",
    "Psoriasis susceptibilty 2",
    "Epidermolysis Bullosa Simplex localised (Weber Cockayne)",
    "Epidermolysis Bullosa Simplex (Weber Cockayne)",
    "Epidermolysis Bullosa Simplex generalised intermediate (Köbner)",
    "Epidermolysis Bullosa Simplex generalised severe (Dowling - Meara)",
    "Epidermolysis Bullosa Simplex (Mottled pigmentation)",
    "Epidermolysis Bullosa Simplex (recessive)",
    "Epidermolysis Bullosa Simplex (Ogna)",
    "Epidermolysis Bullosa Junctional (lethal Herlitz)",
    "Haim-Munk syndrome",
    "Hartnup disease",
    "Monilethrix",
    "Myotonic dystrophy 2",
    "Naegeli syndrome",
    "Netherton syndrome",
    "Neuropathy, hereditary sensory and autonomic, type II",
    "Neuropathy, hereditary sensory and autonomic, type III",
    "Nijmegan breakage syndrome",
    "Omenn syndrome",
    "OSSEOUS HETEROPLASIA, PROGRESSIVE",
    "Osteogenesis imperfecta type IV",
    "Osteogenesis imperfecta congenita type II",
    "Hypercholesterolaemia, autosomal dominant",
    "Hypercholesterolaemia, autosomal dominant, type B",
    "Hypercholesterolaemia, autosomal recessive, 1",
    "Hyperlipoproteinaemia type 1",
    "Hyperlipoproteinaemia, type IB",
    "Hypertriglycidaemia, familial",
    "Hyper IgD syndrome",
    "Hypotrichosis, localised autosomal recessive",
    "Hypotrichosis-lymphoedema-telangiectasia syndrome",
    "Hypotrichosis simplex of the scalp",
    "Congenital ichthyosis type 1",
    "Congenital ichthyosis type 2",
    "Congenital ichthyosis type 3",
    "Ichthyosiform erythroderma, bullous",
    "Ichthyosis, congenital, autosomal recessive",
    "Ichthyosis, cyclic with epidermolytic hyperkeratosis",
    "Ichthyosis harlequin",
    "Ichthyosis hystrix, Curth-Macklin type",
    "Ichthyosis, leucocyte vacuoles, alopecia and sclerosing cholangitis",
    "Juvenile hyaline fibromatosis",
    "Pachyonychia congenita 1 Jadassohn-Lewandowsky",
    "Pachyonychia congenita 2 Jackson-Lawler",
    "PPK Vorner-Unna-Thost (non-epidermolytic)",
    "PPK Vorner-Unna-Thost (epidermolytic)",
    "PPK (striate)",
    "PPK (Bothnia)",
    "PPK Mal de Meleda (transgrediens)",
    "PPK Naxos (+ woolly hair + ECG abnormalities, NAXOS disease)",
    "PPK Vohwinkel+ichthyosis (variant)",
    "Peeling skin syndrome, acral type",
    "Periodic fever, familial, autosomal dominant",
    "Pheochromocytoma",
    "Piebaldism",
    "Pyogenic sterile arthritis, pyoderma gangrenosum and acne",
    "RAPP-HODGKIN SYNDROME",
    "Restrictive dermopathy, lethal",
    "Trichothiodystrophy, non photosensitive",
    "Epidermolysis Bullosa Junctional (atrophic benign)",
    "Epidermolysis Bullosa Junctional",
    "Epidermolysis Bullosa Pruriginosa",
    "Waardenburg syndrome type IV (biallelic, loss of function)",
    "Autoimmune lymphoproliferative syndrome type IA (biallelic, dominant negative)",
    "Autoimmune lymphoproliferative syndrome type IA (mosaic, dominant negative)",]